{
  "lang": [
    {
      "label": "English",
      "value": "en"
    },
    {
      "label": "Chinese",
      "value": "zh"
    },
    {
      "label": "Hindi",
      "value": "hi"
    },
    {
      "label": "Spanish",
      "value": "es"
    },
    {
      "label": "French",
      "value": "fr"
    },
    {
      "label": "Arabic",
      "value": "ar"
    },
    {
      "label": "Bengali (Bangla)",
      "value": "bn"
    },
    {
      "label": "Portuguese",
      "value": "pt"
    },
    {
      "label": "Russian",
      "value": "ru"
    },
    {
      "label": "Japanese",
      "value": "ja"
    },
    {
      "label": "Indonesian",
      "value": "id, in"
    },
    {
      "label": "Abkhazian",
      "value": "ab"
    },
    {
      "label": "Afar",
      "value": "aa"
    },
    {
      "label": "Afrikaans",
      "value": "af"
    },
    {
      "label": "Akan",
      "value": "ak"
    },
    {
      "label": "Albanian",
      "value": "sq"
    },
    {
      "label": "Amharic",
      "value": "am"
    },
    {
      "label": "Aragonese",
      "value": "an"
    },
    {
      "label": "Armenian",
      "value": "hy"
    },
    {
      "label": "Assamese",
      "value": "as"
    },
    {
      "label": "Avaric",
      "value": "av"
    },
    {
      "label": "Avestan",
      "value": "ae"
    },
    {
      "label": "Aymara",
      "value": "ay"
    },
    {
      "label": "Azerbaijani",
      "value": "az"
    },
    {
      "label": "Bambara",
      "value": "bm"
    },
    {
      "label": "Bashkir",
      "value": "ba"
    },
    {
      "label": "Basque",
      "value": "eu"
    },
    {
      "label": "Belarusian",
      "value": "be"
    },
    {
      "label": "Bihari",
      "value": "bh"
    },
    {
      "label": "Bislama",
      "value": "bi"
    },
    {
      "label": "Bosnian",
      "value": "bs"
    },
    {
      "label": "Breton",
      "value": "br"
    },
    {
      "label": "Bulgarian",
      "value": "bg"
    },
    {
      "label": "Burmese",
      "value": "my"
    },
    {
      "label": "Catalan",
      "value": "ca"
    },
    {
      "label": "Chamorro",
      "value": "ch"
    },
    {
      "label": "Chechen",
      "value": "ce"
    },
    {
      "label": "Chichewa, Chewa, Nyanja",
      "value": "ny"
    },
    {
      "label": "Chinese (Simplified)",
      "value": "zh-Hans"
    },
    {
      "label": "Chinese (Traditional)",
      "value": "zh-Hant"
    },
    {
      "label": "Chuvash",
      "value": "cv"
    },
    {
      "label": "Cornish",
      "value": "kw"
    },
    {
      "label": "Corsican",
      "value": "co"
    },
    {
      "label": "Cree",
      "value": "cr"
    },
    {
      "label": "Croatian",
      "value": "hr"
    },
    {
      "label": "Czech",
      "value": "cs"
    },
    {
      "label": "Danish",
      "value": "da"
    },
    {
      "label": "Divehi, Dhivehi, Maldivian",
      "value": "dv"
    },
    {
      "label": "Dutch",
      "value": "nl"
    },
    {
      "label": "Dzongkha",
      "value": "dz"
    },
    {
      "label": "Esperanto",
      "value": "eo"
    },
    {
      "label": "Estonian",
      "value": "et"
    },
    {
      "label": "Ewe",
      "value": "ee"
    },
    {
      "label": "Faroese",
      "value": "fo"
    },
    {
      "label": "Fijian",
      "value": "fj"
    },
    {
      "label": "Finnish",
      "value": "fi"
    },
    {
      "label": "Fula, Fulah, Pulaar, Pular",
      "value": "ff"
    },
    {
      "label": "Galician",
      "value": "gl"
    },
    {
      "label": "Gaelic (Scottish)",
      "value": "gd"
    },
    {
      "label": "Gaelic (Manx)",
      "value": "gv"
    },
    {
      "label": "Georgian",
      "value": "ka"
    },
    {
      "label": "German",
      "value": "de"
    },
    {
      "label": "Greek",
      "value": "el"
    },
    {
      "label": "Greenlandic",
      "value": "kl"
    },
    {
      "label": "Guarani",
      "value": "gn"
    },
    {
      "label": "Gujarati",
      "value": "gu"
    },
    {
      "label": "Haitian Creole",
      "value": "ht"
    },
    {
      "label": "Hausa",
      "value": "ha"
    },
    {
      "label": "Hebrew",
      "value": "he"
    },
    {
      "label": "Herero",
      "value": "hz"
    },
    {
      "label": "Hiri Motu",
      "value": "ho"
    },
    {
      "label": "Hungarian",
      "value": "hu"
    },
    {
      "label": "Icelandic",
      "value": "is"
    },
    {
      "label": "Ido",
      "value": "io"
    },
    {
      "label": "Igbo",
      "value": "ig"
    },
    {
      "label": "Interlingua",
      "value": "ia"
    },
    {
      "label": "Interlingue",
      "value": "ie"
    },
    {
      "label": "Inuktitut",
      "value": "iu"
    },
    {
      "label": "Inupiak",
      "value": "ik"
    },
    {
      "label": "Irish",
      "value": "ga"
    },
    {
      "label": "Italian",
      "value": "it"
    },
    {
      "label": "Javanese",
      "value": "jv"
    },
    {
      "label": "Kalaallisut, Greenlandic",
      "value": "kl"
    },
    {
      "label": "Kannada",
      "value": "kn"
    },
    {
      "label": "Kanuri",
      "value": "kr"
    },
    {
      "label": "Kashmiri",
      "value": "ks"
    },
    {
      "label": "Kazakh",
      "value": "kk"
    },
    {
      "label": "Khmer",
      "value": "km"
    },
    {
      "label": "Kikuyu",
      "value": "ki"
    },
    {
      "label": "Kinyarwanda (Rwanda)",
      "value": "rw"
    },
    {
      "label": "Kirundi",
      "value": "rn"
    },
    {
      "label": "Kyrgyz",
      "value": "ky"
    },
    {
      "label": "Komi",
      "value": "kv"
    },
    {
      "label": "Kongo",
      "value": "kg"
    },
    {
      "label": "Korean",
      "value": "ko"
    },
    {
      "label": "Kurdish",
      "value": "ku"
    },
    {
      "label": "Kwanyama",
      "value": "kj"
    },
    {
      "label": "Lao",
      "value": "lo"
    },
    {
      "label": "Latin",
      "value": "la"
    },
    {
      "label": "Latvian (Lettish)",
      "value": "lv"
    },
    {
      "label": "Limburgish ( Limburger)",
      "value": "li"
    },
    {
      "label": "Lingala",
      "value": "ln"
    },
    {
      "label": "Lithuanian",
      "value": "lt"
    },
    {
      "label": "Luga-Katanga",
      "value": "lu"
    },
    {
      "label": "Luganda, Ganda",
      "value": "lg"
    },
    {
      "label": "Luxembourgish",
      "value": "lb"
    },
    {
      "label": "Manx",
      "value": "gv"
    },
    {
      "label": "Macedonian",
      "value": "mk"
    },
    {
      "label": "Malagasy",
      "value": "mg"
    },
    {
      "label": "Malay",
      "value": "ms"
    },
    {
      "label": "Malayalam",
      "value": "ml"
    },
    {
      "label": "Maltese",
      "value": "mt"
    },
    {
      "label": "Maori",
      "value": "mi"
    },
    {
      "label": "Marathi",
      "value": "mr"
    },
    {
      "label": "Marshallese",
      "value": "mh"
    },
    {
      "label": "Moldavian",
      "value": "mo"
    },
    {
      "label": "Mongolian",
      "value": "mn"
    },
    {
      "label": "Nauru",
      "value": "na"
    },
    {
      "label": "Navajo",
      "value": "nv"
    },
    {
      "label": "Ndonga",
      "value": "ng"
    },
    {
      "label": "Northern Ndebele",
      "value": "nd"
    },
    {
      "label": "Nepali",
      "value": "ne"
    },
    {
      "label": "Norwegian",
      "value": "no"
    },
    {
      "label": "Norwegian bokmål",
      "value": "nb"
    },
    {
      "label": "Norwegian nynorsk",
      "value": "nn"
    },
    {
      "label": "Nuosu",
      "value": "ii"
    },
    {
      "label": "Occitan",
      "value": "oc"
    },
    {
      "label": "Ojibwe",
      "value": "oj"
    },
    {
      "label": "Old Church Slavonic, Old Bulgarian",
      "value": "cu"
    },
    {
      "label": "Oriya",
      "value": "or"
    },
    {
      "label": "Oromo (Afaan Oromo)",
      "value": "om"
    },
    {
      "label": "Ossetian",
      "value": "os"
    },
    {
      "label": "Pāli",
      "value": "pi"
    },
    {
      "label": "Pashto, Pushto",
      "value": "ps"
    },
    {
      "label": "Persian (Farsi)",
      "value": "fa"
    },
    {
      "label": "Polish",
      "value": "pl"
    },
    {
      "label": "Punjabi (Eastern)",
      "value": "pa"
    },
    {
      "label": "Quechua",
      "value": "qu"
    },
    {
      "label": "Romansh",
      "value": "rm"
    },
    {
      "label": "Romanian",
      "value": "ro"
    },
    {
      "label": "Sami",
      "value": "se"
    },
    {
      "label": "Samoan",
      "value": "sm"
    },
    {
      "label": "Sango",
      "value": "sg"
    },
    {
      "label": "Sanskrit",
      "value": "sa"
    },
    {
      "label": "Serbian",
      "value": "sr"
    },
    {
      "label": "Serbo-Croatian",
      "value": "sh"
    },
    {
      "label": "Sesotho",
      "value": "st"
    },
    {
      "label": "Setswana",
      "value": "tn"
    },
    {
      "label": "Shona",
      "value": "sn"
    },
    {
      "label": "Sichuan Yi",
      "value": "ii"
    },
    {
      "label": "Sindhi",
      "value": "sd"
    },
    {
      "label": "Sinhalese",
      "value": "si"
    },
    {
      "label": "Siswati",
      "value": "ss"
    },
    {
      "label": "Slovak",
      "value": "sk"
    },
    {
      "label": "Slovenian",
      "value": "sl"
    },
    {
      "label": "Somali",
      "value": "so"
    },
    {
      "label": "Southern Ndebele",
      "value": "nr"
    },
    {
      "label": "Sundanese",
      "value": "su"
    },
    {
      "label": "Swahili (Kiswahili)",
      "value": "sw"
    },
    {
      "label": "Swati",
      "value": "ss"
    },
    {
      "label": "Swedish",
      "value": "sv"
    },
    {
      "label": "Tagalog",
      "value": "tl"
    },
    {
      "label": "Tahitian",
      "value": "ty"
    },
    {
      "label": "Tajik",
      "value": "tg"
    },
    {
      "label": "Tamil",
      "value": "ta"
    },
    {
      "label": "Tatar",
      "value": "tt"
    },
    {
      "label": "Telugu",
      "value": "te"
    },
    {
      "label": "Thai",
      "value": "th"
    },
    {
      "label": "Tibetan",
      "value": "bo"
    },
    {
      "label": "Tigrinya",
      "value": "ti"
    },
    {
      "label": "Tonga",
      "value": "to"
    },
    {
      "label": "Tsonga",
      "value": "ts"
    },
    {
      "label": "Turkish",
      "value": "tr"
    },
    {
      "label": "Turkmen",
      "value": "tk"
    },
    {
      "label": "Twi",
      "value": "tw"
    },
    {
      "label": "Uyghur",
      "value": "ug"
    },
    {
      "label": "Ukrainian",
      "value": "uk"
    },
    {
      "label": "Urdu",
      "value": "ur"
    },
    {
      "label": "Uzbek",
      "value": "uz"
    },
    {
      "label": "Venda",
      "value": "ve"
    },
    {
      "label": "Vietnamese",
      "value": "vi"
    },
    {
      "label": "Volapük",
      "value": "vo"
    },
    {
      "label": "Wallon",
      "value": "wa"
    },
    {
      "label": "Welsh",
      "value": "cy"
    },
    {
      "label": "Wolof",
      "value": "wo"
    },
    {
      "label": "Western Frisian",
      "value": "fy"
    },
    {
      "label": "Xhosa",
      "value": "xh"
    },
    {
      "label": "Yiddish",
      "value": "yi, ji"
    },
    {
      "label": "Yoruba",
      "value": "yo"
    },
    {
      "label": "Zhuang, Chuang",
      "value": "za"
    },
    {
      "label": "Zulu",
      "value": "zu"
    }
  ],
  "license": [
    {
      "value": "https://www.mozilla.org/MPL/2.0/",
      "label": "MPL V2.0"
    },
    {
      "value": "http://www.meta-net.eu/meta-share/meta-share-licenses/META-SHARE%20Commercial%20%20NoRedistribution_v0%207.pdf",
      "label": "META-SHARE Commercial NoRedistribution For-A-Fee V1.0"
    },
    {
      "value": "http://www.meta-net.eu/meta-share/meta-share-licenses/META-SHARE%20Commercial%20%20NoRedistribution_v0%207.pdf",
      "label": "META-SHARE Commercial NoRedistribution V1.0"
    },
    {
      "value": "http://wiki.data.gouv.fr/images/0/05/Open_Licence.pdf",
      "label": "OL V1.0"
    },
    {
      "value": "https://gnu.org/licenses/fdl.html",
      "label": "GFDL V1.3"
    },
    {
      "value": "https://gnu.org/licenses/fdl.html",
      "label": "GFDL V1.1"
    },
    {
      "value": "http://artlibre.org/licence/lal/en/",
      "label": "GFDL V1.3"
    },
    {
      "value": "https://www.gnu.org/licenses/lgpl.html",
      "label": "LGPL V2.0"
    },
    {
      "value": "https://www.gnu.org/licenses/lgpl.html",
      "label": "LGPL V3.0"
    },
    {
      "value": "https://www.gnu.org/licenses/lgpl.html",
      "label": "LGPL V2.1"
    },
    {
      "value": "http://www.gnu.org/licenses/agpl-3.0.html",
      "label": "GNU Affero General Public License 3.0"
    },
    {
      "value": "http://creativecommons.org/publicdomain/zero/1.0/",
      "label": "CC0 1.0 Universal (CC0 1.0) Public Domain Dedication"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/4.0/",
      "label": "Creative Commons - Attribution-ShareAlike 4.0 International - CC BY-SA 4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/4.0/",
      "label": "Creative Commons - Attribution-NoDerivatives 4.0 International - CC BY-ND 4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-sa/4.0/",
      "label": "Creative Commons - Attribution-NonCommercial-ShareAlike 4.0 International - CC BY-NC-SA 4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/4.0/",
      "label": "Creative Commons - Attribution-NonCommercial-NoDerivatives 4.0 International - CC BY-NC-ND 4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc/4.0/",
      "label": "Creative Commons - Attribution-NonCommercial 4.0 International - CC BY-NC 4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/fr",
      "label": "CC-BY 3.0 France"
    },
    {
      "value": "http://creativecommons.org/licenses/by/4.0/",
      "label": "Creative Commons - Attribution 4.0 International - CC BY 4.0"
    },
    {
      "value": "http://openvalue.org/licenses/academic.php",
      "label": "Academic Free License 3.0"
    },
    {
      "value": "http://iss.ndl.go.jp/ndla/use/",
      "label": "Web NDL Authority License"
    },
    {
      "value": "http://www.w3.org/Consortium/Legal/2002/copyright-software-20021231",
      "label": "W3C Software Notice and License V1.0"
    },
    {
      "value": "http://www.nationalarchives.gov.uk/doc/non-commercial-government-licence/non-commercial-government-licence.htm",
      "label": "UK NonCommercial Government License V1.0"
    },
    {
      "value": "http://openvalue.org/licenses/SimPL-2.0",
      "label": "Simple Public License V2.0"
    },
    {
      "value": "http://en.wikipedia.org/wiki/Public_domain",
      "label": "Public domain"
    },
    {
      "value": "http://creativecommons.org/publicdomain/mark/1.0/",
      "label": "Public Domain Mark V1.0"
    },
    {
      "value": "http://www.oracle.com/technetwork/database/database-technologies/berkeleydb/downloads/oslicense-093458.html",
      "label": "Oracle Berkely DB License V1.0"
    },
    {
      "value": "http://www.nationalarchives.gov.uk/doc/open-government-licence/version/2/",
      "label": "Open Government Licence Non-Commercial V2.0"
    },
    {
      "value": "http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
      "label": "Open Government Licence V3.0"
    },
    {
      "value": "http://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/re-use-and-licensing/ukglf/",
      "label": "Open Government Licence V1.0"
    },
    {
      "value": "http://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/re-use-and-licensing/ukglf/",
      "label": "Open Government Licence V2.0"
    },
    {
      "value": "http://www.opengeospatial.org/ogc/document",
      "label": "Open Geospatial Consortium Document V1.0"
    },
    {
      "value": "http://www.opengeospatial.org/ogc/software",
      "label": "Open Geospatial Consortium Software V1.0"
    },
    {
      "value": "http://opendatacommons.org/licenses/pddl/",
      "label": "Open Data Commons Public Domain Dedication and License V1.0"
    },
    {
      "value": "http://opendatacommons.org/licenses/odbl/",
      "label": "Open Data Commons Open Database License V1.0"
    },
    {
      "value": "http://opendatacommons.org/licenses/odc-by/",
      "label": "Open Data Commons Attribution License V1.0"
    },
    {
      "value": "http://www.ordnancesurvey.co.uk/business-and-government/licensing/using-creating-data-with-os-products/os-opendata.html",
      "label": "OS Open Data License V3.0"
    },
    {
      "value": "https://www.mozilla.org/MPL/2.0/",
      "label": "Mozilla Public License V2.0"
    },
    {
      "value": "http://openvalue.org/licenses/MIT",
      "label": "MIT License V1.0"
    },
    {
      "value": "http://referencevalue.microsoft.com/referencevaluelicensing.aspx",
      "label": "Microsoft Reference value License"
    },
    {
      "value": "http://wiki.data.gouv.fr/images/0/05/Open_Licence.pdf",
      "label": "License Ouverte V1.0"
    },
    {
      "value": "http://www.formez.it/iodl/",
      "label": "Italian Open Data License v1.0 V1.0"
    },
    {
      "value": "https://www.govtrack.us/developers/license",
      "label": "Govtrack License"
    },
    {
      "value": "http://www.elda.org/media/filer_public/2014/08/01/var_140312.pdf",
      "label": "LANGUAGE REvalueS VALUE-ADDED-RESELLER AGREEMENT"
    },
    {
      "value": "http://openvalue.org/licenses/IPL-1.0",
      "label": "IBM Public License V1.0"
    },
    {
      "value": "https://gnu.org/licenses/fdl.html",
      "label": "GNU Free Documentation License V1.3"
    },
    {
      "value": "https://gnu.org/licenses/fdl.html",
      "label": "GNU Free Documentation License V1.1"
    },
    {
      "value": "https://www.gnu.org/licenses/lgpl.html",
      "label": "GNU Library General Public License V2.0"
    },
    {
      "value": "http://gnu.org/licenses/gpl-3.0.html",
      "label": "GNU General Public License V3.0"
    },
    {
      "value": "http://gnu.org/licenses/gpl-2.0.html",
      "label": "GNU General Public License V2.0"
    },
    {
      "value": "http://gnu.org/licenses/gpl-1.0.html",
      "label": "GNU General Public License V1.0"
    },
    {
      "value": "https://www.gnu.org/licenses/lgpl.html",
      "label": "GNU Lesser General Public License V3.0"
    },
    {
      "value": "https://www.gnu.org/licenses/lgpl.html",
      "label": "GNU Lesser General Public License V2.1"
    },
    {
      "value": "http://www.gnu.org/licenses/agpl-3.0.html",
      "label": "GNU Affero General Public License V3.0"
    },
    {
      "value": "https://joinup.ec.europa.eu/software/page/eupl/licence-eupl",
      "label": "European Union Public License V1.1"
    },
    {
      "value": "http://www.freebsd.org/copyright/freebsd-doc-license.html",
      "label": "Free BSD Documentation License"
    },
    {
      "value": "http://artlibre.org/licence/lal/en/",
      "label": "Free Art License V1.3"
    },
    {
      "value": "http://cryptix.org/LICENSE.TXT",
      "label": "Cryptix General License"
    },
    {
      "value": "https://www.eclipse.org/legal/epl-v10.html",
      "label": "Eclipse Public License V1.0"
    },
    {
      "value": "http://creativecommons.org/publicdomain/zero/1.0/",
      "label": "Creative Commons CC0 V1.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/ro",
      "label": "Creative Commons CC-BY-SA Romania V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/pt",
      "label": "Creative Commons CC-BY-SA Portugal V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/nl",
      "label": "Creative Commons CC-BY-SA Netherlands V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/ie",
      "label": "Creative Commons CC-BY-SA Ireland V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/4.0/",
      "label": "Creative Commons CC-BY-SA V4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/",
      "label": "Creative Commons CC-BY-SA V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/2.0/",
      "label": "Creative Commons CC-BY-SA V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/ch",
      "label": "Creative Commons CC-BY-SA 3.0 Switzerland V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/ve",
      "label": "Creative Commons CC-BY-SA Venezuela V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/es",
      "label": "Creative Commons CC-BY-SA 3.0 Spain V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/it",
      "label": "Creative Commons CC-BY-SA 3.0 Italy V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/gr",
      "label": "Creative Commons CC-BY-SA 3.0 Greece V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/cl",
      "label": "Creative Commons CC-BY-SA 3.0 Chile V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/at",
      "label": "Creative Commons CC-BY-SA 3.0 Austria V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/de",
      "label": "Creative Commons CC-BY-SA 3.0 Germany V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/fr",
      "label": "Creative Commons CC-BY-SA 3.0 France V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/ec",
      "label": "Creative Commons CC-BY-SA 3.0 Ecuador V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/cn",
      "label": "Creative Commons CC-BY-SA 3.0 China V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/br",
      "label": "Creative Commons CC-BY-SA 3.0 Brazil V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-sa/3.0/au",
      "label": "Creative Commons CC-BY-SA 3.0 Australia V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/ch",
      "label": "Creative Commons CC-BY-ND Switzerland V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/ie",
      "label": "Creative Commons CC-BY-ND Ireland V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/2.5/dk",
      "label": "Creative Commons CC-BY-ND Denmark V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/cn",
      "label": "Creative Commons CC-BY-ND China V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/de",
      "label": "Creative Commons CC-BY-ND Germany V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/cl",
      "label": "Creative Commons CC-BY-ND Chile V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/ec",
      "label": "Creative Commons CC-BY-ND Ecuador V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/br",
      "label": "Creative Commons CC-BY-ND Brazil V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/at",
      "label": "Creative Commons CC-BY-ND Austria V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/2.0/be",
      "label": "Creative Commons CC-BY-ND Belgium V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/au",
      "label": "Creative Commons CC-BY-ND Australia V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/ve",
      "label": "Creative Commons CC-BY-ND 3.0 Venezuela"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/ro",
      "label": "Creative Commons CC-BY-ND 3.0 Romania"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/es",
      "label": "Creative Commons CC-BY-ND 3.0 Spain"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/gr",
      "label": "Creative Commons CC-BY-ND 3.0 Greece"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/pt",
      "label": "Creative Commons CC-BY-ND 3.0 Portugal"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/it",
      "label": "Creative Commons CC-BY-ND 3.0 Italy"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/nl",
      "label": "Creative Commons CC-BY-ND 3.0 Netherlands"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/3.0/fr",
      "label": "Creative Commons CC-BY-ND 3.0 France"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nd/4.0/",
      "label": "Creative Commons CC-BY-ND V4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/",
      "label": "Creative Commons CC-BY-ND V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/2.0/",
      "label": "Creative Commons CC-BY-ND V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-sa/3.0/",
      "label": "Creative Commons CC-BY-NC-SA V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-sa/4.0/",
      "label": "Creative Commons CC-BY-NC-SA V4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-sa/2.0/",
      "label": "Creative Commons CC-BY-NC-SA V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/ve",
      "label": "Creative Commons CC-BY-NC-ND Venezuela V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/ch",
      "label": "Creative Commons CC-BY-NC-ND Switzerland V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/es",
      "label": "Creative Commons CC-BY-NC-ND Spain V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/ro",
      "label": "Creative Commons CC-BY-NC-ND Romania V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/gr",
      "label": "Creative Commons CC-BY-NC-ND Greece V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/fr",
      "label": "Creative Commons CC-BY-NC-ND France V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/cn",
      "label": "Creative Commons CC-BY-NC-ND China V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/ec",
      "label": "Creative Commons CC-BY-NC-ND Ecuador V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/cl",
      "label": "Creative Commons CC-BY-NC-ND Chile V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/pt",
      "label": "Creative Commons CC-BY-NC-ND Portugal V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/at",
      "label": "Creative Commons CC-BY-NC-ND Austria V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/au",
      "label": "Creative Commons CC-BY-NC-ND Australia V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/nl",
      "label": "Creative Commons CC-BY-NC-ND Netherlands V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/ie",
      "label": "Creative Commons CC-BY-NC-ND Ireland V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/it",
      "label": "Creative Commons CC-BY-NC-ND Italy V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/3.0/",
      "label": "Creative Commons CC-BY-NC-ND V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/4.0/",
      "label": "Creative Commons CC-BY-NC-ND V4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc-nd/2.0/",
      "label": "Creative Commons CC-BY-NC-ND V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc/3.0/",
      "label": "Creative Commons CC-BY-NC V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc/2.0/",
      "label": "Creative Commons CC-BY-NC V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by-nc/4.0/",
      "label": "Creative Commons CC-BY-NC V4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/ve",
      "label": "Creative Commons CC-BY Venezuela V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/us",
      "label": "Creative Commons CC-BY United States V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/ch",
      "label": "Creative Commons CC-BY Switzerland V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/es",
      "label": "Creative Commons CC-BY Spain V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/th",
      "label": "Creative Commons CC-BY Thailand V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/za",
      "label": "Creative Commons CC-BY South Africa V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/scotland",
      "label": "Creative Commons CC-BY Scotland V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/lu",
      "label": "Creative Commons CC-BY Luxemburg V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/pt",
      "label": "Creative Commons CC-BY Portugal V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/nz",
      "label": "Creative Commons CC-BY New Zealand V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/nl",
      "label": "Creative Commons CC-BY Netherlands V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/mx",
      "label": "Creative Commons CC-BY Mexico V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/jp",
      "label": "Creative Commons CC-BY Japan V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/kr",
      "label": "Creative Commons CC-BY Korea V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/it",
      "label": "Creative Commons CC-BY Italy V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/il",
      "label": "Creative Commons CC-BY Israel V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/in",
      "label": "Creative Commons CC-BY India V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/ie",
      "label": "Creative Commons CC-BY Ireland V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/hu",
      "label": "Creative Commons CC-BY Hungary V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/gr",
      "label": "Creative Commons CC-BY Greece V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/uk",
      "label": "Creative Commons CC-BY England & Wales V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/eg",
      "label": "Creative Commons CC-BY Egypt V3.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/fr",
      "label": "Creative Commons CC-BY France V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/de",
      "label": "Creative Commons CC-BY Germany V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/dk",
      "label": "Creative Commons CC-BY Denmark V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/dz",
      "label": "Creative Commons CC-BY Czech Republic V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/dz",
      "label": "Uveďte původ Česká republika V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/bg",
      "label": "Creative Commons CC-BY Bulgaria V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/cl",
      "label": "Creative Commons CC-BY Chile V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/ca",
      "label": "Creative Commons CC-BY Canada V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/be",
      "label": "Creative Commons CC-BY Belgium V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/mx",
      "label": "Creative Commons CC-BY Argentina V2.5"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/ch",
      "label": "Creative Commons CC-BY 3.0 Switzerland"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/es",
      "label": "Creative Commons CC-BY 3.0 Spain"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/nl",
      "label": "Creative Commons CC-BY 3.0 Netherlands"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/ro",
      "label": "Creative Commons CC-BY 3.0 Romania"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/pl",
      "label": "Creative Commons CC-BY 3.0 Poland"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/fr",
      "label": "Creative Commons CC-BY 3.0 France"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/it",
      "label": "Creative Commons CC-BY 3.0 Italy"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/ec",
      "label": "Creative Commons CC-BY 3.0 Ecuador"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/de",
      "label": "Creative Commons CC-BY 3.0 Germany"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/cn",
      "label": "Creative Commons CC-BY 3.0 China"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/cl",
      "label": "Creative Commons CC-BY 3.0 Chile"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/pt",
      "label": "Creative Commons CC-BY 2.5 Portugal"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/br",
      "label": "Creative Commons CC-BY 3.0 Brazil"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/at",
      "label": "Creative Commons CC-BY 3.0 Austria"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/se",
      "label": "Creative Commons CC-BY 2.5 Sweden"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/au",
      "label": "Creative Commons CC-BY 3.0 Australia"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.5/pe",
      "label": "Creative Commons CC-BY 2.5 Peru"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/br",
      "label": "Creative Commons CC-BY 2.0 Brazil"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/at",
      "label": "Creative Commons CC-BY 2.0 Austria"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/au",
      "label": "Creative Commons CC-BY 2.0 Australia"
    },
    {
      "value": "http://creativecommons.org/licenses/by/2.0/",
      "label": "Creative Commons CC-BY V2.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/1.0/",
      "label": "Creative Commons CC-BY V1.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/4.0/",
      "label": "Creative Commons CC-BY V4.0"
    },
    {
      "value": "http://creativecommons.org/licenses/by/3.0/",
      "label": "Creative Commons CC-BY V3.0"
    },
    {
      "value": "http://openvalue.org/licenses/cpl1.0.php",
      "label": "Common Public License V1.0"
    },
    {
      "value": "http://openvalue.org/licenses/CDDL-1.0",
      "label": "Common Development and Distribution License V1.0"
    },
    {
      "value": "http://www.coloriuris.net/en:avisos_legales#copyright_and_industrial_property",
      "label": "ColorIURIS Copyright"
    },
    {
      "value": "http://www.linfo.org/bsdlicense.html",
      "label": "BSD License 4-clause V4.0"
    },
    {
      "value": "http://openvalue.org/licenses/BSL-1.0",
      "label": "BOOST Software License V1.0"
    },
    {
      "value": "http://www.linfo.org/bsdlicense.html",
      "label": "BSD License 3-clause V4.0"
    },
    {
      "value": "http://www.apache.org/licenses/LICENSE-1.0",
      "label": "Apache License V1.0"
    },
    {
      "value": "http://www.apache.org/licenses/LICENSE-2.0",
      "label": "Apache License V2.0"
    },
    {
      "value": "http://openvalue.org/licenses/Artistic-2.0",
      "label": "Artistic License V2.0"
    },
    {
      "value": "http://www.linfo.org/bsdlicense.html",
      "label": "2-clause BSD License V2.0"
    },
    {
      "value": "http://openvalue.org/licenses/academic.php",
      "label": "Academic Free License V3.0"
    }
  ],
  "vocabulary": [
    {
      "nsp": "http://www.irit.fr/recherches/MELODI/ontologies/SAN#",
      "prefix": "SAN",
      "uri": "http://www.irit.fr/recherches/MELODI/ontologies/SAN",
      "titles": [
        {
          "value": "SAN (Semantic Actuator Network)",
          "lang": "en",
          "_id": "632487f6f0004aba7af3f86e"
        }
      ]
    },
    {
      "uri": "https://w3id.org/arco/ontology/location",
      "nsp": "https://w3id.org/arco/ontology/location/",
      "prefix": "a-loc",
      "titles": [
        {
          "value": "Location Ontology (ArCo network)",
          "lang": "en",
          "_id": "63248ca8121504032603bd80"
        }
      ]
    },
    {
      "nsp": "http://purl.org/acco/ns#",
      "prefix": "acco",
      "uri": "http://purl.org/acco/ns",
      "titles": [
        {
          "value": "Accomodation Ontology",
          "lang": "en",
          "_id": "60f45cf6f15c60e61cf5bb21"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/auth/acl#",
      "prefix": "acl",
      "uri": "http://www.w3.org/ns/auth/acl",
      "titles": [
        {
          "value": "Basic Access Control ontology",
          "lang": "en",
          "_id": "63248405f0004aba7af3f823"
        }
      ]
    },
    {
      "nsp": "http://acm.rkbexplorer.com/ontologies/acm#",
      "prefix": "acm",
      "uri": "http://www.rkbexplorer.com/ontologies/acm",
      "titles": [
        {
          "value": "ACM Classification Ontology",
          "lang": "en",
          "_id": "5aba12a00d8ceb4e0147e17b"
        }
      ]
    },
    {
      "nsp": "http://privatealpha.com/ontology/certification/1#",
      "prefix": "acrt",
      "uri": "http://privatealpha.com/ontology/certification/1#",
      "titles": [
        {
          "value": "Agent Certification Ontology",
          "lang": "en",
          "_id": "632484dbf0004aba7af3f840"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/adms#",
      "prefix": "adms",
      "uri": "http://www.w3.org/ns/adms",
      "titles": [
        {
          "value": "Asset Description Metadata Schema",
          "lang": "en",
          "_id": "56916f91b7cea413588f954b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/af/",
      "prefix": "af",
      "uri": "http://purl.org/ontology/af/",
      "titles": [
        {
          "value": "Audio Features Ontology",
          "lang": "en",
          "_id": "586a4a897e341093492b8b59"
        }
      ]
    },
    {
      "nsp": "http://www.agls.gov.au/agls/terms/",
      "prefix": "agls",
      "uri": "http://www.agls.gov.au/agls/terms",
      "titles": [
        {
          "value": "AGLS Metadata Terms",
          "lang": "en",
          "_id": "586a46447e341093492b8583"
        }
      ]
    },
    {
      "nsp": "http://promsns.org/def/agr#",
      "prefix": "agr",
      "uri": "http://promsns.org/def/agr",
      "titles": [
        {
          "value": "Agreements ontology",
          "lang": "en",
          "_id": "5a4141b8b201efd03d3af351"
        }
      ]
    },
    {
      "nsp": "http://d-nb.info/standards/elementset/agrelon#",
      "prefix": "agrelon",
      "uri": "http://d-nb.info/standards/elementset/agrelon",
      "titles": [
        {
          "value": "Agent Relationship Ontology",
          "lang": "en",
          "_id": "632489c6f0004aba7af3f88e"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/aiiso/schema#",
      "prefix": "aiiso",
      "uri": "http://purl.org/vocab/aiiso/schema",
      "titles": [
        {
          "value": "Academic Institution Internal Structure Ontology",
          "lang": "en",
          "_id": "5696a5b6ff8848f96bd11d80"
        }
      ]
    },
    {
      "uri": "https://w3id.org/AIRO",
      "nsp": "https://w3id.org/AIRO#",
      "prefix": "airo",
      "titles": [
        {
          "value": "AI Risk Ontology",
          "lang": "en",
          "_id": "63248867f0004aba7af3f883"
        }
      ]
    },
    {
      "nsp": "https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#",
      "prefix": "airs",
      "uri": "https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#",
      "titles": [
        {
          "value": "Alliance of Information and Referral Services (AIRS) Vocabulary",
          "lang": "en",
          "_id": "57f6086b812207ab0361cd14"
        }
      ]
    },
    {
      "nsp": "http://www.aktors.org/ontology/portal#",
      "prefix": "akt",
      "uri": "http://www.aktors.org/ontology/portal",
      "titles": [
        {
          "value": "AKT Reference Ontology",
          "lang": "en",
          "_id": "57f60938812207ab0361cdcc"
        }
      ]
    },
    {
      "nsp": "http://www.aktors.org/ontology/support#",
      "prefix": "akts",
      "uri": "http://www.aktors.org/ontology/support",
      "titles": [
        {
          "value": "AKT Support Ontology",
          "lang": "en",
          "_id": "57f60961812207ab0361cdfa"
        }
      ]
    },
    {
      "nsp": "http://securitytoolbox.appspot.com/securityAlgorithms#",
      "prefix": "algo",
      "uri": "http://securitytoolbox.appspot.com/securityAlgorithms#",
      "titles": [
        {
          "value": "Algorithms Ontology",
          "lang": "en",
          "_id": "569170d2b7cea413588f95ea"
        }
      ]
    },
    {
      "nsp": "http://open-services.net/ns/asset#",
      "prefix": "am",
      "uri": "http://open-services.net/ns/asset#",
      "titles": [
        {
          "value": "OSLC Asset Management Vocabulary",
          "lang": "en",
          "_id": "6324850bf0004aba7af3f846"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/i40/aml#",
      "prefix": "aml",
      "uri": "https://w3id.org/i40/aml",
      "titles": [
        {
          "value": "AutomationML Ontology",
          "lang": "en",
          "_id": "588a2c0967d4e8e0568bcc4a"
        }
      ]
    },
    {
      "uri": "http://w3id.org/amlo/core",
      "nsp": "http://w3id.org/amlo/core#",
      "prefix": "amlo-core",
      "titles": [
        {
          "value": "AMLO-core vocabulary",
          "lang": "en",
          "_id": "5ec7f4bb218a9eab39bb02c4"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/ao/core#",
      "prefix": "ao",
      "uri": "http://purl.org/ontology/ao/core#",
      "titles": [
        {
          "value": "Association Ontology",
          "lang": "en",
          "_id": "63248d50121504032603bd8a"
        }
      ]
    },
    {
      "nsp": "http://rdf.muninn-project.org/ontologies/appearances#",
      "prefix": "aos",
      "uri": "http://rdf.muninn-project.org/ontologies/appearances",
      "titles": [
        {
          "value": "Appearances Ontology Specification",
          "lang": "en",
          "_id": "5731d1d7b5cce30e4a3b54ff"
        }
      ]
    },
    {
      "nsp": "http://purl.org/linked-data/api/vocab#",
      "prefix": "api",
      "uri": "http://purl.org/linked-data/api/vocab#",
      "titles": [
        {
          "value": "Linked Data API Vocabulary",
          "lang": "en",
          "_id": "586ba5297e341093492c4762"
        }
      ]
    },
    {
      "nsp": "http://semweb.mmlab.be/ns/apps4X#",
      "prefix": "apps4X",
      "uri": "http://semweb.mmlab.be/ns/apps4X",
      "titles": [
        {
          "value": "The vocabulary for Co-creation Events based on Open Data",
          "lang": "en",
          "_id": "5f1ace5e388540d23b85cf33"
        }
      ]
    },
    {
      "nsp": "http://purl.org/archival/vocab/arch#",
      "prefix": "arch",
      "uri": "http://purl.org/archival/vocab/arch",
      "titles": [
        {
          "value": "Archival collections ontology",
          "lang": "en",
          "_id": "583a047acd0ed0472763e107"
        }
      ]
    },
    {
      "uri": "https://w3id.org/arco/ontology/core",
      "nsp": "https://w3id.org/arco/ontology/core/",
      "prefix": "arco",
      "titles": [
        {
          "value": "Core Ontology (ArCo network)",
          "lang": "en",
          "_id": "5cf3c5e4022005fa5d1ac292"
        }
      ]
    },
    {
      "nsp": "http://www.arpenteur.org/ontology/Arpenteur.owl#",
      "prefix": "arp",
      "uri": "http://www.arpenteur.org/ontology/Arpenteur.owl",
      "titles": [
        {
          "value": "Arpenteur Ontology",
          "lang": "en",
          "_id": "5a5d1f7d209e748d429f9e37"
        }
      ]
    },
    {
      "nsp": "https://data.nasa.gov/ontologies/atmonto/data#",
      "prefix": "atd",
      "uri": "https://data.nasa.gov/ontologies/atmonto/data#",
      "titles": [
        {
          "value": "Air Traffic Data",
          "lang": "en",
          "_id": "5ad894ad1d2f4eee4d656fcf"
        }
      ]
    },
    {
      "nsp": "https://data.nasa.gov/ontologies/atmonto/ATM#",
      "prefix": "atm",
      "uri": "https://data.nasa.gov/ontologies/atmonto/ATM#",
      "titles": [
        {
          "value": "Air Traffic Management (ATM) Vocabulary",
          "lang": "en",
          "_id": "5ad8922b61786a9648240d21"
        }
      ]
    },
    {
      "nsp": "https://data.nasa.gov/ontologies/atmonto/general#",
      "prefix": "atts",
      "uri": "https://data.nasa.gov/ontologies/atmonto/general#",
      "titles": [
        {
          "value": "Air Traffic Temporal and Spacial Vocabulary",
          "lang": "en",
          "_id": "5ad895c40946b4a14e455be7"
        }
      ]
    },
    {
      "nsp": "http://bblfish.net/work/atom-owl/2006-06-06/#",
      "prefix": "awol",
      "uri": "http://bblfish.net/work/atom-owl/2006-06-06/",
      "titles": [
        {
          "value": "Atom Syndication Ontology",
          "lang": "en",
          "_id": "57f68820812207ab03623950"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/ssnx/meteo/aws#",
      "prefix": "aws",
      "uri": "http://purl.oclc.org/NET/ssnx/meteo/aws",
      "titles": [
        {
          "value": "Ontology for Meteorological sensors",
          "lang": "en",
          "_id": "583a04b0cd0ed0472763e10d"
        }
      ]
    },
    {
      "nsp": "http://bag.basisregistraties.overheid.nl/def/bag#",
      "prefix": "bag",
      "uri": "http://bag.basisregistraties.overheid.nl/def/bag",
      "titles": [
        {
          "value": "Vocabulary for the Dutch base registration of buildings and addresses (BAG)",
          "lang": "en",
          "_id": "5abcb8dfc7ef5ec931501221"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#",
      "prefix": "basic",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic",
      "titles": [
        {
          "value": "OWL representation of ISO 19103 (Basic types package)",
          "lang": "en",
          "_id": "57f68251812207ab0362348e"
        }
      ]
    },
    {
      "nsp": "http://www.bbc.co.uk/ontologies/bbc/",
      "prefix": "bbc",
      "uri": "http://www.bbc.co.uk/ontologies/bbc",
      "titles": [
        {
          "value": "BBC Ontology",
          "lang": "en",
          "_id": "5731b734b5cce30e4a3b52ab"
        }
      ]
    },
    {
      "nsp": "http://www.bbc.co.uk/ontologies/cms/",
      "prefix": "bbccms",
      "uri": "http://www.bbc.co.uk/ontologies/cms",
      "titles": [
        {
          "value": "BBC CMS Ontology",
          "lang": "en",
          "_id": "5731b9a0b5cce30e4a3b52fe"
        }
      ]
    },
    {
      "nsp": "http://www.bbc.co.uk/ontologies/coreconcepts/",
      "prefix": "bbccore",
      "uri": "http://www.bbc.co.uk/ontologies/coreconcepts",
      "titles": [
        {
          "value": "BBC Core Concepts",
          "lang": "en",
          "_id": "5731bb32b5cce30e4a3b5311"
        }
      ]
    },
    {
      "nsp": "http://www.bbc.co.uk/ontologies/provenance/",
      "prefix": "bbcprov",
      "uri": "http://www.bbc.co.uk/ontologies/provenance",
      "titles": [
        {
          "value": "BBC Provenance Ontology",
          "lang": "en",
          "_id": "578370c60183b1e80fc877ff"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/BCI-ontology#",
      "prefix": "bci",
      "uri": "https://w3id.org/BCI-ontology",
      "titles": [
        {
          "value": "Brain Computing Interface (BCI) Ontology",
          "lang": "en",
          "_id": "58219de637e8a6d933be9d04"
        }
      ]
    },
    {
      "uri": "https://w3id.org/bcom",
      "nsp": "https://w3id.org/bcom#",
      "prefix": "bcom",
      "titles": [
        {
          "value": "Building Concrete Monitoring Ontology (BCOM)",
          "lang": "en",
          "_id": "60fec67c640de9b115d1653e"
        }
      ]
    },
    {
      "nsp": "http://contextus.net/ontology/ontomedia/ext/common/being#",
      "prefix": "being",
      "uri": "http://contextus.net/ontology/ontomedia/ext/common/being#",
      "titles": [
        {
          "value": "OntoMedia Being Representation",
          "lang": "en",
          "_id": "57f6082e812207ab0361ccdf"
        }
      ]
    },
    {
      "nsp": "http://rdfs.co/bevon/",
      "prefix": "bevon",
      "uri": "http://rdfs.co/bevon/",
      "titles": [
        {
          "value": "BEVON: Beverage Ontology",
          "lang": "en",
          "_id": "63248cf5121504032603bd84"
        }
      ]
    },
    {
      "nsp": "http://id.loc.gov/ontologies/bibframe/",
      "prefix": "bf",
      "uri": "http://id.loc.gov/ontologies/bibframe/",
      "titles": [
        {
          "value": "BIBFRAME Vocabulary",
          "lang": "en",
          "_id": "5c9894025ba958e17a8636e0"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/bibo/",
      "prefix": "bibo",
      "uri": "http://purl.org/ontology/bibo/",
      "titles": [
        {
          "value": "The Bibliographic Ontology",
          "lang": "en",
          "_id": "5dacded48b936c5b59e22a73"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/nknouf/ns/bibtex#",
      "prefix": "bibtex",
      "uri": "http://purl.org/net/nknouf/ns/bibtex",
      "titles": [
        {
          "value": "BibTeX ontology",
          "lang": "en",
          "_id": "578365250183b1e80fc87401"
        }
      ]
    },
    {
      "uri": "http://bimerr.iot.linkeddata.es/def/occupancy-profile#",
      "nsp": "http://bimerr.iot.linkeddata.es/def/occupancy-profile#",
      "prefix": "bimerr-op",
      "titles": [
        {
          "value": "Occupancy Profile ontology",
          "lang": "en",
          "_id": "5eb4402ff298949e0c2d3e1c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/bio/0.1/",
      "prefix": "bio",
      "uri": "http://purl.org/vocab/bio/0.1/",
      "titles": [
        {
          "value": "BIO: A vocabulary for biographical information",
          "lang": "en",
          "_id": "586a4a1a7e341093492b8af4"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/biol/ns#",
      "prefix": "biol",
      "uri": "http://purl.org/NET/biol/ns#",
      "titles": [
        {
          "value": "Biological Taxonomy Vocabulary 0.2 (Core)",
          "lang": "en",
          "_id": "5adda40767b67f5811d01cac"
        }
      ]
    },
    {
      "nsp": "http://www.biopax.org/release/biopax-level3.owl#",
      "prefix": "biopax",
      "uri": "http://www.biopax.org/release/biopax-level3.owl",
      "titles": [
        {
          "value": "BioPAX Level 3 ontology",
          "lang": "en",
          "_id": "56a6abfb37d8a8044b2670ed"
        }
      ]
    },
    {
      "nsp": "http://purl.org/biotop/biotop.owl#",
      "prefix": "biotop",
      "uri": "http://purl.org/biotop/biotop.owl",
      "titles": [
        {
          "value": "BioTop",
          "lang": "en",
          "_id": "59ca791929685e28746bbf9a"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/biro/",
      "prefix": "biro",
      "uri": "http://purl.org/spar/biro",
      "titles": [
        {
          "value": "The Bibliographic Reference Ontology",
          "lang": "en",
          "_id": "569cca73ff8848f96bd16c98"
        }
      ]
    },
    {
      "nsp": "http://www.bl.uk/schemas/bibliographic/blterms#",
      "prefix": "blt",
      "uri": "http://www.bl.uk/schemas/bibliographic/blterms",
      "titles": [
        {
          "value": "British Library Terms RDF schema",
          "lang": "en",
          "_id": "569f7714ff8848f96bd20405"
        }
      ]
    },
    {
      "nsp": "http://swa.cefriel.it/ontologies/botdcat-ap#",
      "prefix": "bot",
      "uri": "http://swa.cefriel.it/ontologies/botdcat-ap",
      "titles": [
        {
          "value": "BotDCAT-AP - Data Catalogue vocabulary Application Profile for chatbots",
          "lang": "en",
          "_id": "5947897b8f40482b5d8dff03"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/biol/botany#",
      "prefix": "botany",
      "uri": "http://purl.org/NET/biol/botany#",
      "titles": [
        {
          "value": "Biological Taxonomy Vocabulary 0.2 (Botany)",
          "lang": "en",
          "_id": "56a6998b37d8a8044b26678a"
        }
      ]
    },
    {
      "nsp": "http://data.vlaanderen.be/ns/persoon#",
      "prefix": "bperson",
      "uri": "http://data.vlaanderen.be/ns/persoon",
      "titles": [
        {
          "value": "Person",
          "lang": "en",
          "_id": "5a32c6fdece6c50213e99ec7"
        },
        {
          "value": "Persoon",
          "lang": "nl",
          "_id": "5a32c6fdece6c50213e99ec6"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/br#",
      "prefix": "br",
      "uri": "http://vocab.deri.ie/br",
      "titles": [
        {
          "value": "Brainstorm Ontology",
          "lang": "en",
          "_id": "569f766fff8848f96bd20377"
        }
      ]
    },
    {
      "nsp": "http://brk.basisregistraties.overheid.nl/def/brk#",
      "prefix": "brk",
      "uri": "http://brk.basisregistraties.overheid.nl/def/brk",
      "titles": [
        {
          "value": "Key Register Cadastre (BRK) vocabulary",
          "lang": "en",
          "_id": "5abcc633c7ef5ec93150270e"
        }
      ]
    },
    {
      "nsp": "http://brt.basisregistraties.overheid.nl/def/top10nl#",
      "prefix": "brt",
      "uri": "http://brt.basisregistraties.overheid.nl/def/top10nl",
      "titles": [
        {
          "value": "Key Register Topography (BRT) vocabulary",
          "lang": "en",
          "_id": "5abcc60ac7ef5ec9315026db"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/bot#",
      "prefix": "bto",
      "uri": "https://w3id.org/bot",
      "titles": [
        {
          "value": "BOT: Building Topology Ontology",
          "lang": "en",
          "_id": "601c4192c01d47585511d794"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/c4n#",
      "prefix": "c4n",
      "uri": "http://vocab.deri.ie/c4n",
      "titles": [
        {
          "value": "Call for Anything vocabulary",
          "lang": "en",
          "_id": "5df2c0bd642496d2717d1a37"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/c4o/",
      "prefix": "c4o",
      "uri": "http://purl.org/spar/c4o",
      "titles": [
        {
          "value": "C4O, the Citation Counting and Context Characterization Ontology",
          "lang": "en",
          "_id": "569cc7ccff8848f96bd16c4a"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2002/12/cal/ical#",
      "prefix": "cal",
      "uri": "http://www.w3.org/2002/12/cal/ical",
      "titles": [
        {
          "value": "Internet Calendaring and Scheduling Core Object Specification",
          "lang": "en",
          "_id": "569f96b5ff8848f96bd21335"
        }
      ]
    },
    {
      "uri": "http://caressesrobot.org/ontology",
      "nsp": "http://caressesrobot.org/ontology#",
      "prefix": "caresses",
      "titles": [
        {
          "value": "CARESSES Ontology",
          "lang": "en",
          "_id": "5d3ea9f18b4d0a137781129c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/cartCoord#",
      "prefix": "cart",
      "uri": "http://purl.org/net/cartCoord#",
      "titles": [
        {
          "value": "cartCoordOnt",
          "lang": "en",
          "_id": "6326e8d0121504032603c3ec"
        }
      ]
    },
    {
      "uri": "http://www.w3id.org/def/caso#",
      "nsp": "http://www.w3id.org/def/caso#",
      "prefix": "caso",
      "titles": [
        {
          "value": "Context Aware System Observation Ontology",
          "lang": "en",
          "_id": "6034ea855520e9076d89fd4e"
        }
      ]
    },
    {
      "uri": "http://w3id.org/um/cbcm/eu-cm-ontology",
      "nsp": "http://w3id.org/um/cbcm/eu-cm-ontology#",
      "prefix": "cbcm",
      "titles": [
        {
          "value": "The European Union Company Mobility Ontology (EUCM ontology)",
          "lang": "en",
          "_id": "61b324916858fed439e7c4c6"
        }
      ]
    },
    {
      "nsp": "http://comicmeta.org/cbo/",
      "prefix": "cbo",
      "uri": "http://comicmeta.org/cbo/",
      "titles": [
        {
          "value": "Comic Book Ontology",
          "lang": "en",
          "_id": "57ad87cfb00b4b1452a888b7"
        }
      ]
    },
    {
      "nsp": "http://betalinkeddata.cbs.nl/def/cbs#",
      "prefix": "cbs",
      "uri": "http://betalinkeddata.cbs.nl/def/cbs",
      "titles": [
        {
          "value": "De Centraal Bureau voor de Statistiek (CBS) ontologie",
          "lang": "nl",
          "_id": "5b34dc5ccd8de63f0afaa608"
        },
        {
          "value": "Netherlands' National Statistics Office (CBS) ontology",
          "lang": "en",
          "_id": "5b34dc5ccd8de63f0afaa607"
        }
      ]
    },
    {
      "nsp": "http://creativecommons.org/ns#",
      "prefix": "cc",
      "uri": "http://creativecommons.org/ns",
      "titles": [
        {
          "value": "Creative Commons Rights Expression Language",
          "lang": "en",
          "_id": "569171f5b7cea413588f9682"
        }
      ]
    },
    {
      "nsp": "http://cookingbigdata.com/linkeddata/ccinstances#",
      "prefix": "cci",
      "uri": "http://cookingbigdata.com/linkeddata/ccinstances",
      "titles": [
        {
          "value": "Ontology for Cloud Computing instances",
          "lang": "en",
          "_id": "5b0594ea453b589b0c9f98db"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/cco/core#",
      "prefix": "cco",
      "uri": "http://purl.org/ontology/cco/core#",
      "titles": [
        {
          "value": "Cognitive Characteristics Ontology",
          "lang": "en",
          "_id": "5dacdf978b936c5b59e22a8e"
        }
      ]
    },
    {
      "nsp": "http://cookingbigdata.com/linkeddata/ccpricing#",
      "prefix": "ccp",
      "uri": "http://cookingbigdata.com/linkeddata/ccpricing",
      "titles": [
        {
          "value": "Vocabulary for prices options in Cloud Computing Services",
          "lang": "en",
          "_id": "5b05922d453b589b0c9f9874"
        }
      ]
    },
    {
      "nsp": "http://cookingbigdata.com/linkeddata/ccregions#",
      "prefix": "ccr",
      "uri": "http://cookingbigdata.com/linkeddata/ccregions",
      "titles": [
        {
          "value": "Vocabulary for Regions and Zones on Cloud Computing",
          "lang": "en",
          "_id": "5b0595be453b589b0c9f98fa"
        }
      ]
    },
    {
      "nsp": "http://cookingbigdata.com/linkeddata/ccsla#",
      "prefix": "ccsla",
      "uri": "http://cookingbigdata.com/linkeddata/ccsla",
      "titles": [
        {
          "value": "Service Level Agreement for Cloud Computing",
          "lang": "en",
          "_id": "5b058fb3453b589b0c9f9816"
        }
      ]
    },
    {
      "uri": "https://w3id.org/cdc",
      "nsp": "https://w3id.org/cdc#",
      "prefix": "cdc",
      "titles": [
        {
          "value": "CDC: Construction Dataset Context ontology",
          "lang": "en",
          "_id": "6038cad813698c270be20d8f"
        }
      ]
    },
    {
      "uri": "https://w3id.org/arco/ontology/context-description",
      "nsp": "https://w3id.org/arco/ontology/context-description/",
      "prefix": "cdesc",
      "titles": [
        {
          "value": "Context Description Ontology (ArCo network)",
          "lang": "en",
          "_id": "5db03884581233d82940d27c"
        },
        {
          "value": "Ontologia della Descrizione di Contesto (ArCo network)",
          "lang": "it",
          "_id": "5db03884581233d82940d27b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/twc/ontology/cdm.owl#",
      "prefix": "cdm",
      "uri": "http://purl.org/twc/ontology/cdm.owl#",
      "titles": [
        {
          "value": "Conceptual Depth and Momentum",
          "lang": "en",
          "_id": "59a69b227845e44d19bfa2d0"
        }
      ]
    },
    {
      "nsp": "http://purl.org/cld/cdtype/",
      "prefix": "cdtype",
      "uri": "http://purl.org/cld/cdtype/",
      "titles": [
        {
          "value": "The Collection Description Type Namespace",
          "lang": "en",
          "_id": "56950413ff8848f96bd1006d"
        }
      ]
    },
    {
      "uri": "https://w3id.org/CEMontology",
      "nsp": "https://w3id.org/CEMontology/",
      "prefix": "cem",
      "titles": [
        {
          "value": "Crime Event Model (CEM)",
          "lang": "en",
          "_id": "638bc07ce8d209386de14911"
        }
      ]
    },
    {
      "nsp": "http://www.ebusiness-unibw.org/ontologies/consumerelectronics/v1#",
      "prefix": "ceo",
      "uri": "http://www.ebusiness-unibw.org/ontologies/consumerelectronics/v1",
      "titles": [
        {
          "value": "Consumer Electronics Ontology",
          "lang": "en",
          "_id": "577e0e430183b1e80fc6ac2a"
        }
      ]
    },
    {
      "nsp": "http://www.eurocris.org/ontologies/cerif/1.3#",
      "prefix": "cerif",
      "uri": "http://www.eurocris.org/ontologies/cerif/1.3",
      "titles": [
        {
          "value": "CERIF Ontology 1.3",
          "lang": "en",
          "_id": "582ae92ccd0ed04727598a3e"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/auth/cert#",
      "prefix": "cert",
      "uri": "http://www.w3.org/ns/auth/cert#",
      "titles": [
        {
          "value": "The Cert Ontology",
          "lang": "en",
          "_id": "586a4c467e341093492b8ce4"
        }
      ]
    },
    {
      "uri": "https://w3id.org/arco/ontology/cultural-event",
      "nsp": "https://w3id.org/arco/ontology/cultural-event/",
      "prefix": "cevent",
      "titles": [
        {
          "value": "Cultural Event Ontology (ArCo network)",
          "lang": "en",
          "_id": "5db055a0581233d82940d2d8"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/ssnx/cf/cf-feature#",
      "prefix": "cff",
      "uri": "http://purl.oclc.org/NET/ssnx/cf/cf-feature",
      "titles": [
        {
          "value": "Climate and Forecast (CF) features",
          "lang": "en",
          "_id": "583a0a86cd0ed0472763e156"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/ssnx/cf/cf-property#",
      "prefix": "cfp",
      "uri": "http://purl.oclc.org/NET/ssnx/cf/cf-property",
      "titles": [
        {
          "value": "Climate and Forecast (CF) standard names parameter vocabulary",
          "lang": "en",
          "_id": "586a49437e341093492b89e8"
        }
      ]
    },
    {
      "nsp": "http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#",
      "prefix": "cfrl",
      "uri": "http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#",
      "titles": [
        {
          "value": "Corporate Financial Reports and Loans Ontology",
          "lang": "en",
          "_id": "57d28910a3a9d3a63d7e6b3b"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov.uk/def/central-government/",
      "prefix": "cgov",
      "uri": "http://reference.data.gov.uk/def/central-government",
      "titles": [
        {
          "value": "Central Government Ontology",
          "lang": "en",
          "_id": "5c49902a9e5c7dfa7bfd1e9b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/chord/",
      "prefix": "chord",
      "uri": "http://purl.org/ontology/chord/",
      "titles": [
        {
          "value": "The OMRAS2 Chord Ontology",
          "lang": "en",
          "_id": "586b9f0f7e341093492c4719"
        }
      ]
    },
    {
      "uri": "https://privatealpha.com/ontology/content-inventory/1#",
      "nsp": "https://privatealpha.com/ontology/content-inventory/1#",
      "prefix": "ci",
      "titles": [
        {
          "value": "A Content Inventory Vocabulary",
          "lang": "en",
          "_id": "5c628d4c72ab374754392202"
        }
      ]
    },
    {
      "nsp": "http://dati.beniculturali.it/cis/",
      "prefix": "cis",
      "uri": "http://dati.beniculturali.it/cultural-ON/cultural-ON.owl",
      "titles": [
        {
          "value": "Cultural-ON (Cultural ONtology): Cultural Institute/Site and Cultural Event Ontology",
          "lang": "en",
          "_id": "597f0dc9780cc2987e56fe0d"
        },
        {
          "value": "Cultural-ON (Cultural ONtology): Ontologia dei Luoghi della Cultura e degli Eventi Culturali",
          "lang": "it",
          "_id": "597f0dc9780cc2987e56fe0c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/cito/",
      "prefix": "cito",
      "uri": "http://purl.org/spar/cito",
      "titles": [
        {
          "value": "CiTO, the Citation Typing Ontology",
          "lang": "en",
          "_id": "5ace37a53aba5caf50dde017"
        }
      ]
    },
    {
      "nsp": "http://www.essepuntato.it/2013/03/cito-functions/",
      "prefix": "citof",
      "uri": "http://www.essepuntato.it/2013/03/cito-functions",
      "titles": [
        {
          "value": "Functions of Citations",
          "lang": "en",
          "_id": "586a4db87e341093492b8e18"
        }
      ]
    },
    {
      "nsp": "http://advene.org/ns/cinelab/ld#",
      "prefix": "cl",
      "uri": "http://advene.org/ns/cinelab/ld",
      "titles": [
        {
          "value": "Cinelab ontology",
          "lang": "en",
          "_id": "5784e0f20183b1e80fc90523"
        }
      ]
    },
    {
      "nsp": "http://purl.org/cld/terms/",
      "prefix": "cld",
      "uri": "http://purl.org/cld/terms/",
      "titles": [
        {
          "value": "The Collection Description Terms",
          "lang": "en",
          "_id": "56a698cf37d8a8044b26673e"
        }
      ]
    },
    {
      "nsp": "http://purl.org/twc/ontologies/cmo.owl#",
      "prefix": "cmo",
      "uri": "http://purl.org/twc/ontologies/cmo.owl",
      "titles": [
        {
          "value": "Conceptual Model Ontology",
          "lang": "en",
          "_id": "5783694e0183b1e80fc8758e"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2011/content#",
      "prefix": "cnt",
      "uri": "http://www.w3.org/2011/content",
      "titles": [
        {
          "value": "Representing Content in RDF",
          "lang": "en",
          "_id": "632caea0c4f7e5f619d44f01"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/co/core#",
      "prefix": "co",
      "uri": "http://purl.org/ontology/co/core#",
      "titles": [
        {
          "value": "Counter Ontology",
          "lang": "en",
          "_id": "632caf16c4f7e5f619d44f0f"
        }
      ]
    },
    {
      "uri": "http://data.cochrane.org/ontologies/core/",
      "nsp": "http://data.cochrane.org/ontologies/core/",
      "prefix": "cochrane",
      "titles": [
        {
          "value": "Cochrane Core Vocabulary Ontology",
          "lang": "en",
          "_id": "5e905a10714818e448ba0a65"
        }
      ]
    },
    {
      "uri": "https://w3id.org/cocoon/v1.0",
      "nsp": "https://w3id.org/cocoon/v1.0#",
      "prefix": "cocoon",
      "titles": [
        {
          "value": "Cloud Computing Services Ontology",
          "lang": "en",
          "_id": "5cf4d54edf5b20456acd6571"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/cogs#",
      "prefix": "cogs",
      "uri": "http://vocab.deri.ie/cogs",
      "titles": [
        {
          "value": "COGS Vocabulary",
          "lang": "en",
          "_id": "621caca8eb61c60043989113"
        }
      ]
    },
    {
      "nsp": "http://purl.org/configurationontology#",
      "prefix": "cold",
      "uri": "http://purl.org/configurationontology",
      "titles": [
        {
          "value": "'Configuration as Linked Data' ontology",
          "lang": "en",
          "_id": "568bec904ee7f7176ff12591"
        }
      ]
    },
    {
      "nsp": "http://purl.org/co/",
      "prefix": "coll",
      "uri": "http://purl.org/co",
      "titles": [
        {
          "value": "Collections Ontology",
          "lang": "en",
          "_id": "55d7292de4ac2b1c4c5a5072"
        }
      ]
    },
    {
      "nsp": "http://vocab.resc.info/communication#",
      "prefix": "comm",
      "uri": "http://vocab.resc.info/communication",
      "titles": [
        {
          "value": "Vocabulary related to incident communication",
          "lang": "en",
          "_id": "5783b7420183b1e80fc87d22"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/2007/uwa/context/deliverycontext.owl",
      "nsp": "http://www.w3.org/2007/uwa/context/common.owl#",
      "prefix": "common",
      "titles": [
        {
          "value": "The Delivery Context Ontology",
          "lang": "en",
          "_id": "5db03395581233d82940d25c"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2000/10/swap/pim/contact#",
      "prefix": "con",
      "uri": "http://www.w3.org/2000/10/swap/pim/contact",
      "titles": [
        {
          "value": "Contact",
          "lang": "en",
          "_id": "632cac56c4f7e5f619d44ef3"
        }
      ]
    },
    {
      "uri": "https://w3id.org/con-tax",
      "nsp": "https://w3id.org/con-tax#",
      "prefix": "contax",
      "titles": [
        {
          "value": "ConTax ontology",
          "lang": "en",
          "_id": "6038c99613698c270be20d72"
        }
      ]
    },
    {
      "nsp": "http://purl.org/twc/vocab/conversion/",
      "prefix": "conversion",
      "uri": "http://purl.org/twc/vocab/conversion/",
      "titles": [
        {
          "value": "Conversion Ontology",
          "lang": "en",
          "_id": "5dace3818b936c5b59e22ac3"
        }
      ]
    },
    {
      "nsp": "http://purl.org/coo/ns#",
      "prefix": "coo",
      "uri": "http://purl.org/coo/ns#",
      "titles": [
        {
          "value": "Car Options Ontology",
          "lang": "en",
          "_id": "6326ebfe121504032603c43b"
        }
      ]
    },
    {
      "uri": "https://w3id.org/mdo/core/",
      "nsp": "https://w3id.org/mdo/core/",
      "prefix": "core",
      "titles": [
        {
          "value": "Materials Design Ontology - Core Module",
          "lang": "en",
          "_id": "5fb399314234ac0847e4c4d6"
        }
      ]
    },
    {
      "nsp": "http://www.daml.org/2001/09/countries/iso-3166-ont#",
      "prefix": "coun",
      "uri": "http://www.daml.org/2001/09/countries/iso-3166-ont",
      "titles": [
        {
          "value": "ISO 3166 Country Codes",
          "lang": "en",
          "_id": "5783b7a50183b1e80fc87d34"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#",
      "prefix": "cpa",
      "uri": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl",
      "titles": [
        {
          "value": "Content Pattern Annotations",
          "lang": "en",
          "_id": "568beccf4ee7f7176ff12595"
        }
      ]
    },
    {
      "nsp": "http://www.cidoc-crm.org/cidoc-crm/",
      "prefix": "crm",
      "uri": "http://www.cidoc-crm.org/cidoc-crm/",
      "titles": [
        {
          "value": "CIDOC Conceptual Reference Model",
          "lang": "en",
          "_id": "56a69a0a37d8a8044b2667ca"
        }
      ]
    },
    {
      "nsp": "http://rhizomik.net/ontologies/copyrightonto.owl#",
      "prefix": "cro",
      "uri": "http://rhizomik.net/ontologies/copyrightonto.owl",
      "titles": [
        {
          "value": "Copyright Ontology",
          "lang": "en",
          "_id": "632cad7bc4f7e5f619d44efb"
        }
      ]
    },
    {
      "nsp": "http://courseware.rkbexplorer.com/ontologies/courseware#",
      "prefix": "crsw",
      "uri": "http://courseware.rkbexplorer.com/ontologies/courseware",
      "titles": [
        {
          "value": "ReSIST Courseware Ontology",
          "lang": "en",
          "_id": "586b9f837e341093492c4726"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/changeset/schema#",
      "prefix": "cs",
      "uri": "http://purl.org/vocab/changeset/schema",
      "titles": [
        {
          "value": "Changeset",
          "lang": "en",
          "_id": "586a4ca57e341093492b8d3a"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/csp#",
      "prefix": "csp",
      "uri": "http://vocab.deri.ie/csp",
      "titles": [
        {
          "value": "Constraint Satisfaction Problems Vocabulary",
          "lang": "en",
          "_id": "56a51ae637d8a8044b25db71"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/csvw#",
      "prefix": "csvw",
      "uri": "http://www.w3.org/ns/csvw#",
      "titles": [
        {
          "value": "CSV on the Web Vocabulary",
          "lang": "en",
          "_id": "61e18ae7ad0aa62c05f2469d"
        }
      ]
    },
    {
      "nsp": "http://www.tele.pw.edu.pl/~sims-onto/ConnectivityType.owl#",
      "prefix": "ct",
      "uri": "http://www.tele.pw.edu.pl/~sims-onto/ConnectivityType.owl",
      "titles": [
        {
          "value": "Connectivity types",
          "lang": "en",
          "_id": "55bb59c67459b3975b63c028"
        }
      ]
    },
    {
      "nsp": "http://commontag.org/ns#",
      "prefix": "ctag",
      "uri": "http://commontag.org/ns#",
      "titles": [
        {
          "value": "Common Tag Vocabulary",
          "lang": "en",
          "_id": "55a0d19257613119099c0fff"
        }
      ]
    },
    {
      "uri": "https://w3id.org/arco/ontology/catalogue",
      "nsp": "https://w3id.org/arco/ontology/catalogue/",
      "prefix": "ctlog",
      "titles": [
        {
          "value": "Catalogue Ontology (ArCo network)",
          "lang": "en",
          "_id": "5db0548b581233d82940d2c8"
        }
      ]
    },
    {
      "uri": "https://w3id.org/cto",
      "nsp": "https://w3id.org/cto#",
      "prefix": "cto",
      "titles": [
        {
          "value": "CTO: Construction Tasks Ontology",
          "lang": "en",
          "_id": "6038cb4113698c270be20d95"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ctic/infraestructuras/organizacion#",
      "prefix": "ctorg",
      "uri": "http://purl.org/ctic/infraestructuras/organizacion",
      "titles": [
        {
          "value": "Vocabulario de la estructura de organismos públicos",
          "lang": "es",
          "_id": "6326e9c2121504032603c3f2"
        },
        {
          "value": "Vocabulary for the structure of the public organizations",
          "lang": "en",
          "_id": "6326e9c2121504032603c3f1"
        }
      ]
    },
    {
      "uri": "https://w3id.org/ibp/CTRLont",
      "nsp": "https://w3id.org/ibp/CTRLont#",
      "prefix": "ctrl",
      "titles": [
        {
          "value": "CTRLont - An ontology to formally specify the control domain",
          "lang": "en",
          "_id": "5cc863223c9ea81c2a69ab68"
        }
      ]
    },
    {
      "nsp": "http://www.demcare.eu/ontologies/contextdescriptor.owl#",
      "prefix": "ctxdesc",
      "uri": "http://www.demcare.eu/ontologies/contextdescriptor.owl",
      "titles": [
        {
          "value": "Context Descriptor Pattern",
          "lang": "en",
          "_id": "5624b6a942fc695f7e69522c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/cwmo/#",
      "prefix": "cwmo",
      "uri": "http://purl.org/cwmo/#",
      "titles": [
        {
          "value": "Creative Workshop Management Ontology (CWMO)",
          "lang": "en",
          "_id": "58e3c9c4f6baaa6b1ab1eb0f"
        }
      ]
    },
    {
      "nsp": "http://www.bbc.co.uk/ontologies/creativework/",
      "prefix": "cwork",
      "uri": "http://www.bbc.co.uk/ontologies/creativework",
      "titles": [
        {
          "value": "Creative Work Ontology",
          "lang": "en",
          "_id": "578369050183b1e80fc8755a"
        }
      ]
    },
    {
      "nsp": "http://sparql.cwrc.ca/ontologies/cwrc#",
      "prefix": "cwrc",
      "uri": "http://sparql.cwrc.ca/ontologies/cwrc",
      "titles": [
        {
          "value": "L'Ontologie CWRC",
          "lang": "fr",
          "_id": "594a863d91b367211b350e1e"
        },
        {
          "value": "The CWRC Ontology",
          "lang": "en",
          "_id": "594a863d91b367211b350e1d"
        }
      ]
    },
    {
      "nsp": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#",
      "prefix": "d2rq",
      "uri": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1",
      "titles": [
        {
          "value": "D2RQ - Language Specification",
          "lang": "en",
          "_id": "56719ed04ee7f7176fe64bfd"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/dady#",
      "prefix": "dady",
      "uri": "http://vocab.deri.ie/dady",
      "titles": [
        {
          "value": "Dataset Dynamics (dady) vocabulary",
          "lang": "en",
          "_id": "55d72b39e4ac2b1c4c5a50d7"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/daia/",
      "prefix": "daia",
      "uri": "http://purl.org/ontology/daia",
      "titles": [
        {
          "value": "Document Availability Information Ontology",
          "lang": "en",
          "_id": "569f9677ff8848f96bd21304"
        }
      ]
    },
    {
      "nsp": "http://purl.org/eis/vocab/daq#",
      "prefix": "daq",
      "uri": "http://purl.org/eis/vocab/daq#",
      "titles": [
        {
          "value": "Dataset Quality Vocabulary",
          "lang": "en",
          "_id": "559aaf5e1928827f4b0133ff"
        }
      ]
    },
    {
      "nsp": "http://dataid.dbpedia.org/ns/core#",
      "prefix": "dataid",
      "uri": "http://dataid.dbpedia.org/ns/core#",
      "titles": [
        {
          "value": "DataID",
          "lang": "en",
          "_id": "57d906bb812207ab034e4c18"
        }
      ]
    },
    {
      "nsp": "http://contextus.net/ontology/ontomedia/misc/date#",
      "prefix": "date",
      "uri": "http://contextus.net/ontology/ontomedia/misc/date#",
      "titles": [
        {
          "value": "OntoMedia Date Part Representation",
          "lang": "en",
          "_id": "58eb8132abe2639e2c3ac8c1"
        }
      ]
    },
    {
      "nsp": "http://vocab.datex.org/terms#",
      "prefix": "datex",
      "uri": "http://vocab.datex.org/terms#",
      "titles": [
        {
          "value": "Linked Datex II",
          "lang": "en",
          "_id": "575e6f74a7910dac495e4e28"
        }
      ]
    },
    {
      "nsp": "http://theme-e.adaptcentre.ie/dave#",
      "prefix": "dave",
      "uri": "http://theme-e.adaptcentre.ie/dave/dave.ttl",
      "titles": [
        {
          "value": "Data Value Vocabulary (DaVe)",
          "lang": "en",
          "_id": "5a254c923d405e60384f2d29"
        }
      ]
    },
    {
      "uri": "https://w3id.org/dba/ontology/",
      "nsp": "https://w3id.org/dba/ontology/",
      "prefix": "dba",
      "titles": [
        {
          "value": "Description Banking Archives Ontology",
          "lang": "en",
          "_id": "61d583fdb7d3952f63200247"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/dbm/ontology#",
      "prefix": "dbm",
      "uri": "http://purl.org/net/dbm/ontology#",
      "titles": [
        {
          "value": "DBM Ontology",
          "lang": "en",
          "_id": "57d27628a3a9d3a63d7e6270"
        }
      ]
    },
    {
      "nsp": "http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#",
      "prefix": "dbowl",
      "uri": "http://ontology.cybershare.utep.edu/dbowl",
      "titles": [
        {
          "value": "Relational to Ontology Mapping Primitive",
          "lang": "en",
          "_id": "576968874a73263716312e2d"
        }
      ]
    },
    {
      "nsp": "http://dbpedia.org/ontology/",
      "prefix": "dbpedia-owl",
      "uri": "http://dbpedia.org/ontology/",
      "titles": [
        {
          "value": "The DBpedia Ontology",
          "lang": "en",
          "_id": "57d2ae3fa3a9d3a63d7e7c4a"
        }
      ]
    },
    {
      "nsp": "http://ontologi.es/doap-bugs#",
      "prefix": "dbug",
      "uri": "http://ontologi.es/doap-bugs#",
      "titles": [
        {
          "value": "DOAP Bugs",
          "lang": "en",
          "_id": "5788bca38c6f955d29bf1fc5"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dc/dcam/",
      "prefix": "dcam",
      "uri": "http://purl.org/dc/dcam/",
      "titles": [
        {
          "value": "DCMI Abstract Model",
          "lang": "en",
          "_id": "5dacdfd58b936c5b59e22a94"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/dcat#",
      "prefix": "dcat",
      "uri": "http://www.w3.org/ns/dcat",
      "titles": [
        {
          "value": "Data Catalog Vocabulary",
          "lang": "en",
          "_id": "5f9efd5dfdbf2d3c39c0071f"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dc/elements/1.1/",
      "prefix": "dce",
      "uri": "http://purl.org/dc/elements/1.1/",
      "titles": [
        {
          "value": "Dublin Core Metadata Element Set",
          "lang": "en",
          "_id": "5dace1d28b936c5b59e22aa6"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/datacite/",
      "prefix": "dcite",
      "uri": "http://purl.org/spar/datacite",
      "titles": [
        {
          "value": "The DataCite Ontology",
          "lang": "en",
          "_id": "55bb5f927459b3975b63c064"
        }
      ]
    },
    {
      "nsp": "http://ndl.go.jp/dcndl/terms/",
      "prefix": "dcndl",
      "uri": "http://ndl.go.jp/dcndl/terms/",
      "titles": [
        {
          "value": "NDL Metadata Terms",
          "lang": "en",
          "_id": "5cfa12bda83ab4061e10b66d"
        }
      ]
    },
    {
      "uri": "https://w3id.org/dco",
      "nsp": "https://w3id.org/dco#",
      "prefix": "dco",
      "titles": [
        {
          "value": "domOS Common Ontology",
          "lang": "en",
          "_id": "61a769dfbf34bcf5590f0ab5"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dc/terms/",
      "prefix": "dcterms",
      "uri": "http://purl.org/dc/terms/",
      "titles": [
        {
          "value": "DCMI Metadata Terms",
          "lang": "en",
          "_id": "5b633475fe90868e587d2001"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dc/dcmitype/",
      "prefix": "dctype",
      "uri": "http://purl.org/dc/dcmitype/",
      "titles": [
        {
          "value": "DCMI Type Vocabulary",
          "lang": "en",
          "_id": "5697b75eff8848f96bd12b10"
        }
      ]
    },
    {
      "uri": "https://w3id.org/arco/ontology/denotative-description",
      "nsp": "https://w3id.org/arco/ontology/denotative-description/",
      "prefix": "ddesc",
      "titles": [
        {
          "value": "Denotative Description Ontology (ArCo network)",
          "lang": "en",
          "_id": "5db03af5581233d82940d288"
        }
      ]
    },
    {
      "nsp": "https://decision-ontology.googlecode.com/svn/trunk/decision.owl#",
      "prefix": "decision",
      "uri": "https://decision-ontology.googlecode.com/svn/trunk/decision.owl",
      "titles": [
        {
          "value": "Decision ontology",
          "lang": "en",
          "_id": "584840948a0d14e34d5eb88a"
        }
      ]
    },
    {
      "nsp": "http://www.demcare.eu/ontologies/demlab.owl#",
      "prefix": "demlab",
      "uri": "http://www.demcare.eu/ontologies/demlab.owl",
      "titles": [
        {
          "value": "Dem@Care Lab Ontology for Dementia Assessment",
          "lang": "en",
          "_id": "56ae4d4f98f0192c57ea0261"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/deo/",
      "prefix": "deo",
      "uri": "http://purl.org/spar/deo",
      "titles": [
        {
          "value": "The Discourse Elements Ontology",
          "lang": "en",
          "_id": "55d72e72e4ac2b1c4c5a5158"
        }
      ]
    },
    {
      "nsp": "http://ontologi.es/doap-deps#",
      "prefix": "deps",
      "uri": "http://ontologi.es/doap-deps#",
      "titles": [
        {
          "value": "DOAP Dependencies",
          "lang": "en",
          "_id": "5784e1270183b1e80fc90546"
        }
      ]
    },
    {
      "uri": "http://static.datafoodconsortium.org/ontologies/DFC_FullModel.owl",
      "nsp": "http://static.datafoodconsortium.org/ontologies/DFC_FullModel.owl#",
      "prefix": "dfc",
      "titles": [
        {
          "value": "Data Food Consortium Ontology",
          "lang": "en",
          "_id": "60115d948d57f51b29adfe81"
        }
      ]
    },
    {
      "uri": "http://static.datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl",
      "nsp": "http://static.datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#",
      "prefix": "dfc-b",
      "titles": [
        {
          "value": "DFC Business Ontology",
          "lang": "en",
          "_id": "60115eeb8d57f51b29adfe9f"
        }
      ]
    },
    {
      "uri": "http://static.datafoodconsortium.org/ontologies/DFC_ProductGlossary.owl",
      "nsp": "http://static.datafoodconsortium.org/ontologies/DFC_ProductGlossary.owl#",
      "prefix": "dfc-p",
      "titles": [
        {
          "value": "A common vocabulary for digital food platforms (Product Glossary Part)",
          "lang": "en",
          "_id": "601162cdc6bbc8992d5655d3"
        }
      ]
    },
    {
      "uri": "http://static.datafoodconsortium.org/ontologies/DFC_TechnicalOntology.owl",
      "nsp": "http://static.datafoodconsortium.org/ontologies/DFC_TechnicalOntology.owl#",
      "prefix": "dfc-t",
      "titles": [
        {
          "value": "A common vocabulary for digital food platforms (Technical Part)",
          "lang": "en",
          "_id": "601160d18d57f51b29adfebf"
        }
      ]
    },
    {
      "uri": "https://w3id.org/dingo/",
      "nsp": "https://w3id.org/dingo#",
      "prefix": "dg",
      "titles": [
        {
          "value": "DINGO Ontology",
          "lang": "en",
          "_id": "5f1aed9b388540d23b85cf6b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/healthcarevocab/v1#",
      "prefix": "dicom",
      "uri": "http://purl.org/healthcarevocab/v1",
      "titles": [
        {
          "value": "Healthcare metadata - DICOM ontology",
          "lang": "en",
          "_id": "567e6cb64ee7f7176fea7b5f"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/dio#",
      "prefix": "dio",
      "uri": "https://w3id.org/dio",
      "titles": [
        {
          "value": "The Design Intent Ontology",
          "lang": "en",
          "_id": "569fcc8fff8848f96bd2385a"
        }
      ]
    },
    {
      "nsp": "http://rdf-vocabulary.ddialliance.org/discovery#",
      "prefix": "disco",
      "uri": "http://rdf-vocabulary.ddialliance.org/discovery",
      "titles": [
        {
          "value": "DDI-RDF Discovery Vocabulary",
          "lang": "en",
          "_id": "586ba6417e341093492c476c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dita/ns#",
      "prefix": "dita",
      "uri": "http://purl.org/dita/ns#",
      "titles": [
        {
          "value": "DITA RDF ontology",
          "lang": "en",
          "_id": "5788be8f8c6f955d29bf207c"
        }
      ]
    },
    {
      "nsp": "http://www.data-knowledge.org/dk/",
      "prefix": "dk",
      "uri": "http://www.data-knowledge.org/dk/",
      "titles": [
        {
          "value": "The Data Knowledge Vocabulary",
          "lang": "en",
          "_id": "5abb62460d8ceb4e01493ec2"
        },
        {
          "value": "Das Data-Knowledge-Vokabular",
          "lang": "de",
          "_id": "5abb62460d8ceb4e01493ec1"
        }
      ]
    },
    {
      "nsp": "http://onto.dm2e.eu/schemas/dm2e/",
      "prefix": "dm2e",
      "uri": "http://onto.dm2e.eu/schemas/dm2e",
      "titles": [
        {
          "value": "DM2E model",
          "lang": "en",
          "_id": "578d036d8c6f955d29c02b9f"
        }
      ]
    },
    {
      "nsp": "http://d-nb.info/standards/elementset/dnb#",
      "prefix": "dnbt",
      "uri": "http://d-nb.info/standards/elementset/dnb",
      "titles": [
        {
          "value": "DNB Metadata Terms",
          "lang": "en",
          "_id": "5c486f14d7048abc5cc35ee2"
        }
      ]
    },
    {
      "nsp": "http://usefulinc.com/ns/doap#",
      "prefix": "doap",
      "uri": "http://usefulinc.com/ns/doap#",
      "titles": [
        {
          "value": "Description of a Project vocabulary",
          "lang": "en",
          "_id": "57d2ceb7a3a9d3a63d7e8b48"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2000/10/swap/pim/doc#",
      "prefix": "doc",
      "uri": "http://www.w3.org/2000/10/swap/pim/doc",
      "titles": [
        {
          "value": "Works, licences, derivatives and dependencies",
          "lang": "en",
          "_id": "586baa787e341093492c4882"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/doco/",
      "prefix": "doco",
      "uri": "http://purl.org/spar/doco",
      "titles": [
        {
          "value": "DoCO, the Document Components Ontology",
          "lang": "en",
          "_id": "5bf281e02a4bb83670a7ba12"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/dso#",
      "prefix": "docso",
      "uri": "http://purl.org/ontology/dso",
      "titles": [
        {
          "value": "Document Service Ontology",
          "lang": "en",
          "_id": "63248a03f0004aba7af3f893"
        }
      ]
    },
    {
      "nsp": "http://elite.polito.it/ontologies/dogont",
      "prefix": "dogont",
      "uri": "http://elite.polito.it/ontologies/dogont.owl",
      "titles": [
        {
          "value": "Ontology Modeling for Intelligent Domotic Environments",
          "lang": "en",
          "_id": "5cdd0e17624369723924cb70"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov.au/def/ont/dataset#",
      "prefix": "donto",
      "uri": "http://reference.data.gov.au/def/ont/dataset",
      "titles": [
        {
          "value": "Dataset Ontology",
          "lang": "en",
          "_id": "5ad8adf22e909b214fc2d206"
        }
      ]
    },
    {
      "uri": "https://w3id.org/dot#",
      "nsp": "https://w3id.org/dot#",
      "prefix": "dot",
      "titles": [
        {
          "value": "Damage Topology Ontology",
          "lang": "en",
          "_id": "5fae670ab5c44be746694897"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dpn#",
      "prefix": "dpn",
      "uri": "http://purl.org/dpn",
      "titles": [
        {
          "value": "Data Provider Node ontology",
          "lang": "en",
          "_id": "57223579b5cce30e4a33f4cd"
        }
      ]
    },
    {
      "nsp": "http://promsns.org/def/do#",
      "prefix": "dprov",
      "uri": "http://promsns.org/def/decprov",
      "titles": [
        {
          "value": "Decision Provenance ontology (DecPROV)",
          "lang": "en",
          "_id": "5a4145efb201efd03d3afa2a"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#",
      "prefix": "dq",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality",
      "titles": [
        {
          "value": "OWL representation of ISO 19115 (Geographic Information - Metadata - Data quality package)",
          "lang": "en",
          "_id": "568a55274ee7f7176ff10eb6"
        }
      ]
    },
    {
      "nsp": "http://semwebquality.org/ontologies/dq-constraints#",
      "prefix": "dqc",
      "uri": "http://semwebquality.org/ontologies/dq-constraints",
      "titles": [
        {
          "value": "The Data Quality Constraints Library",
          "lang": "en",
          "_id": "586ba7e87e341093492c477b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dqm-vocabulary/v1/dqm#",
      "prefix": "dqm",
      "uri": "http://purl.org/dqm-vocabulary/v1/dqm",
      "titles": [
        {
          "value": "The Data Quality Management Vocabulary",
          "lang": "en",
          "_id": "55a6349e57613119099c3516"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/dqv#",
      "prefix": "dqv",
      "uri": "http://www.w3.org/ns/dqv",
      "titles": [
        {
          "value": "Data Quality Vocabulary",
          "lang": "en",
          "_id": "587e4f137e341093493c3b8e"
        }
      ]
    },
    {
      "nsp": "http://purl.org/swan/2.0/discourse-relationships/",
      "prefix": "dr",
      "uri": "http://purl.org/swan/2.0/discourse-relationships/",
      "titles": [
        {
          "value": "Discourse relationships vocabulary",
          "lang": "en",
          "_id": "55d7310de4ac2b1c4c5a51b8"
        }
      ]
    },
    {
      "uri": "http://www.purl.org/drammar",
      "nsp": "http://www.purl.org/drammar#",
      "prefix": "drama",
      "titles": [
        {
          "value": "Drammar: a comprehensive ontology of drama",
          "lang": "en",
          "_id": "5dce66f4372cf4662a0554f8"
        }
      ]
    },
    {
      "nsp": "http://vocab.data.gov/def/drm#",
      "prefix": "drm",
      "uri": "http://vocab.data.gov/def/drm",
      "titles": [
        {
          "value": "Data Reference Model",
          "lang": "en",
          "_id": "567e6bd24ee7f7176fea7b57"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ctic/dcat#",
      "prefix": "ds",
      "uri": "http://purl.org/ctic/dcat#",
      "titles": [
        {
          "value": "Dataset Catalog Vocabulary",
          "lang": "en",
          "_id": "560655948f7ad2ce3438d4ca"
        }
      ]
    },
    {
      "uri": "http://dqm.faw.jku.at/ontologies/dsd",
      "nsp": "http://dqm.faw.jku.at/ontologies/dsd#",
      "prefix": "dsd",
      "titles": [
        {
          "value": "Description of a Data Source",
          "lang": "en",
          "_id": "62b9a9bc749168e60eb2312b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/dsnotify/vocab/eventset/",
      "prefix": "dsn",
      "uri": "http://purl.org/dsnotify/vocab/eventset/",
      "titles": [
        {
          "value": "DSNotify Eventsets: A vocabulary for change events in linked data sources",
          "lang": "en",
          "_id": "55d731d7e4ac2b1c4c5a51dc"
        }
      ]
    },
    {
      "nsp": "http://inference-web.org/2.0/ds.owl#",
      "prefix": "dso",
      "uri": "http://inference-web.org/2.0/ds.owl",
      "titles": [
        {
          "value": "Data Structure Ontology",
          "lang": "en",
          "_id": "578d04fc8c6f955d29c02c3c"
        }
      ]
    },
    {
      "uri": "http://cef.uv.es/lodroadtran18/def/transporte/dtx_srti",
      "nsp": "http://cef.uv.es/lodroadtran18/def/transporte/dtx_srti#",
      "prefix": "dtx_srti",
      "titles": [
        {
          "value": "LOD SRTI DATEX II",
          "lang": "en",
          "_id": "63480071d5c74e27718ddda2"
        }
      ]
    },
    {
      "nsp": "http://www.linkedmodel.org/schema/dtype#",
      "prefix": "dtype",
      "uri": "http://www.linkedmodel.org/schema/dtype",
      "titles": [
        {
          "value": "Datatype Ontology",
          "lang": "en",
          "_id": "55ae826dcff711cc3f2b1898"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#",
      "prefix": "dul",
      "uri": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl",
      "titles": [
        {
          "value": "DOLCE+DnS Ultralite",
          "lang": "en",
          "_id": "58eb972dabe2639e2c3ae112"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/duv#",
      "prefix": "duv",
      "uri": "http://www.w3.org/ns/duv",
      "titles": [
        {
          "value": "Dataset Usage Vocabulary",
          "lang": "en",
          "_id": "5dad706d98c7a8076a14d5e9"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/dvia#",
      "prefix": "dvia",
      "uri": "http://purl.org/ontology/dvia",
      "titles": [
        {
          "value": "The visualization vocabulary for LOD applications",
          "lang": "en",
          "_id": "576a8e7e4a73263716317b8d"
        }
      ]
    },
    {
      "nsp": "http://archivi.ibc.regione.emilia-romagna.it/ontology/eac-cpf/",
      "prefix": "eac-cpf",
      "uri": "http://archivi.ibc.regione.emilia-romagna.it/ontology/eac-cpf/",
      "titles": [
        {
          "value": "EAC-CPF Descriptions Ontology for Linked Archival Data:",
          "lang": "en",
          "_id": "57d2ceeda3a9d3a63d7e8b6b"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/earl#",
      "prefix": "earl",
      "uri": "http://www.w3.org/ns/earl",
      "titles": [
        {
          "value": "Evaluation and Report Language",
          "lang": "en",
          "_id": "568be9814ee7f7176ff12517"
        }
      ]
    },
    {
      "nsp": "http://linked.earth/ontology#",
      "prefix": "earth",
      "uri": "http://linked.earth/ontology#",
      "titles": [
        {
          "value": "The Linked Earth Ontology",
          "lang": "en",
          "_id": "57692ff64a73263716311e06"
        }
      ]
    },
    {
      "uri": "http://data.businessgraph.io/ontology#",
      "nsp": "http://data.businessgraph.io/ontology#",
      "prefix": "ebg",
      "titles": [
        {
          "value": "euBusinessGraph ontology",
          "lang": "en",
          "_id": "60141943a63b96c815bc4dc2"
        }
      ]
    },
    {
      "nsp": "http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#",
      "prefix": "ebucore",
      "uri": "http://www.ebu.ch/metadata/ontologies/ebucore/ebucore",
      "titles": [
        {
          "value": "EBU Ontology",
          "lang": "en",
          "_id": "56ae523698f0192c57ea02a4"
        }
      ]
    },
    {
      "nsp": "https://vocab.eccenca.com/revision/",
      "prefix": "eccrev",
      "uri": "https://vocab.eccenca.com/revision/",
      "titles": [
        {
          "value": "RDF changes and revisions vocabulary",
          "lang": "en",
          "_id": "56e69473aacd7f0864390f9a"
        }
      ]
    },
    {
      "nsp": "http://www.eclap.eu/schema/eclap/",
      "prefix": "eclap",
      "uri": "http://www.eclap.eu/schema/eclap/",
      "titles": [
        {
          "value": "ECLAP, Performing Arts Vocabulary",
          "lang": "en",
          "_id": "55cde768e4ac2b1c4c59a51b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/ecpo#",
      "prefix": "ecpo",
      "uri": "http://purl.org/ontology/ecpo",
      "titles": [
        {
          "value": "Enumeration and Chronology of Periodicals Ontology",
          "lang": "en",
          "_id": "586bacd87e341093492c48b3"
        }
      ]
    },
    {
      "nsp": "http://erlangen-crm.org/current/",
      "prefix": "ecrm",
      "uri": "http://erlangen-crm.org/current/",
      "titles": [
        {
          "value": "Erlangen CRM / OWL",
          "lang": "en",
          "_id": "586bd89e7e341093492c5123"
        }
      ]
    },
    {
      "nsp": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#",
      "prefix": "edac",
      "uri": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl",
      "titles": [
        {
          "value": "ELSEWeb EDAC Ontology",
          "lang": "en",
          "_id": "56af776998f0192c57ea9391"
        }
      ]
    },
    {
      "nsp": "http://www.europeana.eu/schemas/edm/",
      "prefix": "edm",
      "uri": "http://www.europeana.eu/schemas/edm/",
      "titles": [
        {
          "value": "Europeana Data Model vocabulary",
          "lang": "en",
          "_id": "55d732bde4ac2b1c4c5a5211"
        }
      ]
    },
    {
      "uri": "https://schema.edu.ee/",
      "nsp": "https://schema.edu.ee/",
      "prefix": "edu",
      "titles": [
        {
          "value": "Education Ontology",
          "lang": "en",
          "_id": "5ec64d33a4efa76e1c8bb146"
        },
        {
          "value": "Hariduse ontoloogia",
          "lang": "et",
          "_id": "5ec64d33a4efa76e1c8bb145"
        }
      ]
    },
    {
      "uri": "http://ns.inria.fr/semed/eduprogression/",
      "nsp": "http://ns.inria.fr/semed/eduprogression#",
      "prefix": "edupro",
      "titles": [
        {
          "value": "EduProgression Ontology",
          "lang": "en",
          "_id": "5c669c0a6c1cff773137ac17"
        }
      ]
    },
    {
      "nsp": "http://purl.org/eem#",
      "prefix": "eem",
      "uri": "http://purl.org/eem",
      "titles": [
        {
          "value": "The EPCIS Event Model",
          "lang": "en",
          "_id": "553e9cf1581958526a68e5d8"
        }
      ]
    },
    {
      "uri": "https://w3id.org/eeo",
      "nsp": "https://w3id.org/eeo#",
      "prefix": "eeo",
      "titles": [
        {
          "value": "Experimental Evaluation Ontology",
          "lang": "en",
          "_id": "5fc66d2784c552d10a3f32d1"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/eepsa#",
      "prefix": "eepsa",
      "uri": "https://w3id.org/eepsa",
      "titles": [
        {
          "value": "EEPSA (Energy Efficiency Prediction Semantic Assistant) Ontology",
          "lang": "en",
          "_id": "5a92c32167d9427a394ca305"
        }
      ]
    },
    {
      "uri": "https://opendata.aragon.es/def/ei2a/ei2a.owl",
      "nsp": "http://opendata.aragon.es/def/ei2a#",
      "prefix": "ei2a",
      "titles": [
        {
          "value": "Aragon Interoperable Information Structure Ontology\nEI2A",
          "lang": "en",
          "_id": "5c498db59e5c7dfa7bfd1e93"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ctic/sector-publico/elecciones#",
      "prefix": "elec",
      "uri": "http://purl.org/ctic/sector-publico/elecciones",
      "titles": [
        {
          "value": "Vocabulario de Resultados Electorales",
          "lang": "es",
          "_id": "578d05298c6f955d29c02c43"
        },
        {
          "value": "Vocabulary for Vote Results",
          "lang": "en",
          "_id": "578d05298c6f955d29c02c42"
        }
      ]
    },
    {
      "nsp": "http://data.europa.eu/eli/ontology#",
      "prefix": "eli",
      "uri": "http://data.europa.eu/eli/ontology",
      "titles": [
        {
          "value": "The European Legislation Identifier",
          "lang": "en",
          "_id": "5b0fcb39f79aa03849eabe1c"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/emoca#",
      "prefix": "emotion",
      "uri": "http://ns.inria.fr/emoca",
      "titles": [
        {
          "value": "Emotion Ontology for Context Awareness",
          "lang": "en",
          "_id": "5691702fb7cea413588f958c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ctic/empleo/oferta#",
      "prefix": "emp",
      "uri": "http://purl.org/ctic/empleo/oferta",
      "titles": [
        {
          "value": "Vocabulario de Ofertas de Empleo",
          "lang": "es",
          "_id": "56a6abce37d8a8044b2670cc"
        },
        {
          "value": "A vocabulary for jobs",
          "lang": "en",
          "_id": "56a6abce37d8a8044b2670cb"
        }
      ]
    },
    {
      "nsp": "http://labs.mondeca.com/vocab/endpointStatus#",
      "prefix": "ends",
      "uri": "http://labs.mondeca.com/vocab/endpointStatus",
      "titles": [
        {
          "value": "Vocabulary of endpoint status (availability, responseTime)",
          "lang": "en",
          "_id": "55d73331e4ac2b1c4c5a522d"
        }
      ]
    },
    {
      "nsp": "http://eprints.org/ontology/",
      "prefix": "ep",
      "uri": "http://eprints.org/ontology/",
      "titles": [
        {
          "value": "EPrints Ontology",
          "lang": "en",
          "_id": "55d735d6e4ac2b1c4c5a52a8"
        }
      ]
    },
    {
      "uri": "https://w3id.org/ep-plan",
      "nsp": "https://w3id.org/ep-plan#",
      "prefix": "eppl",
      "titles": [
        {
          "value": "The EP-Plan ontology",
          "lang": "en",
          "_id": "5cb30645470a172015caa334"
        }
      ]
    },
    {
      "nsp": "https://data.nasa.gov/ontologies/atmonto/equipment#",
      "prefix": "eqp",
      "uri": "https://data.nasa.gov/ontologies/atmonto/equipment#",
      "titles": [
        {
          "value": "Aircraft Equipment Vocabulary",
          "lang": "en",
          "_id": "5ad89378a236156c49539cfa"
        }
      ]
    },
    {
      "uri": "http://data.europa.eu/esco/model",
      "nsp": "http://data.europa.eu/esco/model#",
      "prefix": "esco",
      "titles": [
        {
          "value": "The ESCO ontology",
          "lang": "en",
          "_id": "5da74883db65682853c6e1d0"
        }
      ]
    },
    {
      "nsp": "http://purl.org/essglobal/vocab/",
      "prefix": "essglobal",
      "uri": "http://purl.org/essglobal/vocab/",
      "titles": [
        {
          "value": "ESSGlobal Vocabulary",
          "lang": "en",
          "_id": "5549338bb6189eea2262b0c8"
        }
      ]
    },
    {
      "uri": "http://elite.polito.it/ontologies/eupont.owl",
      "nsp": "http://elite.polito.it/ontologies/eupont.owl#",
      "prefix": "eupont",
      "titles": [
        {
          "value": "EUPont: an ontology for End User Programming of the IoT",
          "lang": "en",
          "_id": "5bc4a88a3bf18c902a0fe53f"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/c4dm/event.owl#",
      "prefix": "event",
      "uri": "http://purl.org/NET/c4dm/event.owl",
      "titles": [
        {
          "value": "The Event Ontology",
          "lang": "en",
          "_id": "5a36c89aece6c50213eee4b3"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/ns/ex#",
      "prefix": "ex",
      "uri": "http://purl.org/net/ns/ex",
      "titles": [
        {
          "value": "Example vocabulary",
          "lang": "en",
          "_id": "5cfa1260a83ab4061e10b660"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2003/12/exif/ns#",
      "prefix": "exif",
      "uri": "http://www.w3.org/2003/12/exif/ns",
      "titles": [
        {
          "value": "Exif data description vocabulary",
          "lang": "en",
          "_id": "57d2d0d7a3a9d3a63d7e8c51"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/extent#",
      "prefix": "ext",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/extent",
      "titles": [
        {
          "value": "OWL representation of ISO 19115 (Geographic Information - Metadata - Extent package)",
          "lang": "en",
          "_id": "55bca7e37459b3975b63ca9a"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/fabio/",
      "prefix": "fabio",
      "uri": "http://purl.org/spar/fabio",
      "titles": [
        {
          "value": "FRBR-aligned Bibliographic Ontology",
          "lang": "en",
          "_id": "5ca1c571aa7b2a694adc746c"
        }
      ]
    },
    {
      "nsp": "http://biohackathon.org/resource/faldo#",
      "prefix": "faldo",
      "uri": "http://biohackathon.org/resource/faldo",
      "titles": [
        {
          "value": "Feature Annotation Location Description Ontology",
          "lang": "en",
          "_id": "5a251b4e3d405e60384ebde6"
        }
      ]
    },
    {
      "nsp": "http://vocab.data.gov/def/fea#",
      "prefix": "fea",
      "uri": "http://vocab.data.gov/def/fea",
      "titles": [
        {
          "value": "Federal Enterprise Architecture Vocabulary",
          "lang": "en",
          "_id": "55abcb9c57613119099d7ba1"
        }
      ]
    },
    {
      "uri": "http://w3id.org/vcb/fel#",
      "nsp": "http://w3id.org/vcb/fel#",
      "prefix": "fel",
      "titles": [
        {
          "value": "A Fine-grained Entity Linking vocabulary",
          "lang": "en",
          "_id": "5db17ad35433bbf424c65993"
        }
      ]
    },
    {
      "nsp": "http://purl.org/iot/ontology/fiesta-iot#",
      "prefix": "fiesta-iot",
      "uri": "http://purl.org/iot/ontology/fiesta-iot",
      "titles": [
        {
          "value": "FIESTA-IoT Ontology",
          "lang": "en",
          "_id": "58e49ea8f6baaa6b1ab291bf"
        }
      ]
    },
    {
      "uri": "http://purl.org/iot/ontology/fiesta-priv#",
      "nsp": "http://purl.org/iot/ontology/fiesta-iot#",
      "prefix": "fiesta-priv",
      "titles": [
        {
          "value": "FIESTA-Priv Ontology",
          "lang": "en",
          "_id": "5f2d3298f1a48001181ada3f"
        }
      ]
    },
    {
      "nsp": "http://xmlns.com/foaf/0.1/",
      "prefix": "foaf",
      "uri": "http://xmlns.com/foaf/0.1/",
      "titles": [
        {
          "value": "Friend of a Friend vocabulary",
          "lang": "en",
          "_id": "5da81d9589eb3bf7665c24f3"
        }
      ]
    },
    {
      "uri": "https://w3id.org/fog",
      "nsp": "https://w3id.org/fog#",
      "prefix": "fog",
      "titles": [
        {
          "value": "FOG: File Ontology for Geometry formats",
          "lang": "en",
          "_id": "5d1c6a2eb97ed46e3dc5e191"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/FeatureOfInterestOntology/",
      "prefix": "foio",
      "uri": "https://w3id.org/seas/FeatureOfInterestOntology",
      "titles": [
        {
          "value": "The SEAS Feature of Interest ontology.",
          "lang": "en",
          "_id": "5841771b6002ada739d039d9"
        }
      ]
    },
    {
      "nsp": "http://data.lirmm.fr/ontologies/food#",
      "prefix": "food",
      "uri": "http://data.lirmm.fr/ontologies/food",
      "titles": [
        {
          "value": "Food Ontology",
          "lang": "en",
          "_id": "5dc00b8ab22aa88127c1ae0c"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#",
      "prefix": "fowl",
      "uri": "http://www.w3.org/TR/2003/PR-owl-guide-20031215/food",
      "titles": [
        {
          "value": "Food Ontology in OWL",
          "lang": "en",
          "_id": "56c595b82ba77c902f47551e"
        }
      ]
    },
    {
      "nsp": "http://iflastandards.info/ns/fr/frad/",
      "prefix": "frad",
      "uri": "http://iflastandards.info/ns/fr/frad/",
      "titles": [
        {
          "value": "FRAD model",
          "lang": "en",
          "_id": "55bcb4317459b3975b63cb10"
        }
      ]
    },
    {
      "nsp": "http://purl.org/cerif/frapo/",
      "prefix": "frapo",
      "uri": "http://purl.org/cerif/frapo/",
      "titles": [
        {
          "value": "Funding, Research Administration and Projects Ontology",
          "lang": "en",
          "_id": "586bad0d7e341093492c48ba"
        }
      ]
    },
    {
      "nsp": "http://streamreasoning.org/ontologies/frappe#",
      "prefix": "frappe",
      "uri": "http://streamreasoning.org/ontologies/frappe#",
      "titles": [
        {
          "value": "FraPPE: Frame, Pixel, Place, Event vocabulary",
          "lang": "en",
          "_id": "55258c6800191ee77225badd"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/frbr/core#",
      "prefix": "frbr",
      "uri": "http://purl.org/vocab/frbr/core",
      "titles": [
        {
          "value": "Expression of Core FRBR Concepts in RDF",
          "lang": "en",
          "_id": "55a9000a57613119099c4b61"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/frbr/extended#",
      "prefix": "frbre",
      "uri": "http://purl.org/vocab/frbr/extended",
      "titles": [
        {
          "value": "Extended FRBR",
          "lang": "en",
          "_id": "554740c3924aca1164f28a75"
        }
      ]
    },
    {
      "nsp": "http://iflastandards.info/ns/fr/frbr/frbrer/",
      "prefix": "frbrer",
      "uri": "http://iflastandards.info/ns/fr/frbr/frbrer/",
      "titles": [
        {
          "value": "FRBRer model",
          "lang": "en",
          "_id": "55bb69c17459b3975b63c0d5"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2004/09/fresnel#",
      "prefix": "fresnel",
      "uri": "http://www.w3.org/2004/09/fresnel",
      "titles": [
        {
          "value": "Fresnel Lens and Format Core Vocabulary",
          "lang": "en",
          "_id": "561c02da42fc695f7e67253d"
        }
      ]
    },
    {
      "nsp": "http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/",
      "prefix": "g50k",
      "uri": "http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/",
      "titles": [
        {
          "value": "50K Gazetteer Vocabulary",
          "lang": "en",
          "_id": "55bb5c687459b3975b63c03f"
        }
      ]
    },
    {
      "nsp": "http://data.totl.net/game/",
      "prefix": "game",
      "uri": "http://data.totl.net/game/",
      "titles": [
        {
          "value": "TotL Game Ontology",
          "lang": "en",
          "_id": "5784e0820183b1e80fc904e0"
        }
      ]
    },
    {
      "nsp": "http://www.oegov.org/core/owl/gc#",
      "prefix": "gc",
      "uri": "http://www.oegov.org/core/owl/gc",
      "titles": [
        {
          "value": "oeGOV Government Core Ontology",
          "lang": "en",
          "_id": "55d733fbe4ac2b1c4c5a5250"
        }
      ]
    },
    {
      "nsp": "http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#",
      "prefix": "gci",
      "uri": "http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl",
      "titles": [
        {
          "value": "Global City Indicator Foundation Ontology",
          "lang": "en",
          "_id": "552fa52bd945656b497885fc"
        }
      ]
    },
    {
      "uri": "https://w3id.org/GConsent",
      "nsp": "https://w3id.org/GConsent#",
      "prefix": "gcon",
      "titles": [
        {
          "value": "GConsent - a consent ontology based on the GDPR",
          "lang": "en",
          "_id": "5c62adf8a43464be5563cb3d"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov/def/govdata/",
      "prefix": "gd",
      "uri": "http://vocab.data.gov/gd",
      "titles": [
        {
          "value": "Government Data Vocabulary",
          "lang": "en",
          "_id": "55abd15a57613119099d7fb1"
        }
      ]
    },
    {
      "uri": "https://w3id.org/GDPRov",
      "nsp": "https://w3id.org/GDPRov#",
      "prefix": "gdprov",
      "titles": [
        {
          "value": "The GDPR Provenance ontology",
          "lang": "en",
          "_id": "5c62d070eff3ff9e5c8bc1de"
        }
      ]
    },
    {
      "uri": "https://w3id.org/GDPRtEXT",
      "nsp": "https://w3id.org/GDPRtEXT#",
      "prefix": "gdprt",
      "titles": [
        {
          "value": "GDPR text EXTensions",
          "lang": "en",
          "_id": "5c62cee4a43464be5563cbb9"
        }
      ]
    },
    {
      "nsp": "http://purl.org/gen/0.1#",
      "prefix": "gen",
      "uri": "http://purl.org/gen/0.1#",
      "titles": [
        {
          "value": "Vocabulary for Linked Genealogical Data",
          "lang": "en",
          "_id": "55d73681e4ac2b1c4c5a52c2"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2003/01/geo/wgs84_pos#",
      "prefix": "geo",
      "uri": "http://www.w3.org/2003/01/geo/wgs84_pos",
      "titles": [
        {
          "value": "WGS84 Geo Positioning",
          "lang": "en",
          "_id": "57696ba14a73263716312e53"
        }
      ]
    },
    {
      "nsp": "http://vocab.lenka.no/geo-deling#",
      "prefix": "geod",
      "uri": "http://vocab.lenka.no/geo-deling",
      "titles": [
        {
          "value": "Landinndelingen i Norge",
          "lang": "no",
          "_id": "568a5b4d4ee7f7176ff10efa"
        },
        {
          "value": "Administrative vocabulary for Norway",
          "lang": "en",
          "_id": "568a5b4d4ee7f7176ff10ef9"
        }
      ]
    },
    {
      "nsp": "http://www.mindswap.org/2003/owl/geo/geoFeatures20040307.owl#",
      "prefix": "geof",
      "uri": "http://www.mindswap.org/2003/owl/geo/geoFeatures20040307.owl",
      "titles": [
        {
          "value": "Geo Features",
          "lang": "en",
          "_id": "573347bab5cce30e4a3b7229"
        }
      ]
    },
    {
      "nsp": "http://data.ign.fr/def/geofla#",
      "prefix": "geofla",
      "uri": "http://data.ign.fr/def/geofla",
      "titles": [
        {
          "value": "Ontologie des unités administratives de l'IGN",
          "lang": "fr",
          "_id": "60b6037695b778e06b9a58d0"
        },
        {
          "value": "Ontology of administrative units at IGN-France",
          "lang": "en",
          "_id": "60b6037695b778e06b9a58cf"
        }
      ]
    },
    {
      "nsp": "http://data.ign.fr/def/geometrie#",
      "prefix": "geom",
      "uri": "http://data.ign.fr/def/geometrie",
      "titles": [
        {
          "value": "Ontologie des primitives géométriques",
          "lang": "fr",
          "_id": "568a54734ee7f7176ff10eac"
        },
        {
          "value": "Ontology for geometry",
          "lang": "en",
          "_id": "568a54734ee7f7176ff10eab"
        }
      ]
    },
    {
      "nsp": "http://aims.fao.org/aos/geopolitical.owl#",
      "prefix": "geop",
      "uri": "http://aims.fao.org/aos/geopolitical.owl",
      "titles": [
        {
          "value": "FAO Geopolitical Ontology",
          "lang": "en",
          "_id": "55bb5efa7459b3975b63c05b"
        }
      ]
    },
    {
      "nsp": "http://rdf.geospecies.org/ont/geospecies#",
      "prefix": "geosp",
      "uri": "http://rdf.geospecies.org/ont/geospecies",
      "titles": [
        {
          "value": "GeoSpecies Ontology",
          "lang": "en",
          "_id": "55ae8357cff711cc3f2b1949"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#",
      "prefix": "gf",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature",
      "titles": [
        {
          "value": "OWL representation of ISO 19109 (General Feature Model)",
          "lang": "en",
          "_id": "55a0fc2157613119099c1156"
        }
      ]
    },
    {
      "uri": "https://www.gleif.org/ontology/L1/",
      "nsp": "https://www.gleif.org/ontology/L1/",
      "prefix": "gleif-L1",
      "titles": [
        {
          "value": "Global Legal Entity Identifier Foundation Level 1 Ontology - Who Is Who",
          "lang": "en",
          "_id": "5d26300be239944f0e0582e1"
        }
      ]
    },
    {
      "uri": "https://www.gleif.org/ontology/L2/",
      "nsp": "https://www.gleif.org/ontology/L2/",
      "prefix": "gleif-L2",
      "titles": [
        {
          "value": "Global Legal Entity Identifier Foundation Level 2 Ontology - Who Owns Whom",
          "lang": "en",
          "_id": "5d2610eaa038485a10d98c53"
        }
      ]
    },
    {
      "uri": "https://www.gleif.org/ontology/Base/",
      "nsp": "https://www.gleif.org/ontology/Base/",
      "prefix": "gleif-base",
      "titles": [
        {
          "value": "Global Legal Entity Identifier Foundation Base Ontology",
          "lang": "en",
          "_id": "5d270fae7905867e22b4587d"
        }
      ]
    },
    {
      "uri": "https://www.gleif.org/ontology/EntityLegalForm/",
      "nsp": "https://www.gleif.org/ontology/EntityLegalForm/",
      "prefix": "gleif-elf",
      "titles": [
        {
          "value": "Entity Legal Form Ontology",
          "lang": "en",
          "_id": "5d2623eacfa360250be1fed3"
        }
      ]
    },
    {
      "uri": "https://www.gleif.org/ontology/Geocoding/",
      "nsp": "https://www.gleif.org/ontology/Geocoding/",
      "prefix": "gleif-geo",
      "titles": [
        {
          "value": "Global Legal Entity Identifier Foundation Geocoding Ontology",
          "lang": "en",
          "_id": "5d2610f4492085c310684b5e"
        }
      ]
    },
    {
      "uri": "https://www.gleif.org/ontology/RegistrationAuthority/",
      "nsp": "https://www.gleif.org/ontology/RegistrationAuthority/",
      "prefix": "gleif-ra",
      "titles": [
        {
          "value": "Global Legal Entity Identifier Foundation Registration Authority Ontology",
          "lang": "en",
          "_id": "5d2613419f33896f11e5b42a"
        }
      ]
    },
    {
      "uri": "https://www.gleif.org/ontology/ReportingException/",
      "nsp": "https://www.gleif.org/ontology/ReportingException/",
      "prefix": "gleif-repex",
      "titles": [
        {
          "value": "Global Legal Entity Identifier Foundation Reporting Exception Ontology",
          "lang": "en",
          "_id": "5d261b590189b6ed059c49e8"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#",
      "prefix": "gm",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry",
      "titles": [
        {
          "value": "OWL representation of ISO 19107 (Geographic Information)",
          "lang": "en",
          "_id": "55bcb0f07459b3975b63caf0"
        }
      ]
    },
    {
      "nsp": "http://www.opengis.net/ont/gml#",
      "prefix": "gml",
      "uri": "http://www.opengis.net/ont/gml",
      "titles": [
        {
          "value": "OGC Geometry",
          "lang": "en",
          "_id": "561e50dd42fc695f7e6770f9"
        }
      ]
    },
    {
      "nsp": "http://www.geonames.org/ontology#",
      "prefix": "gn",
      "uri": "http://www.geonames.org/ontology",
      "titles": [
        {
          "value": "The Geonames ontology",
          "lang": "en",
          "_id": "5f64bbffe19cb3b3685f7f9e"
        }
      ]
    },
    {
      "nsp": "http://d-nb.info/standards/elementset/gnd#",
      "prefix": "gndo",
      "uri": "http://d-nb.info/standards/elementset/gnd#",
      "titles": [
        {
          "value": "GND Ontology",
          "lang": "en",
          "_id": "552f7ca7d945656b497884b1"
        },
        {
          "value": "GND-Ontologie",
          "lang": "de",
          "_id": "552f7ca7d945656b497884b0"
        }
      ]
    },
    {
      "nsp": "http://purl.org/linguistics/gold/",
      "prefix": "gold",
      "uri": "http://purl.org/linguistics/gold",
      "titles": [
        {
          "value": "General Ontology for Linguistic Description",
          "lang": "en",
          "_id": "55d736c5e4ac2b1c4c5a52ce"
        }
      ]
    },
    {
      "uri": "https://w3id.org/gom",
      "nsp": "https://w3id.org/gom#",
      "prefix": "gom",
      "titles": [
        {
          "value": "GOM: Geometry Metadata Ontology",
          "lang": "en",
          "_id": "5db178e05433bbf424c6592b"
        }
      ]
    },
    {
      "nsp": "http://gov.genealogy.net/ontology.owl#",
      "prefix": "gov",
      "uri": "http://gov.genealogy.net/ontology.owl",
      "titles": [
        {
          "value": "Ontology for modelling historic administrative information.",
          "lang": "en",
          "_id": "55ba5d037459b3975b63b9cc"
        },
        {
          "value": "Ontologie zur Modellierung historischer Verwaltungsinformationen.",
          "lang": "de",
          "_id": "55ba5d037459b3975b63b9cb"
        }
      ]
    },
    {
      "nsp": "http://purl.org/goodrelations/v1#",
      "prefix": "gr",
      "uri": "http://purl.org/goodrelations/v1",
      "titles": [
        {
          "value": "The GoodRelations Ontology for Semantic Web-based E-Commerce",
          "lang": "en",
          "_id": "56c5972c2ba77c902f47557d"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2003/g/data-view#",
      "prefix": "grddl",
      "uri": "http://www.w3.org/2003/g/data-view",
      "titles": [
        {
          "value": "Gleaning Resource Descriptions from Dialects of Languages Vocabulary",
          "lang": "en",
          "_id": "555d0aaf30f688c94e823643"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2006/gen/ont#",
      "prefix": "gso",
      "uri": "http://www.w3.org/2006/gen/ont",
      "titles": [
        {
          "value": "Generic Specific Ontology",
          "lang": "en",
          "_id": "557f47351d5237e823d24eba"
        }
      ]
    },
    {
      "nsp": "http://www.opengis.net/ont/geosparql#",
      "prefix": "gsp",
      "uri": "http://www.opengis.net/ont/geosparql",
      "titles": [
        {
          "value": "OGC GeoSPARQL",
          "lang": "en",
          "_id": "5695030bff8848f96bd10004"
        }
      ]
    },
    {
      "nsp": "http://vocab.gtfs.org/terms#",
      "prefix": "gtfs",
      "uri": "http://vocab.gtfs.org/terms#",
      "titles": [
        {
          "value": "General Transit Feed Specification",
          "lang": "en",
          "_id": "569173f2b7cea413588f9751"
        }
      ]
    },
    {
      "nsp": "http://resource.geosciml.org/ontology/timescale/gts#",
      "prefix": "gts",
      "uri": "http://resource.geosciml.org/ontology/timescale/gts",
      "titles": [
        {
          "value": "Geologic Timescale model",
          "lang": "en",
          "_id": "598ade0488adb933350f5c0c"
        }
      ]
    },
    {
      "uri": "http://purl.org/nemo/gufo#",
      "nsp": "http://purl.org/nemo/gufo#",
      "prefix": "gufo",
      "titles": [
        {
          "value": "gUFO: A Lightweight Implementation of the Unified Foundational Ontology (UFO)",
          "lang": "en",
          "_id": "61a2b023599f8bcd3af0c255"
        }
      ]
    },
    {
      "nsp": "http://vocab.getty.edu/ontology#",
      "prefix": "gvp",
      "uri": "http://vocab.getty.edu/ontology",
      "titles": [
        {
          "value": "Getty Vocabulary Program ontology",
          "lang": "en",
          "_id": "554791ee13b634da681d20ff"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#",
      "prefix": "h2o",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic",
      "titles": [
        {
          "value": "Ontology for conversion of ISO/TC 211",
          "lang": "en",
          "_id": "55de157754ef107a63464ae9"
        }
      ]
    },
    {
      "nsp": "http://sensormeasurement.appspot.com/ont/home/homeActivity#",
      "prefix": "ha",
      "uri": "http://sensormeasurement.appspot.com/ont/home/homeActivity#",
      "titles": [
        {
          "value": "Home Activity",
          "lang": "en",
          "_id": "552b9a4b039260ce46e256fc"
        }
      ]
    },
    {
      "uri": "https://www.w3.org/2019/wot/hypermedia#",
      "nsp": "https://www.w3.org/2019/wot/hypermedia#",
      "prefix": "hctl",
      "titles": [
        {
          "value": "Hypermedia Controls Ontology",
          "lang": "en",
          "_id": "5ed4d6b5c7d84a2a049e424b"
        }
      ]
    },
    {
      "nsp": "http://www.samos.gr/ontologies/helpdeskOnto.owl#",
      "prefix": "hdo",
      "uri": "http://www.samos.gr/ontologies/helpdeskOnto.owl",
      "titles": [
        {
          "value": "HelpDesk support Ontology",
          "lang": "en",
          "_id": "569cc974ff8848f96bd16c87"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/hifm/ontology#",
      "prefix": "hifm",
      "uri": "http://purl.org/net/hifm/ontology#",
      "titles": [
        {
          "value": "HIFM Ontology",
          "lang": "en",
          "_id": "57c3f854a3a9d3a63d7aa354"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/holding#",
      "prefix": "holding",
      "uri": "http://purl.org/ontology/holding",
      "titles": [
        {
          "value": "Holding Ontology",
          "lang": "en"
        }
      ]
    },
    {
      "nsp": "http://health.data.gov/def/hospital/",
      "prefix": "hosp",
      "uri": "http://vocab.data.gov/hosp",
      "titles": [
        {
          "value": "Hospital Vocabulary",
          "lang": "en",
          "_id": "57d2795ca3a9d3a63d7e63e8"
        }
      ]
    },
    {
      "uri": "https://w3id.org/hpont",
      "nsp": "https://w3id.org/hpont#",
      "prefix": "hpont",
      "titles": [
        {
          "value": "The Heat Pump Ontology (HPOnt).",
          "lang": "en",
          "_id": "632477a4f0004aba7af3f7a9"
        }
      ]
    },
    {
      "nsp": "http://iserve.kmi.open.ac.uk/ns/hrests#",
      "prefix": "hr",
      "uri": "http://iserve.kmi.open.ac.uk/ns/hrests",
      "titles": [
        {
          "value": "hRESTS Ontology",
          "lang": "en",
          "_id": "569cc917ff8848f96bd16c76"
        }
      ]
    },
    {
      "nsp": "http://vcharpenay.github.io/hto/hto.xml#",
      "prefix": "hto",
      "uri": "http://vcharpenay.github.io/hto/hto.xml",
      "titles": [
        {
          "value": "Haystack Tagging Ontology",
          "lang": "en",
          "_id": "58099f8b3e5586c53d896497"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2011/http#",
      "prefix": "http",
      "uri": "http://www.w3.org/2011/http",
      "titles": [
        {
          "value": "HTTP in RDF",
          "lang": "en",
          "_id": "5691717db7cea413588f9641"
        }
      ]
    },
    {
      "nsp": "https://www.auto.tuwien.ac.at/downloads/thinkhome/ontology/WeatherOntology.owl",
      "prefix": "hw",
      "uri": "https://www.auto.tuwien.ac.at/downloads/thinkhome/ontology/WeatherOntology.owl",
      "titles": [
        {
          "value": "Home Weather",
          "lang": "en",
          "_id": "5809c7653e5586c53d897055"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/hydra/core#",
      "prefix": "hydra",
      "uri": "http://www.w3.org/ns/hydra/core",
      "titles": [
        {
          "value": "The Hydra Core Vocabulary",
          "lang": "en",
          "_id": "5acccfa03aba5caf50dbec41"
        }
      ]
    },
    {
      "uri": "https://w3id.org/iadopt/ont",
      "nsp": "https://w3id.org/iadopt/ont/",
      "prefix": "iadopt",
      "titles": [
        {
          "value": "I-ADOPT Framework ontology",
          "lang": "en",
          "_id": "638bc6a8e8d209386de14932"
        }
      ]
    },
    {
      "uri": "https://privatealpha.com/ontology/ibis/1#",
      "nsp": "https://privatealpha.com/ontology/ibis/1#",
      "prefix": "ibis",
      "titles": [
        {
          "value": "IBIS Vocabulary",
          "lang": "en",
          "_id": "5c628a18f5c09b905305f954"
        }
      ]
    },
    {
      "nsp": "http://ontology.eil.utoronto.ca/icontact.owl#",
      "prefix": "ic",
      "uri": "http://ontology.eil.utoronto.ca/icontact.owl",
      "titles": [
        {
          "value": "International Contact Ontology: Addresses, phone numbers and emails.",
          "lang": "en",
          "_id": "553602163cc9f6585db5255c"
        }
      ]
    },
    {
      "uri": "https://w3id.org/iddo",
      "nsp": "https://w3id.org/iddo#",
      "prefix": "iddo",
      "titles": [
        {
          "value": "The Interconnected Data Dictionary Ontology (IDDO)",
          "lang": "en",
          "_id": "638bca31e8d209386de14951"
        }
      ]
    },
    {
      "nsp": "http://rdf.insee.fr/def/demo#",
      "prefix": "idemo",
      "uri": "http://rdf.insee.fr/def/demo",
      "titles": [
        {
          "value": "Ontologie démographique de l'INSEE",
          "lang": "fr",
          "_id": "56916cc1b7cea413588f93c1"
        },
        {
          "value": "Demographic ontology from the French Statistics Institute",
          "lang": "en",
          "_id": "56916cc1b7cea413588f93c0"
        }
      ]
    },
    {
      "nsp": "http://www.identity.org/ontologies/identity.owl#",
      "prefix": "identity",
      "uri": "http://www.identity.org/ontologies/identity.owl",
      "titles": [
        {
          "value": "Ontology of digital identity.",
          "lang": "en",
          "_id": "56d2d48c85099278261131de"
        }
      ]
    },
    {
      "uri": "https://w3id.org/idsa/core",
      "nsp": "https://w3id.org/idsa/core/",
      "prefix": "ids",
      "titles": [
        {
          "value": "IDS Information Model",
          "lang": "en",
          "_id": "6001d546bdeefbd86ab78376"
        }
      ]
    },
    {
      "uri": "https://w3id.org/ifc/IFC4_ADD1",
      "nsp": "https://w3id.org/ifc/IFC4_ADD1#",
      "prefix": "ifc",
      "titles": [
        {
          "value": "IFC4_ADD1",
          "lang": "en",
          "_id": "5ecba7ee8217e3242789eb08"
        }
      ]
    },
    {
      "nsp": "http://rdf.insee.fr/def/geo#",
      "prefix": "igeo",
      "uri": "http://rdf.insee.fr/def/geo",
      "titles": [
        {
          "value": "Ontologie géographique de l'INSEE",
          "lang": "fr",
          "_id": "63761f7537bc29b307642007"
        },
        {
          "value": "French Statistical ontology for geolocation",
          "lang": "en",
          "_id": "63761f7537bc29b307642006"
        }
      ]
    },
    {
      "nsp": "http://data.ign.fr/def/ignf#",
      "prefix": "ignf",
      "uri": "http://data.ign.fr/def/ignf",
      "titles": [
        {
          "value": "Ontologie des systèmes de coordonnées de référence",
          "lang": "fr",
          "_id": "5783c1bd0183b1e80fc88032"
        },
        {
          "value": "Ontology of coordinates reference systems",
          "lang": "en",
          "_id": "5783c1bd0183b1e80fc88031"
        }
      ]
    },
    {
      "nsp": "http://imgpedia.dcc.uchile.cl/ontology#",
      "prefix": "imo",
      "uri": "http://imgpedia.dcc.uchile.cl/ontology",
      "titles": [
        {
          "value": "The IMGpedia Ontology",
          "lang": "en",
          "_id": "5aa783bd5177bf47192c0714"
        },
        {
          "value": "La Ontología de IMGpedia",
          "lang": "es",
          "_id": "5aa783bd5177bf47192c0713"
        }
      ]
    },
    {
      "nsp": "http://vocab.resc.info/incident#",
      "prefix": "incident",
      "uri": "http://vocab.resc.info/incident",
      "titles": [
        {
          "value": "Vocabulary to describe incident response by emergency services",
          "lang": "en",
          "_id": "55da25a88b5f9f281f4c453b"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
      "prefix": "infor",
      "uri": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl",
      "titles": [
        {
          "value": "Information Realization",
          "lang": "en",
          "_id": "56a3c65937d8a8044b254263"
        }
      ]
    },
    {
      "nsp": "http://purl.org/innovation/ns#",
      "prefix": "inno",
      "uri": "http://purl.org/innovation/ns",
      "titles": [
        {
          "value": "Ontology for Innovation",
          "lang": "en",
          "_id": "55de165654ef107a63464afd"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov.uk/def/intervals/",
      "prefix": "interval",
      "uri": "http://reference.data.gov.uk/def/intervals",
      "titles": [
        {
          "value": "Intervals Ontology",
          "lang": "en",
          "_id": "5dace34e8b936c5b59e22abc"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#",
      "prefix": "iol",
      "uri": "http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl",
      "titles": [
        {
          "value": "Information Objects ontology",
          "lang": "en",
          "_id": "569cc936ff8848f96bd16c7c"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/UNIS/fiware/iot-lite#",
      "prefix": "iot-lite",
      "uri": "http://purl.oclc.org/NET/UNIS/fiware/iot-lite#",
      "titles": [
        {
          "value": "Iot-lite ontology",
          "lang": "en",
          "_id": "5809c5053e5586c53d896de3"
        }
      ]
    },
    {
      "uri": "https://w3id.org/iot-tta/",
      "nsp": "https://w3id.org/iot-tta/#",
      "prefix": "iot-tta",
      "titles": [
        {
          "value": "Ontology for Internet of Things Technologies, Tools, and Applications",
          "lang": "en",
          "_id": "632b41fac4f7e5f619d4447d"
        }
      ]
    },
    {
      "nsp": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#",
      "prefix": "ioto",
      "uri": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-O",
      "titles": [
        {
          "value": "IoT-O",
          "lang": "en",
          "_id": "5809c4e03e5586c53d896dba"
        }
      ]
    },
    {
      "uri": "http://purl.org/iot/vocab/iot-taxonomy-lite#",
      "nsp": "http://purl.org/iot/vocab/iot-taxonomy-lite#",
      "prefix": "iottaxolite",
      "titles": [
        {
          "value": "The IoTTaxonomy-lite Taxonomy",
          "lang": "en",
          "_id": "602287f265d8a4db28f18488"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ipo/core#",
      "prefix": "ipo",
      "uri": "http://purl.org/ipo/core",
      "titles": [
        {
          "value": "IPO - Issue Procedure Ontology",
          "lang": "en",
          "_id": "55e412bca71142386b779a15"
        }
      ]
    },
    {
      "uri": "http://ontology.ethereal.cz/irao",
      "nsp": "http://ontology.ethereal.cz/irao/",
      "prefix": "irao",
      "titles": [
        {
          "value": "Informatics Research Artifacts Ontology",
          "lang": "en",
          "_id": "60afcbe8c3818f4546035954"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/ont/web/irw.owl#",
      "prefix": "irw",
      "uri": "http://www.ontologydesignpatterns.org/ont/web/irw.owl",
      "titles": [
        {
          "value": "The Identity of Resources on the Web ontology",
          "lang": "en",
          "_id": "55de1a0754ef107a63464b2b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/is/core#",
      "prefix": "is",
      "uri": "http://purl.org/ontology/is/core#",
      "titles": [
        {
          "value": "Info Service Ontology",
          "lang": "en",
          "_id": "55e0591c419d00687563ad6d"
        }
      ]
    },
    {
      "nsp": "http://iflastandards.info/ns/isbd/elements/",
      "prefix": "isbd",
      "uri": "http://iflastandards.info/ns/isbd/elements/",
      "titles": [
        {
          "value": "ISBD elements",
          "lang": "en"
        }
      ]
    },
    {
      "nsp": "http://purl.org/iso25964/skos-thes#",
      "prefix": "iso-thes",
      "uri": "http://purl.org/iso25964/skos-thes",
      "titles": [
        {
          "value": "ISO 25964 SKOS extension",
          "lang": "en",
          "_id": "56a63acf37d8a8044b263a2b"
        }
      ]
    },
    {
      "nsp": "http://ontology.eil.utoronto.ca/ISO37120.owl#",
      "prefix": "iso37120",
      "uri": "http://ontology.eil.utoronto.ca/ISO37120.owl",
      "titles": [
        {
          "value": "ISO 37120 indicator URIs",
          "lang": "en",
          "_id": "5817292fc1b1a26b516f855f"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov.au/def/ont/iso19160-1-address#",
      "prefix": "isoadr",
      "uri": "http://reference.data.gov.au/def/ont/iso19160-1-address",
      "titles": [
        {
          "value": "ISO19160-1:2015 Address ontology",
          "lang": "en",
          "_id": "5a414a9fb201efd03d3b0079"
        }
      ]
    },
    {
      "nsp": "http://dati.isprambiente.it/ontology/core#",
      "prefix": "ispra",
      "uri": "http://dati.isprambiente.it/ontology/core#",
      "titles": [
        {
          "value": "Ispra Ontology",
          "lang": "en",
          "_id": "572ddb95b5cce30e4a39ab28"
        }
      ]
    },
    {
      "uri": "https://data.istex.fr/ontology/istex#",
      "nsp": "https://data.istex.fr/ontology/istex#",
      "prefix": "istex",
      "titles": [
        {
          "value": "Ontologie du projet Istex pour la diffusion de la littérature scientifique",
          "lang": "fr",
          "_id": "5cc83e583c9ea81c2a69aa8f"
        },
        {
          "value": "Istex ontology for scholarly documents and extracted entities",
          "lang": "en",
          "_id": "5cc83e583c9ea81c2a69aa8e"
        }
      ]
    },
    {
      "nsp": "http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#",
      "prefix": "itm",
      "uri": "http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0",
      "titles": [
        {
          "value": "Issue Tracking tool Model",
          "lang": "en",
          "_id": "55abd6f157613119099d83cd"
        }
      ]
    },
    {
      "nsp": "http://ontology.it/itsmo/v1#",
      "prefix": "itsmo",
      "uri": "http://ontology.it/itsmo/v1",
      "titles": [
        {
          "value": "IT Service Management Ontology",
          "lang": "en",
          "_id": "567e6e9d4ee7f7176fea7b75"
        }
      ]
    },
    {
      "uri": "https://www.w3.org/2019/wot/json-schema#",
      "nsp": "https://www.w3.org/2019/wot/json-schema#",
      "prefix": "jsonsc",
      "titles": [
        {
          "value": "JSON Schema in RDF",
          "lang": "en",
          "_id": "5ed4d78ec7d84a2a049e4251"
        }
      ]
    },
    {
      "nsp": "http://w3id.org/charta77/jup/",
      "prefix": "jup",
      "uri": "http://w3id.org/charta77/jup",
      "titles": [
        {
          "value": "Ontology of Building Accessibility",
          "lang": "en",
          "_id": "57d2a8f2a3a9d3a63d7e79fc"
        },
        {
          "value": "Slovnik pristupnosti budov",
          "lang": "cs",
          "_id": "57d2a8f2a3a9d3a63d7e79fb"
        }
      ]
    },
    {
      "nsp": "http://rdfs.co/juso/",
      "prefix": "juso",
      "uri": "http://rdfs.co/juso/",
      "titles": [
        {
          "value": "Juso Ontology",
          "lang": "en",
          "_id": "5613a12442fc695f7e64c70e"
        }
      ]
    },
    {
      "nsp": "http://rdfs.co/juso/kr/",
      "prefix": "juso.kr",
      "uri": "http://rdfs.co/juso/kr/",
      "titles": [
        {
          "value": "South Korea Extension to Juso Ontology",
          "lang": "en",
          "_id": "5614e3a342fc695f7e657bd0"
        },
        {
          "value": "대한민국 주소 온톨로지",
          "lang": "ko",
          "_id": "5614e3a342fc695f7e657bcf"
        }
      ]
    },
    {
      "nsp": "http://kdo.render-project.eu/kdo#",
      "prefix": "kdo",
      "uri": "http://kdo.render-project.eu/kdo#",
      "titles": [
        {
          "value": "The Knowledge Diversity Ontology",
          "lang": "en",
          "_id": "55e05790419d00687563ad4f"
        }
      ]
    },
    {
      "nsp": "http://linkeddata.center/kees/v1#",
      "prefix": "kees",
      "uri": "http://linkeddata.center/kees/v1",
      "titles": [
        {
          "value": "KEES Ontology",
          "lang": "en",
          "_id": "5710e08a31bafaef0e789576"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/c4dm/keys.owl#",
      "prefix": "keys",
      "uri": "http://purl.org/NET/c4dm/keys.owl",
      "titles": [
        {
          "value": "Keys Ontology",
          "lang": "en",
          "_id": "555d070c30f688c94e823631"
        }
      ]
    },
    {
      "nsp": "http://www.disit.org/km4city/schema#",
      "prefix": "km4c",
      "uri": "http://www.disit.org/km4city/schema",
      "titles": [
        {
          "value": "km4city, the DISIT Knowledge Model for City and Mobility",
          "lang": "en",
          "_id": "58171988c1b1a26b516f78f9"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/vocab/2004/03/label#",
      "prefix": "label",
      "uri": "http://purl.org/net/vocab/2004/03/label",
      "titles": [
        {
          "value": "label",
          "lang": "en",
          "_id": "55a8dfaa57613119099c4a7b"
        }
      ]
    },
    {
      "nsp": "http://lawd.info/ontology/",
      "prefix": "lawd",
      "uri": "http://lawd.info/ontology/",
      "titles": [
        {
          "value": "Linking Ancient World Data Ontology",
          "lang": "en",
          "_id": "56a6015237d8a8044b262bda"
        }
      ]
    },
    {
      "uri": "http://semweb.mmlab.be/ns/linkedconnections#Ontology",
      "nsp": "http://semweb.mmlab.be/ns/linkedconnections#",
      "prefix": "lc",
      "titles": [
        {
          "value": "The Linked Connections ontology",
          "lang": "en",
          "_id": "61a4ab96bf34bcf5590f0330"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/lifecycle/schema#",
      "prefix": "lcy",
      "uri": "http://purl.org/vocab/lifecycle/schema",
      "titles": [
        {
          "value": "Lifecycle Schema",
          "lang": "en",
          "_id": "55620c7bfcb9d2f34824a7f4"
        }
      ]
    },
    {
      "uri": "https://w3id.org/ldes",
      "nsp": "https://w3id.org/ldes#",
      "prefix": "ldes",
      "titles": [
        {
          "value": "The Linked Data Event Streams specification",
          "lang": "en",
          "_id": "63173f41b813c51c1e077290"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/ldp#",
      "prefix": "ldp",
      "uri": "http://www.w3.org/ns/ldp#",
      "titles": [
        {
          "value": "Linked Data Platform",
          "lang": "en",
          "_id": "5733444fb5cce30e4a3b71fd"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/ldr/ns#",
      "prefix": "ldr",
      "uri": "http://purl.oclc.org/NET/ldr/ns#",
      "titles": [
        {
          "value": "Linked Data Rights (LDR)",
          "lang": "en",
          "_id": "55bcb39f7459b3975b63cb0a"
        }
      ]
    },
    {
      "nsp": "http://linked.opendata.cz/ontology/ldvm/",
      "prefix": "ldvm",
      "uri": "http://linked.opendata.cz/ontology/ldvm/",
      "titles": [
        {
          "value": "Vocabulary for Linked Data Visualization Model",
          "lang": "en"
        }
      ]
    },
    {
      "nsp": "http://lemon-model.net/lemon#",
      "prefix": "lemon",
      "uri": "http://lemon-model.net/lemon",
      "titles": [
        {
          "value": "LExicon Model for ONtologies",
          "lang": "en",
          "_id": "578635a28c6f955d29be1bc4"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/lemon/decomp",
      "nsp": "http://www.w3.org/ns/lemon/decomp#",
      "prefix": "lexdcp",
      "titles": [
        {
          "value": "Lexicon Model for Ontologies - Decomp",
          "lang": "en",
          "_id": "60d077156eec354e1dfe3dec"
        }
      ]
    },
    {
      "nsp": "http://www.lexinfo.net/ontology/2.0/lexinfo#",
      "prefix": "lexinfo",
      "uri": "http://www.lexinfo.net/ontology/2.0/lexinfo",
      "titles": [
        {
          "value": "LexInfo Ontology",
          "lang": "en",
          "_id": "57861e058c6f955d29be10ab"
        }
      ]
    },
    {
      "nsp": "http://linkedgeodata.org/ontology/",
      "prefix": "lgdo",
      "uri": "http://linkedgeodata.org/ontology",
      "titles": [
        {
          "value": "LinkedGeoData ontology",
          "lang": "en",
          "_id": "622b5375eb61c6004398e0a0"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#",
      "prefix": "li",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage",
      "titles": [
        {
          "value": "OWL representation of ISO 19115 (Geographic Information - Metadata - Lineage package)",
          "lang": "en",
          "_id": "56a3c54c37d8a8044b2541c3"
        }
      ]
    },
    {
      "nsp": "http://purl.org/library/",
      "prefix": "lib",
      "uri": "http://purl.org/library/",
      "titles": [
        {
          "value": "Library extension of schema.org",
          "lang": "en",
          "_id": "569cc766ff8848f96bd16c3f"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/lifecycle/schema#",
      "prefix": "lifecycle",
      "uri": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-Lifecycle",
      "titles": [
        {
          "value": "IoT-Lifecycle",
          "lang": "en",
          "_id": "57111d1931bafaef0e78a6c0"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/lemon/lime",
      "nsp": "http://www.w3.org/ns/lemon/lime#",
      "prefix": "lime",
      "titles": [
        {
          "value": "Lexicon Model for Ontologies - LIngusitic MEtadata (LIME)",
          "lang": "en",
          "_id": "60d0a175ea2950ca21ba47cc"
        }
      ]
    },
    {
      "nsp": "http://purl.org/limo-ontology/limo#",
      "prefix": "limo",
      "uri": "http://purl.org/limo-ontology/limo/",
      "titles": [
        {
          "value": "Linked Statistical Models Vocabulary",
          "lang": "en",
          "_id": "55bb656f7459b3975b63c09f"
        }
      ]
    },
    {
      "nsp": "http://purl.org/LiMo/0.1#",
      "prefix": "limoo",
      "uri": "http://purl.org/LiMo/0.1#",
      "titles": [
        {
          "value": "License Model Ontology",
          "lang": "en",
          "_id": "55e01bf654ef107a63465d23"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/vocab/lingvoj#",
      "prefix": "lingvo",
      "uri": "https://w3id.org/vocab/lingvoj",
      "titles": [
        {
          "value": "The Lingvoj Ontology",
          "lang": "en",
          "_id": "5ee35dd341346a864572f1a6"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/lio#",
      "prefix": "lio",
      "uri": "http://purl.org/net/lio",
      "titles": [
        {
          "value": "Lightweight Image Ontology",
          "lang": "en",
          "_id": "59a69ac37845e44d19bfa1b4"
        }
      ]
    },
    {
      "nsp": "http://www.linklion.org/ontology#",
      "prefix": "llont",
      "uri": "http://www.linklion.org/ontology",
      "titles": [
        {
          "value": "LinkLion - the Link Discovery Portal",
          "lang": "en",
          "_id": "57d2cfa9a3a9d3a63d7e8bc2"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#",
      "prefix": "lmm1",
      "uri": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl",
      "titles": [
        {
          "value": "Lexical MetaModel Level 1",
          "lang": "en",
          "_id": "56a3c5e537d8a8044b25421b"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#",
      "prefix": "lmm2",
      "uri": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl",
      "titles": [
        {
          "value": "Lexical MetaModel Level 2",
          "lang": "en",
          "_id": "56a3c60f37d8a8044b254234"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ctic/infraestructuras/localizacion#",
      "prefix": "loc",
      "uri": "http://purl.org/ctic/infraestructuras/localizacion",
      "titles": [
        {
          "value": "Vocabulario de Localizaciones",
          "lang": "es",
          "_id": "555a773e30f688c94e8201e6"
        },
        {
          "value": "Location Vocabulary",
          "lang": "en",
          "_id": "555a773e30f688c94e8201e5"
        }
      ]
    },
    {
      "nsp": "http://data.archiveshub.ac.uk/def/",
      "prefix": "locah",
      "uri": "http://data.archiveshub.ac.uk/def/",
      "titles": [
        {
          "value": "The LOCAH RDF Vocabulary",
          "lang": "en",
          "_id": "5697b6b0ff8848f96bd12afc"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/locn#",
      "prefix": "locn",
      "uri": "http://www.w3.org/ns/locn",
      "titles": [
        {
          "value": "ISA Programme Location Core Vocabulary",
          "lang": "en",
          "_id": "571f36f1b5cce30e4a2f1a9f"
        }
      ]
    },
    {
      "nsp": "http://linkedevents.org/ontology/",
      "prefix": "lode",
      "uri": "http://linkedevents.org/ontology/",
      "titles": [
        {
          "value": "Linking Open Descriptions of Events",
          "lang": "en",
          "_id": "5a36c915ece6c50213eee55b"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2000/10/swap/log#",
      "prefix": "log",
      "uri": "http://www.w3.org/2000/10/swap/log",
      "titles": [
        {
          "value": "SWAP Logic Ontology",
          "lang": "en",
          "_id": "61ae2ca65b2c78953fa51b94"
        }
      ]
    },
    {
      "nsp": "http://data.opendiscoveryspace.eu/lom_ontology_ods.owl#",
      "prefix": "lom",
      "uri": "http://data.opendiscoveryspace.eu/lom_ontology_ods.owl",
      "titles": [
        {
          "value": "Learning Object Metadata Ontology",
          "lang": "en"
        }
      ]
    },
    {
      "nsp": "http://sparql.sstu.ru:3030/speciality/",
      "prefix": "losp",
      "uri": "http://sparql.sstu.ru:3030/speciality/",
      "titles": [
        {
          "value": "Linked open specialities RF",
          "lang": "en",
          "_id": "5ab1346e5177bf47193949fe"
        },
        {
          "value": "Открытые связанные специальности РФ",
          "lang": "ru",
          "_id": "5ab1346e5177bf47193949fd"
        }
      ]
    },
    {
      "nsp": "http://loted.eu/ontology#",
      "prefix": "loted",
      "uri": "http://loted.eu/ontology",
      "titles": [
        {
          "value": "LOTED ontology",
          "lang": "en",
          "_id": "552799fb324d21a7430fdcf5"
        }
      ]
    },
    {
      "nsp": "http://linkedscience.org/lsc/ns#",
      "prefix": "lsc",
      "uri": "http://linkedscience.org/lsc/ns#",
      "titles": [
        {
          "value": "Linked Science Core Vocabulary",
          "lang": "en",
          "_id": "55e0609ca71142386b776210"
        }
      ]
    },
    {
      "nsp": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#",
      "prefix": "lslife",
      "uri": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl",
      "titles": [
        {
          "value": "ELSEWeb Lifemapper Ontology",
          "lang": "en",
          "_id": "56af78b098f0192c57ea948c"
        }
      ]
    },
    {
      "nsp": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
      "prefix": "lsmap",
      "uri": "http://ontology.cybershare.utep.edu/ELSEWeb/mappings/elseweb-mappings.owl",
      "titles": [
        {
          "value": "ELSEWeb Mappings Ontology",
          "lang": "en",
          "_id": "56af7a8398f0192c57ea95f3"
        }
      ]
    },
    {
      "nsp": "http://lsq.aksw.org/vocab#",
      "prefix": "lsq",
      "uri": "http://lsq.aksw.org/vocab",
      "titles": [
        {
          "value": "The Linked SPARQL Queries Vocabulary (LSQ(V))",
          "lang": "en",
          "_id": "5735f14fb5cce30e4a3baa61"
        }
      ]
    },
    {
      "nsp": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
      "prefix": "lsweb",
      "uri": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl",
      "titles": [
        {
          "value": "ELSEWeb Data Ontology",
          "lang": "en",
          "_id": "561b8f5542fc695f7e6722c8"
        }
      ]
    },
    {
      "nsp": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#",
      "prefix": "lswmo",
      "uri": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl",
      "titles": [
        {
          "value": "ELSEWeb Modelling Ontology",
          "lang": "en",
          "_id": "561e315342fc695f7e6767fd"
        }
      ]
    },
    {
      "nsp": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#",
      "prefix": "lswpm",
      "uri": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl",
      "titles": [
        {
          "value": "ELSEWeb Lifemapper Parameters Ontology",
          "lang": "en",
          "_id": "56af79d398f0192c57ea9561"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/ludo",
      "prefix": "ludo",
      "uri": "http://ns.inria.fr/ludo",
      "titles": [
        {
          "value": "Ludo Ontology",
          "lang": "en",
          "_id": "57349da9b5cce30e4a3b874d"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/ludo/v1/gamemodel#",
      "prefix": "ludo-gm",
      "uri": "http://ns.inria.fr/ludo/v1/gamemodel#",
      "titles": [
        {
          "value": "Ludo Game Model Ontology",
          "lang": "en",
          "_id": "57bfe97aa3a9d3a63d791bf7"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/ludo/v1/gamepresentation#",
      "prefix": "ludo-gp",
      "uri": "http://ns.inria.fr/ludo/v1/gamepresentation#",
      "titles": [
        {
          "value": "Ludo - Game Presentation",
          "lang": "en",
          "_id": "57bfe970a3a9d3a63d791bec"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/ludo/v1/virtualcontext#",
      "prefix": "ludo-vc",
      "uri": "http://ns.inria.fr/ludo/v1/virtualcontext#",
      "titles": [
        {
          "value": "Ludo - Virtual Context",
          "lang": "en",
          "_id": "57bfe6bda3a9d3a63d791ab0"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/ludo/v1/xapi#",
      "prefix": "ludo-xapi",
      "uri": "http://ns.inria.fr/ludo/v1/xapi",
      "titles": [
        {
          "value": "Experience API (xAPI)",
          "lang": "en",
          "_id": "5734a02fb5cce30e4a3b8783"
        }
      ]
    },
    {
      "nsp": "http://purl.org/lobid/lv#",
      "prefix": "lv",
      "uri": "http://purl.org/lobid/lv",
      "titles": [
        {
          "value": "lobid vocab",
          "lang": "en",
          "_id": "55bb5a4b7459b3975b63c02e"
        }
      ]
    },
    {
      "nsp": "http://lexvo.org/ontology#",
      "prefix": "lvont",
      "uri": "http://lexvo.org/ontology",
      "titles": [
        {
          "value": "Lexvo.org Ontology",
          "lang": "en",
          "_id": "555df44ffcb9d2f348248664"
        }
      ]
    },
    {
      "nsp": "http://purl.org/linkingyou/",
      "prefix": "lyou",
      "uri": "http://purl.org/linkingyou/",
      "titles": [
        {
          "value": "Linking-you vocabulary",
          "lang": "en"
        }
      ]
    },
    {
      "nsp": "http://purl.org/iot/vocab/m3-lite#",
      "prefix": "m3lite",
      "uri": "http://purl.org/iot/vocab/m3-lite#",
      "titles": [
        {
          "value": "The Machine-to-Machine Measurement (M3) Lite Ontology",
          "lang": "en",
          "_id": "59b147832ab721804e285a65"
        }
      ]
    },
    {
      "uri": "http://w3id.org/nfdi4ing/metadata4ing#",
      "nsp": "http://w3id.org/nfdi4ing/metadata4ing#",
      "prefix": "m4i",
      "titles": [
        {
          "value": "Metadata4Ing: An ontology for describing the generation of research data within a scientific activity.",
          "lang": "en",
          "_id": "62306164eb61c60043990f31"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/ma-ont#",
      "prefix": "ma-ont",
      "uri": "http://www.w3.org/ns/ma-ont",
      "titles": [
        {
          "value": "Ontology for Media Resources",
          "lang": "en",
          "_id": "56d067a9ec7d5661016d05fc"
        }
      ]
    },
    {
      "nsp": "http://www.loc.gov/mads/rdf/v1#",
      "prefix": "mads",
      "uri": "http://www.loc.gov/mads/rdf/v1",
      "titles": [
        {
          "value": "Metadata Authority Description Schema",
          "lang": "en",
          "_id": "567e70384ee7f7176fea7b81"
        }
      ]
    },
    {
      "nsp": "http://www.gsi.dit.upm.es/ontologies/marl/ns#",
      "prefix": "marl",
      "uri": "http://www.gsi.dit.upm.es/ontologies/marl/ns",
      "titles": [
        {
          "value": "Marl Ontology Specification",
          "lang": "en",
          "_id": "56a69a7237d8a8044b26685d"
        }
      ]
    },
    {
      "nsp": "http://securitytoolbox.appspot.com/MASO#",
      "prefix": "maso",
      "uri": "http://securitytoolbox.appspot.com/MASO",
      "titles": [
        {
          "value": "Sécurité Agents Mobiles",
          "lang": "fr",
          "_id": "55489271e83552eb70883987"
        },
        {
          "value": "Mobile Agents Security",
          "lang": "en",
          "_id": "55489271e83552eb70883986"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/metadata#",
      "prefix": "md",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/metadata",
      "titles": [
        {
          "value": "OWL representation of ISO 19115",
          "lang": "en",
          "_id": "56065adb8f7ad2ce3438d5c4"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/multidimensional-interface/ontology#",
      "prefix": "mdi",
      "uri": "https://w3id.org/multidimensional-interface/ontology",
      "titles": [
        {
          "value": "RDF vocabulary to describe a Multidimensional Interface.",
          "lang": "en",
          "_id": "577d245f0183b1e80fc65e65"
        }
      ]
    },
    {
      "uri": "https://w3id.org/mdo/full/",
      "nsp": "https://w3id.org/mdo/full/",
      "prefix": "mdo",
      "titles": [
        {
          "value": "Materials Design Ontology - Full",
          "lang": "en",
          "_id": "6001d9461d5b17af6c25a04f"
        }
      ]
    },
    {
      "uri": "https://w3id.org/mdo/calculation/",
      "nsp": "https://w3id.org/mdo/calculation/",
      "prefix": "mdo-calc",
      "titles": [
        {
          "value": "Materials Design Ontology - Calculation Module",
          "lang": "en",
          "_id": "6001de85e34ba6a36fadabaa"
        }
      ]
    },
    {
      "uri": "https://w3id.org/mdo/structure/",
      "nsp": "https://w3id.org/mdo/structure/",
      "prefix": "mdo-struc",
      "titles": [
        {
          "value": "Materials Design Ontology - Structure Module",
          "lang": "en",
          "_id": "6001dbda6f98d1eb6e6d705f"
        }
      ]
    },
    {
      "uri": "https://w3id.org/mdo/provenance/",
      "nsp": "https://w3id.org/mdo/provenance/",
      "prefix": "mdoprov",
      "titles": [
        {
          "value": "Materials Design Ontology - Provenance Module",
          "lang": "en",
          "_id": "63248769f0004aba7af3f862"
        }
      ]
    },
    {
      "uri": "http://semanticturkey.uniroma2.it/ns/mdr",
      "nsp": "http://semanticturkey.uniroma2.it/ns/mdr#",
      "prefix": "mdr",
      "titles": [
        {
          "value": "The Semantic Turkey metadata registry ontology",
          "lang": "en",
          "_id": "6324837df0004aba7af3f813"
        }
      ]
    },
    {
      "nsp": "http://rdf.myexperiment.org/ontologies/base/",
      "prefix": "meb",
      "uri": "http://rdf.myexperiment.org/ontologies/base/",
      "titles": [
        {
          "value": "The myExperiment Base Ontology",
          "lang": "en",
          "_id": "63248285f0004aba7af3f802"
        }
      ]
    },
    {
      "nsp": "http://purl.org/media#",
      "prefix": "media",
      "uri": "http://purl.org/media",
      "titles": [
        {
          "value": "The Media RDF Vocabulary",
          "lang": "en",
          "_id": "63248217f0004aba7af3f7f2"
        }
      ]
    },
    {
      "nsp": "http://w3id.org/medred/medred#",
      "prefix": "medred",
      "uri": "http://w3id.org/medred/medred#",
      "titles": [
        {
          "value": "MedRed ontology: clinical data acquisition model",
          "lang": "en",
          "_id": "632480faf0004aba7af3f7e4"
        },
        {
          "value": "MedRed ontologie: modèle d'aquisition de données cliniques",
          "lang": "fr",
          "_id": "632480faf0004aba7af3f7e3"
        },
        {
          "value": "Ontología MedRed: modelo de adquisición de datos clínicos",
          "lang": "es",
          "_id": "632480faf0004aba7af3f7e2"
        }
      ]
    },
    {
      "nsp": "http://mex.aksw.org/mex-algo#",
      "prefix": "mexalgo",
      "uri": "http://mex.aksw.org/mex-algo",
      "titles": [
        {
          "value": "MEX Algorithm Ontology",
          "lang": "en",
          "_id": "63247e50f0004aba7af3f7d3"
        }
      ]
    },
    {
      "nsp": "http://mex.aksw.org/mex-core#",
      "prefix": "mexcore",
      "uri": "http://mex.aksw.org/mex-core",
      "titles": [
        {
          "value": "MEX Core Vocabulary",
          "lang": "en",
          "_id": "632480aff0004aba7af3f7dc"
        },
        {
          "value": "Vocabulario MEX (mex-core)",
          "lang": "pt",
          "_id": "632480aff0004aba7af3f7db"
        }
      ]
    },
    {
      "nsp": "http://mex.aksw.org/mex-perf#",
      "prefix": "mexperf",
      "uri": "http://mex.aksw.org/mex-perf",
      "titles": [
        {
          "value": "MEX Performance Ontology",
          "lang": "en",
          "_id": "63248181f0004aba7af3f7ec"
        }
      ]
    },
    {
      "nsp": "http://rdf.muninn-project.org/ontologies/military#",
      "prefix": "mil",
      "uri": "http://rdf.muninn-project.org/ontologies/military",
      "titles": [
        {
          "value": "Military Ontology Specification",
          "lang": "en",
          "_id": "6324825ef0004aba7af3f7fa"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/mls#",
      "prefix": "mls",
      "uri": "http://www.w3.org/ns/mls",
      "titles": [
        {
          "value": "Machine Learning Schema",
          "lang": "en",
          "_id": "63248323f0004aba7af3f80d"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/mo/",
      "prefix": "mo",
      "uri": "http://purl.org/ontology/mo/",
      "titles": [
        {
          "value": "Music Ontology",
          "lang": "en",
          "_id": "632487d8f0004aba7af3f866"
        }
      ]
    },
    {
      "nsp": "http://observedchange.com/moac/ns#",
      "prefix": "moac",
      "uri": "http://www.observedchange.com/moac/ns#",
      "titles": [
        {
          "value": "Management of a Crisis Vocabulary",
          "lang": "en",
          "_id": "632488d0f0004aba7af3f886"
        }
      ]
    },
    {
      "nsp": "http://moat-project.org/ns#",
      "prefix": "moat",
      "uri": "http://moat-project.org/ns#",
      "titles": [
        {
          "value": "Meaning of a Tag Ontology",
          "lang": "en",
          "_id": "63248acbf0004aba7af3f89f"
        }
      ]
    },
    {
      "uri": "http://www.isibang.ac.in/ns/mod",
      "nsp": "http://www.isibang.ac.in/ns/mod#",
      "prefix": "mod",
      "titles": [
        {
          "value": "MOD: Metadata for Ontology Description and publication",
          "lang": "en",
          "_id": "63248b3cf0004aba7af3f8a7"
        }
      ]
    },
    {
      "uri": "https://w3id.org/skgo/modsci#",
      "nsp": "https://w3id.org/skgo/modsci#",
      "prefix": "modsci",
      "titles": [
        {
          "value": "ModSci, Modern Science Ontology.",
          "lang": "en",
          "_id": "63a2ecdcd36ad4e74e6fbf1c"
        }
      ]
    },
    {
      "nsp": "http://id.loc.gov/vocabulary/relators/",
      "prefix": "mrel",
      "uri": "http://id.loc.gov/vocabulary/relators",
      "titles": [
        {
          "value": "MARC Code List for Relators",
          "lang": "en",
          "_id": "56a3c44437d8a8044b254130"
        }
      ]
    },
    {
      "nsp": "http://iserve.kmi.open.ac.uk/ns/msm#",
      "prefix": "msm",
      "uri": "http://iserve.kmi.open.ac.uk/ns/msm",
      "titles": [
        {
          "value": "Minimal Service Model",
          "lang": "en",
          "_id": "586ba9fb7e341093492c486d"
        }
      ]
    },
    {
      "nsp": "http://www.telegraphis.net/ontology/measurement/measurement#",
      "prefix": "msr",
      "uri": "http://www.telegraphis.net/ontology/measurement/measurement#",
      "titles": [
        {
          "value": "Measurement Ontology",
          "lang": "en",
          "_id": "632caee0c4f7e5f619d44f09"
        }
      ]
    },
    {
      "nsp": "http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#",
      "prefix": "mtlo",
      "uri": "http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl",
      "titles": [
        {
          "value": "MarineTLO Ontology",
          "lang": "en",
          "_id": "568e25144ee7f7176ff21a6f"
        }
      ]
    },
    {
      "uri": "http://ns.inria.fr/munc/",
      "nsp": "http://ns.inria.fr/munc#",
      "prefix": "munc",
      "titles": [
        {
          "value": "Meta-Uncertainty",
          "lang": "en",
          "_id": "5cf3b11c15973e9745ebcaca"
        }
      ]
    },
    {
      "uri": "http://data.doremus.org/ontology#",
      "nsp": "http://data.doremus.org/ontology#",
      "prefix": "mus",
      "titles": [
        {
          "value": "DOREMUS is an extension of the FRBRoo model for describing the music.",
          "lang": "en",
          "_id": "5bf67fa147ae8a96226d6fcd"
        }
      ]
    },
    {
      "nsp": "http://www.kanzaki.com/ns/music#",
      "prefix": "music",
      "uri": "http://www.kanzaki.com/ns/music",
      "titles": [
        {
          "value": "Music Vocabulary",
          "lang": "en",
          "_id": "568beb7f4ee7f7176ff12583"
        }
      ]
    },
    {
      "nsp": "http://purl.org/muto/core#",
      "prefix": "muto",
      "uri": "http://purl.org/muto/core",
      "titles": [
        {
          "value": "Modular Unified Tagging Ontology (MUTO)",
          "lang": "en",
          "_id": "55bb59547459b3975b63c022"
        }
      ]
    },
    {
      "nsp": "http://schema.mobivoc.org/",
      "prefix": "mv",
      "uri": "http://schema.mobivoc.org/",
      "titles": [
        {
          "value": "MobiVoc: Open Mobility Vocabulary",
          "lang": "en",
          "_id": "5a69f44e696bbe7e0f71a8ce"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/mvco.owl#",
      "prefix": "mvco",
      "uri": "http://purl.oclc.org/NET/mvco.owl",
      "titles": [
        {
          "value": "Media Value Chain Ontology",
          "lang": "en",
          "_id": "568e24824ee7f7176ff219ff"
        }
      ]
    },
    {
      "nsp": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao#",
      "prefix": "nao",
      "uri": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao",
      "titles": [
        {
          "value": "NEPOMUK Annotation Ontology",
          "lang": "en",
          "_id": "5bc4a957ae7b898430043b20"
        }
      ]
    },
    {
      "nsp": "https://data.nasa.gov/ontologies/atmonto/NAS#",
      "prefix": "nas",
      "uri": "https://data.nasa.gov/ontologies/atmonto/NAS#",
      "titles": [
        {
          "value": "US National Airspace System (NAS) vocabulary",
          "lang": "en",
          "_id": "5ad89280a236156c49539c9a"
        }
      ]
    },
    {
      "nsp": "http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#",
      "prefix": "ncal",
      "uri": "http://www.semanticdesktop.org/ontologies/2007/04/02/ncal",
      "titles": [
        {
          "value": "NEPOMUK Calendar Ontology",
          "lang": "en",
          "_id": "55473ccb24d03b315d46a46c"
        }
      ]
    },
    {
      "nsp": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco#",
      "prefix": "nco",
      "uri": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco",
      "titles": [
        {
          "value": "NEPOMUK Contact Ontology",
          "lang": "en",
          "_id": "5531354e00421f5f6ed69a51"
        }
      ]
    },
    {
      "nsp": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#",
      "prefix": "nfo",
      "uri": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo",
      "titles": [
        {
          "value": "NEPOMUK File Ontology",
          "lang": "en",
          "_id": "5bd9bfbb30451cea37dc3452"
        }
      ]
    },
    {
      "nsp": "http://geovocab.org/geometry#",
      "prefix": "ngeo",
      "uri": "http://geovocab.org/geometry",
      "titles": [
        {
          "value": "NeoGeo Geometry Ontology",
          "lang": "en",
          "_id": "57696d624a73263716312ebb"
        }
      ]
    },
    {
      "nsp": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie#",
      "prefix": "nie",
      "uri": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie",
      "titles": [
        {
          "value": "NEPOMUK Information Element Core Ontology",
          "lang": "en",
          "_id": "5531359300421f5f6ed69a57"
        }
      ]
    },
    {
      "nsp": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
      "prefix": "nif",
      "uri": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
      "titles": [
        {
          "value": "NLP Interchange Format",
          "lang": "en",
          "_id": "568e23ef4ee7f7176ff219a6"
        }
      ]
    },
    {
      "nsp": "http://lod.nl.go.kr/ontology/",
      "prefix": "nlon",
      "uri": "http://lod.nl.go.kr/ontology/",
      "titles": [
        {
          "value": "National Library of Korea Ontology",
          "lang": "en",
          "_id": "5650e89e591cccea34de068e"
        }
      ]
    },
    {
      "uri": "https://w3id.org/nno/ontology",
      "nsp": "https://w3id.org/nno/ontology#",
      "prefix": "nno",
      "titles": [
        {
          "value": "The Neural Network Ontology",
          "lang": "en",
          "_id": "5ed93c3a04eb75a1282582a7"
        }
      ]
    },
    {
      "uri": "http://www.nanopub.org/nschema",
      "nsp": "http://www.nanopub.org/nschema#",
      "prefix": "np",
      "titles": [
        {
          "value": "Nano publication ontology",
          "lang": "en",
          "_id": "62860a77ae42b28b6180ba9b"
        }
      ]
    },
    {
      "nsp": "http://ns.nature.com/terms/",
      "prefix": "npg",
      "uri": "http://ns.nature.com/terms/",
      "titles": [
        {
          "value": "Nature.com Core Ontology",
          "lang": "en",
          "_id": "5dacdf398b936c5b59e22a85"
        }
      ]
    },
    {
      "nsp": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#",
      "prefix": "nrl",
      "uri": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl",
      "titles": [
        {
          "value": "NEPOMUK Representational Language",
          "lang": "en",
          "_id": "553134b600421f5f6ed69a44"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/nrv#",
      "prefix": "nrv",
      "uri": "http://ns.inria.fr/nrv",
      "titles": [
        {
          "value": "Normative Requirements Vocabulary",
          "lang": "en",
          "_id": "5989902a88adb933350c517b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/storyline/",
      "prefix": "nsl",
      "uri": "http://purl.org/ontology/storyline",
      "titles": [
        {
          "value": "A News Storyline Ontology",
          "lang": "en",
          "_id": "55366c82a6d4117c3a6b4ffc"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
      "prefix": "ntag",
      "uri": "http://ns.inria.fr/nicetag/2010/09/09/voc",
      "titles": [
        {
          "value": "Nice Tag Ontology",
          "lang": "en",
          "_id": "55bcaef77459b3975b63cad4"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/oa#",
      "prefix": "oa",
      "uri": "http://www.w3.org/ns/oa#",
      "titles": [
        {
          "value": "Open Annotation Data Model",
          "lang": "en",
          "_id": "5788c3738c6f955d29bf2256"
        }
      ]
    },
    {
      "nsp": "http://culturalis.org/oad#",
      "prefix": "oad",
      "uri": "http://culturalis.org/oad#",
      "titles": [
        {
          "value": "Ontology for archival description",
          "lang": "en",
          "_id": "5cdab34faee7bef561bd8f05"
        }
      ]
    },
    {
      "nsp": "http://www.ics.forth.gr/isl/oae/core#",
      "prefix": "oae",
      "uri": "http://www.ics.forth.gr/isl/oae/core",
      "titles": [
        {
          "value": "Open NEE Model",
          "lang": "en",
          "_id": "5731e778b5cce30e4a3b56d3"
        }
      ]
    },
    {
      "nsp": "http://data.lirmm.fr/ontologies/oan/",
      "prefix": "oan",
      "uri": "http://data.lirmm.fr/ontologies/oan",
      "titles": [
        {
          "value": "Ontologie de l'Assemblée  Nationale",
          "lang": "fr",
          "_id": "5cd07c75d18d844f5ff6f7ad"
        },
        {
          "value": "Ontology of the French National Assembly",
          "lang": "en",
          "_id": "5cd07c75d18d844f5ff6f7ac"
        }
      ]
    },
    {
      "nsp": "http://purl.obolibrary.org/obo/",
      "prefix": "obo",
      "uri": "http://purl.obolibrary.org/obo/obi.owl",
      "titles": [
        {
          "value": "Ontology for Biomedical Investigation",
          "lang": "en",
          "_id": "5dad697398c7a8076a14d5bd"
        }
      ]
    },
    {
      "nsp": "http://rdf.geospecies.org/methods/observationMethod#",
      "prefix": "obsm",
      "uri": "http://rdf.geospecies.org/methods/observationMethod.rdf",
      "titles": [
        {
          "value": "Observation Method Ontology",
          "lang": "en",
          "_id": "55de198754ef107a63464b23"
        }
      ]
    },
    {
      "nsp": "http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#",
      "prefix": "obws",
      "uri": "http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl",
      "titles": [
        {
          "value": "Object with states ontology",
          "lang": "en",
          "_id": "57111afb31bafaef0e78a5ce"
        }
      ]
    },
    {
      "nsp": "http://contextus.net/ontology/ontomedia/core/expression#",
      "prefix": "oc",
      "uri": "http://contextus.net/ontology/ontomedia/core/expression#",
      "titles": [
        {
          "value": "OntoMedia Core",
          "lang": "en",
          "_id": "568e243c4ee7f7176ff219dc"
        }
      ]
    },
    {
      "nsp": "http://dati.camera.it/ocd/",
      "prefix": "ocd",
      "uri": "http://dati.camera.it/ocd/",
      "titles": [
        {
          "value": "Ontologia Camera dei Deputati",
          "lang": "it",
          "_id": "55352f246313f1cd32a4b14c"
        },
        {
          "value": "Ontology of Italian Deputy Chamber",
          "lang": "en",
          "_id": "55352f246313f1cd32a4b14b"
        }
      ]
    },
    {
      "nsp": "http://purl.org/onto-ocds/ocds#",
      "prefix": "ocds",
      "uri": "http://purl.org/onto-ocds/ocds",
      "titles": [
        {
          "value": "Schema for an Open Contracting Release (OCDS)",
          "lang": "en",
          "_id": "5b3b9830297c2b02405be2da"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/odapp#",
      "prefix": "odapp",
      "uri": "http://vocab.deri.ie/odapp",
      "titles": [
        {
          "value": "Open Data Applications Vocabulary",
          "lang": "en",
          "_id": "5dace2008b936c5b59e22aac"
        }
      ]
    },
    {
      "nsp": "http://semweb.mmlab.be/ns/odapps#",
      "prefix": "odapps",
      "uri": "http://semweb.mmlab.be/ns/odapps",
      "titles": [
        {
          "value": "The vocabulary for (L)OD ideas and applications",
          "lang": "en",
          "_id": "5a418dd7b201efd03d3b7839"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/cp/owl/participation.owl#",
      "prefix": "odpart",
      "uri": "http://www.ontologydesignpatterns.org/cp/owl/participation.owl",
      "titles": [
        {
          "value": "Ontology Design Pattern Participation",
          "lang": "en",
          "_id": "55f84aec6185ddbd5f7a02af"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/odrl/2/",
      "prefix": "odrl",
      "uri": "http://www.w3.org/ns/odrl/2/",
      "titles": [
        {
          "value": "The Open Digital Rights Language (ODRL) Ontology",
          "lang": "en",
          "_id": "5ee0e72219c009bf5b729a44"
        }
      ]
    },
    {
      "nsp": "http://schema.theodi.org/odrs#",
      "prefix": "odrs",
      "uri": "http://schema.theodi.org/odrs",
      "titles": [
        {
          "value": "Open Data Rights Statement Vocabulary",
          "lang": "en",
          "_id": "55dc2f268b5f9f281f4c5a2d"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov.uk/def/organogram/",
      "prefix": "odv",
      "uri": "http://reference.data.gov.uk/def/organogram",
      "titles": [
        {
          "value": "Organogram Data Vocabulary",
          "lang": "en",
          "_id": "5965f4cf60bd67a35e912a2f"
        }
      ]
    },
    {
      "nsp": "http://www.oegov.org/core/owl/cc#",
      "prefix": "oecc",
      "uri": "http://www.oegov.org/core/owl/cc",
      "titles": [
        {
          "value": "Extended Creative Commons Ontology",
          "lang": "en",
          "_id": "55f848006185ddbd5f7a029e"
        }
      ]
    },
    {
      "nsp": "http://owlrep.eu01.aws.af.cm/fridge#",
      "prefix": "of",
      "uri": "http://owlrep.eu01.aws.af.cm/fridge",
      "titles": [
        {
          "value": "Open Fridge vocabulary",
          "lang": "en",
          "_id": "5809c64b3e5586c53d896f4c"
        }
      ]
    },
    {
      "uri": "https://w3id.org/ofo#",
      "nsp": "https://w3id.org/ofo#",
      "prefix": "ofo",
      "titles": [
        {
          "value": "Occupant Feedback Ontology",
          "lang": "en",
          "_id": "638bd114e8d209386de1497d"
        }
      ]
    },
    {
      "nsp": "http://purl.org/opdm/refrigerator#",
      "prefix": "ofrd",
      "uri": "http://purl.org/opdm/refrigerator#",
      "titles": [
        {
          "value": "Fridge and Freezer Vocabulary",
          "lang": "en",
          "_id": "56a51f8937d8a8044b25de6b"
        }
      ]
    },
    {
      "nsp": "http://ogp.me/ns#",
      "prefix": "og",
      "uri": "http://ogp.me/ns",
      "titles": [
        {
          "value": "Open Graph Protocol Vocabulary",
          "lang": "en",
          "_id": "580e208d7ada884367888d9d"
        }
      ]
    },
    {
      "nsp": "http://semweb.mmlab.be/ns/oh#",
      "prefix": "oh",
      "uri": "http://semweb.mmlab.be/ns/oh",
      "titles": [
        {
          "value": "The Opening Hours vocabulary",
          "lang": "en",
          "_id": "5dace15d8b936c5b59e22aa1"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/vocab/olca#",
      "prefix": "olca",
      "uri": "https://w3id.org/vocab/olca",
      "titles": [
        {
          "value": "Ontology Loose Coupling Annotation",
          "lang": "en",
          "_id": "5ed4c39bc7d84a2a049e41e3"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/olo/core#",
      "prefix": "olo",
      "uri": "http://purl.org/ontology/olo/core#",
      "titles": [
        {
          "value": "Ordered List Ontology",
          "lang": "en",
          "_id": "55e2e8fda71142386b778be3"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/observation#",
      "prefix": "om",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/observation",
      "titles": [
        {
          "value": "ISO 19156 Observation Model",
          "lang": "en",
          "_id": "55a0f98b57613119099c113f"
        }
      ]
    },
    {
      "uri": "https://w3id.org/omg",
      "nsp": "https://w3id.org/omg#",
      "prefix": "omg",
      "titles": [
        {
          "value": "OMG: Ontology for Managing Geometry",
          "lang": "en",
          "_id": "5da47e6ee8203beb0d42115e"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/ontology/om/om-lite#",
      "prefix": "oml",
      "uri": "http://def.seegrid.csiro.au/ontology/om/om-lite",
      "titles": [
        {
          "value": "OWL for Observations",
          "lang": "en",
          "_id": "56af7dfd98f0192c57ea989a"
        }
      ]
    },
    {
      "nsp": "http://open-multinet.info/ontology/omn#",
      "prefix": "omn",
      "uri": "http://open-multinet.info/ontology/omn",
      "titles": [
        {
          "value": "Open-Multinet Upper Ontology",
          "lang": "en",
          "_id": "57ad8385b00b4b1452a88643"
        }
      ]
    },
    {
      "nsp": "http://open-multinet.info/ontology/omn-federation#",
      "prefix": "omnfed",
      "uri": "http://open-multinet.info/ontology/omn-federation",
      "titles": [
        {
          "value": "Open-Multinet Upper Federation Ontology",
          "lang": "en",
          "_id": "5527e61e4727af98034d32a1"
        }
      ]
    },
    {
      "nsp": "http://open-multinet.info/ontology/omn-lifecycle#",
      "prefix": "omnlc",
      "uri": "http://open-multinet.info/ontology/omn-lifecycle",
      "titles": [
        {
          "value": "Open-Multinet Upper Lifecycle Ontology",
          "lang": "en",
          "_id": "5527e63b4727af98034d32ad"
        }
      ]
    },
    {
      "nsp": "http://www.ics.forth.gr/isl/oncm/core#",
      "prefix": "onc",
      "uri": "http://www.ics.forth.gr/isl/oncm/core",
      "titles": [
        {
          "value": "Open NEE Configuration Model",
          "lang": "en",
          "_id": "57d2cf72a3a9d3a63d7e8bb2"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/ns/ontology-annot#",
      "prefix": "ont",
      "uri": "http://purl.org/net/ns/ontology-annot",
      "titles": [
        {
          "value": "Ontology annotation DLiser vocabulary",
          "lang": "en",
          "_id": "5548f6d23d2356850c58948b"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/lemon/ontolex",
      "nsp": "http://www.w3.org/ns/lemon/ontolex#",
      "prefix": "ontolex",
      "titles": [
        {
          "value": "Lexicon Model for Ontologies - Core",
          "lang": "en",
          "_id": "60b7ac9387423a16187e4499"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#",
      "prefix": "ontopic",
      "uri": "http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl",
      "titles": [
        {
          "value": "Ontopic Ontology",
          "lang": "en",
          "_id": "55bb60e07459b3975b63c079"
        }
      ]
    },
    {
      "nsp": "http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#",
      "prefix": "ontosec",
      "uri": "http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl",
      "titles": [
        {
          "value": "Ontology Security",
          "lang": "en",
          "_id": "554942850258721029c75c73"
        }
      ]
    },
    {
      "nsp": "http://www.gsi.dit.upm.es/ontologies/onyx/ns#",
      "prefix": "onyx",
      "uri": "http://www.gsi.dit.upm.es/ontologies/onyx/ns",
      "titles": [
        {
          "value": "Onyx Emotion Ontology",
          "lang": "en",
          "_id": "560658768f7ad2ce3438d56c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/openorg/",
      "prefix": "oo",
      "uri": "http://purl.org/openorg/",
      "titles": [
        {
          "value": "Open Organisations",
          "lang": "en",
          "_id": "57d2d10ca3a9d3a63d7e8c71"
        }
      ]
    },
    {
      "nsp": "http://environment.data.gov.au/def/op#",
      "prefix": "op",
      "uri": "http://environment.data.gov.au/def/op",
      "titles": [
        {
          "value": "Observable properties",
          "lang": "en",
          "_id": "57d2d09ea3a9d3a63d7e8c28"
        }
      ]
    },
    {
      "nsp": "http://ontology.eil.utoronto.ca/open311#",
      "prefix": "open311",
      "uri": "http://ontology.eil.utoronto.ca/open311.owl",
      "titles": [
        {
          "value": "Open 311 Ontology: An Ontology for publishing a city's non-emergency events.",
          "lang": "en",
          "_id": "5ad0b0803aba5caf50df14a1"
        }
      ]
    },
    {
      "uri": "https://w3id.org/opm",
      "nsp": "https://w3id.org/opm#",
      "prefix": "opm",
      "titles": [
        {
          "value": "OPM: Ontology for Property Management",
          "lang": "en",
          "_id": "5da48640532b78ab0e3bdb2f"
        }
      ]
    },
    {
      "nsp": "http://openprovenance.org/model/opmo#",
      "prefix": "opmo",
      "uri": "http://openprovenance.org/model/opmo",
      "titles": [
        {
          "value": "Open Provenance Model",
          "lang": "en",
          "_id": "5693f592ff8848f96bd09140"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/opmv/ns#",
      "prefix": "opmv",
      "uri": "http://purl.org/net/opmv/ns#",
      "titles": [
        {
          "value": "Open Provenance Model Vocabulary",
          "lang": "en",
          "_id": "5ad0b0633aba5caf50df148f"
        }
      ]
    },
    {
      "nsp": "http://www.opmw.org/ontology/",
      "prefix": "opmw",
      "uri": "http://www.opmw.org/ontology/",
      "titles": [
        {
          "value": "The OPMW Ontology",
          "lang": "en",
          "_id": "560654898f7ad2ce3438d47f"
        }
      ]
    },
    {
      "nsp": "http://online-presence.net/opo/ns#",
      "prefix": "opo",
      "uri": "http://online-presence.net/opo/ns#",
      "titles": [
        {
          "value": "Online Presence Ontology",
          "lang": "en",
          "_id": "56065a158f7ad2ce3438d5a5"
        }
      ]
    },
    {
      "nsp": "http://lsdis.cs.uga.edu/projects/semdis/opus#",
      "prefix": "opus",
      "uri": "http://lsdis.cs.uga.edu/projects/semdis/opus#",
      "titles": [
        {
          "value": "SwetoDblp Ontology of Computer Science Publications",
          "lang": "en",
          "_id": "555a77a130f688c94e8201ef"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/orca#",
      "prefix": "orca",
      "uri": "http://vocab.deri.ie/orca",
      "titles": [
        {
          "value": "orca, the Ontology of Reasoning, Certainty and Attribution",
          "lang": "en",
          "_id": "583a03bdcd0ed0472763e103"
        }
      ]
    },
    {
      "nsp": "http://www.openarchives.org/ore/terms/",
      "prefix": "ore",
      "uri": "http://www.openarchives.org/ore/terms/",
      "titles": [
        {
          "value": "The OAI ORE terms vocabulary",
          "lang": "en",
          "_id": "556dc81fa866afd621a1ca6d"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/org#",
      "prefix": "org",
      "uri": "http://www.w3.org/ns/org#",
      "titles": [
        {
          "value": "Core organization ontology",
          "lang": "en",
          "_id": "5731b553b5cce30e4a3b528d"
        }
      ]
    },
    {
      "nsp": "http://datos.gob.es/def/sector-publico/organizacion#",
      "prefix": "orges",
      "uri": "http://datos.gob.es/def/sector-publico/organizacion#",
      "titles": [
        {
          "value": "Ontology about Spanish public organizations",
          "lang": "en",
          "_id": "55efdde5a71142386b78ff41"
        },
        {
          "value": "Ontología sobre organizaciones públicas en España",
          "lang": "es",
          "_id": "55efdde5a71142386b78ff40"
        }
      ]
    },
    {
      "nsp": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
      "prefix": "osadm",
      "uri": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
      "titles": [
        {
          "value": "The administrative geography and civil voting area ontology",
          "lang": "en",
          "_id": "557f458e1d5237e823d24e1d"
        }
      ]
    },
    {
      "nsp": "http://data.ordnancesurvey.co.uk/ontology/geometry/",
      "prefix": "osgeom",
      "uri": "http://data.ordnancesurvey.co.uk/ontology/geometry/",
      "titles": [
        {
          "value": "Ordnance Survey Geometry Ontology",
          "lang": "en",
          "_id": "599206b4605c58c744d4ff2b"
        }
      ]
    },
    {
      "nsp": "http://open-services.net/ns/core#",
      "prefix": "oslc",
      "uri": "http://open-services.net/ns/core#",
      "titles": [
        {
          "value": "OSLC Core Vocabulary",
          "lang": "en",
          "_id": "55478b5d5cd393446058a75c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/oslo/ns/localgov#",
      "prefix": "oslo",
      "uri": "http://purl.org/oslo/ns/localgov",
      "titles": [
        {
          "value": "OSLO Exchange Standard",
          "lang": "en",
          "_id": "55e062ffa71142386b77622d"
        }
      ]
    },
    {
      "nsp": "http://data.lirmm.fr/ontologies/osp#",
      "prefix": "osp",
      "uri": "http://data.lirmm.fr/ontologies/osp",
      "titles": [
        {
          "value": "Ontologie du Service Public",
          "lang": "fr",
          "_id": "57ad8fd9b00b4b1452a88d20"
        },
        {
          "value": "French Public Services Ontology",
          "lang": "en",
          "_id": "57ad8fd9b00b4b1452a88d1f"
        }
      ]
    },
    {
      "nsp": "http://contextus.net/ontology/ontomedia/core/space#",
      "prefix": "osr",
      "uri": "http://contextus.net/ontology/ontomedia/core/space#",
      "titles": [
        {
          "value": "OntoMedia Space Representation",
          "lang": "en",
          "_id": "55bcb0137459b3975b63cae5"
        }
      ]
    },
    {
      "nsp": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
      "prefix": "osspr",
      "uri": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
      "titles": [
        {
          "value": "Spatial Relations Ontology",
          "lang": "en",
          "_id": "556dc9e8a866afd621a1ca90"
        }
      ]
    },
    {
      "nsp": "http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#",
      "prefix": "ostop",
      "uri": "http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl",
      "titles": [
        {
          "value": "Ordnance Survey Topography Ontology",
          "lang": "en",
          "_id": "555e07c0fcb9d2f3482486ec"
        }
      ]
    },
    {
      "uri": "https://w3id.org/opentrafficlights",
      "nsp": "https://w3id.org/opentrafficlights#",
      "prefix": "otl",
      "titles": [
        {
          "value": "The Open Traffic Lights ontology",
          "lang": "en",
          "_id": "5bf68aaa47ae8a96226d7418"
        }
      ]
    },
    {
      "uri": "http://www.ontology-of-units-of-measure.org/resource/om-2/",
      "nsp": "http://www.ontology-of-units-of-measure.org/resource/om-2/",
      "prefix": "oum",
      "titles": [
        {
          "value": "Ontology of units of Measure (OM)",
          "lang": "en",
          "_id": "5f1ac2ed388540d23b85cef5"
        },
        {
          "value": "測定単位のオントロジー (OM)",
          "lang": "ja",
          "_id": "5f1ac2ed388540d23b85cef4"
        }
      ]
    },
    {
      "nsp": "http://open.vocab.org/terms/",
      "prefix": "ov",
      "uri": "http://open.vocab.org/terms",
      "titles": [
        {
          "value": "OpenVocab",
          "lang": "en",
          "_id": "5534d43792fbe6e5228e6fa3"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2002/07/owl#",
      "prefix": "owl",
      "uri": "http://www.w3.org/2002/07/owl",
      "titles": [
        {
          "value": "The OWL 2 Schema vocabulary",
          "lang": "en",
          "_id": "576a57f54a73263716316b54"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/p-plan#",
      "prefix": "p-plan",
      "uri": "http://purl.org/net/p-plan#",
      "titles": [
        {
          "value": "The P-PLAN Ontology",
          "lang": "en",
          "_id": "58171a2bc1b1a26b516f7977"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov.uk/def/parliament/",
      "prefix": "parl",
      "uri": "http://reference.data.gov.uk/def/parliament",
      "titles": [
        {
          "value": "Parliament Ontology",
          "lang": "en",
          "_id": "55e01cac54ef107a63465d2d"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/participation/schema#",
      "prefix": "part",
      "uri": "http://purl.org/vocab/participation/schema",
      "titles": [
        {
          "value": "Participation Schema",
          "lang": "en",
          "_id": "556dc894a866afd621a1ca77"
        }
      ]
    },
    {
      "nsp": "http://data.lirmm.fr/ontologies/passim#",
      "prefix": "passim",
      "uri": "http://data.lirmm.fr/ontologies/passim",
      "titles": [
        {
          "value": "PASSIM ontology",
          "lang": "en",
          "_id": "59dce02c2febc4a21c3167c7"
        }
      ]
    },
    {
      "nsp": "http://purl.org/hpi/patchr#",
      "prefix": "pat",
      "uri": "http://purl.org/hpi/patchr#",
      "titles": [
        {
          "value": "Patch Request Ontology",
          "lang": "en"
        }
      ]
    },
    {
      "nsp": "http://www.essepuntato.it/2008/12/pattern#",
      "prefix": "pattern",
      "uri": "http://www.essepuntato.it/2008/12/pattern",
      "titles": [
        {
          "value": "The Pattern Ontology",
          "lang": "en",
          "_id": "55bb58787459b3975b63c013"
        }
      ]
    },
    {
      "nsp": "http://purl.org/pav/",
      "prefix": "pav",
      "uri": "http://purl.org/pav/",
      "titles": [
        {
          "value": "Provenance, Authoring and Versioning",
          "lang": "en",
          "_id": "581718fdc1b1a26b516f787c"
        }
      ]
    },
    {
      "nsp": "http://reference.data.gov.uk/def/payment#",
      "prefix": "pay",
      "uri": "http://reference.data.gov.uk/def/payment#",
      "titles": [
        {
          "value": "Payments ontology",
          "lang": "en",
          "_id": "57ad8f81b00b4b1452a88cb7"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/pbo/core#",
      "prefix": "pbo",
      "uri": "http://purl.org/ontology/pbo/core#",
      "titles": [
        {
          "value": "Play Back Ontology",
          "lang": "en",
          "_id": "55e060c9a71142386b776215"
        }
      ]
    },
    {
      "nsp": "http://purl.org/procurement/public-contracts#",
      "prefix": "pc",
      "uri": "http://purl.org/procurement/public-contracts",
      "titles": [
        {
          "value": "Public Contracts Ontology",
          "lang": "en",
          "_id": "55310643be83f8651477b824"
        }
      ]
    },
    {
      "nsp": "http://ontologies.smile.deri.ie/pdo#",
      "prefix": "pdo",
      "uri": "http://vocab.deri.ie/pdo",
      "titles": [
        {
          "value": "Project Documents Ontology",
          "lang": "en",
          "_id": "55e05ad8419d00687563ad8f"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/pep/",
      "prefix": "pep",
      "uri": "https://w3id.org/pep/",
      "titles": [
        {
          "value": "Process Execution ontology.",
          "lang": "en",
          "_id": "5feb47beba82ec865987976f"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/person#",
      "prefix": "person",
      "uri": "http://www.w3.org/ns/person",
      "titles": [
        {
          "value": "ISA Programme Person Core Vocabulary",
          "lang": "en",
          "_id": "59dcdeb12febc4a21c31668b"
        }
      ]
    },
    {
      "nsp": "http://www.ontotext.com/proton/protonext#",
      "prefix": "pext",
      "uri": "http://www.ontotext.com/proton/protonext",
      "titles": [
        {
          "value": "PROTON Extent module",
          "lang": "en",
          "_id": "57ad8f47b00b4b1452a88c65"
        }
      ]
    },
    {
      "uri": "https://w3id.org/pfeepsa#",
      "nsp": "https://w3id.org/pfeepsa#",
      "prefix": "pfeepsa",
      "titles": [
        {
          "value": "The PFEEPSA Ontology.",
          "lang": "en",
          "_id": "5eb4077bdff95c0656a7c15a"
        }
      ]
    },
    {
      "nsp": "http://rdf-vocabulary.ddialliance.org/phdd#",
      "prefix": "phdd",
      "uri": "http://rdf-vocabulary.ddialliance.org/phdd",
      "titles": [
        {
          "value": "Physical Data Description",
          "lang": "en",
          "_id": "555df25630f688c94e823b15"
        }
      ]
    },
    {
      "uri": "http://data.cochrane.org/ontologies/pico/",
      "nsp": "http://data.cochrane.org/ontologies/pico/",
      "prefix": "pico",
      "titles": [
        {
          "value": "Cochrane PICO Ontology",
          "lang": "en",
          "_id": "5e905bf32cdad58a4e618c69"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/places#",
      "prefix": "place",
      "uri": "http://purl.org/ontology/places",
      "titles": [
        {
          "value": "The Places Ontology",
          "lang": "en",
          "_id": "5dacde568b936c5b59e22a6b"
        }
      ]
    },
    {
      "nsp": "http://cedric.cnam.fr/isid/ontologies/PersonLink.owl#",
      "prefix": "plink",
      "uri": "http://cedric.cnam.fr/isid/ontologies/PersonLink.owl",
      "titles": [
        {
          "value": "PersonLink Ontology",
          "lang": "en",
          "_id": "5c1a7aa6712ec7a91b1ea13a"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/po#",
      "prefix": "plo",
      "uri": "http://purl.org/net/po#",
      "titles": [
        {
          "value": "Playlist Ontology",
          "lang": "en",
          "_id": "56950ae3ff8848f96bd10445"
        }
      ]
    },
    {
      "nsp": "http://inference-web.org/2.0/pml-provenance.owl#",
      "prefix": "pmlp",
      "uri": "http://inference-web.org/2.0/pml-provenance.owl",
      "titles": [
        {
          "value": "PML2 provenance ontology",
          "lang": "en",
          "_id": "5693f4f9ff8848f96bd09109"
        }
      ]
    },
    {
      "nsp": "http://premon.fbk.eu/ontology/fn#",
      "prefix": "pmofn",
      "uri": "http://premon.fbk.eu/ontology/fn",
      "titles": [
        {
          "value": "Predicate Model for Ontologies (PreMOn) - FrameNet ontology module",
          "lang": "en",
          "_id": "599d8e19daf8c9570d02b8ec"
        }
      ]
    },
    {
      "nsp": "http://premon.fbk.eu/ontology/nb#",
      "prefix": "pmonb",
      "uri": "http://premon.fbk.eu/ontology/nb",
      "titles": [
        {
          "value": "Predicate Model for Ontologies (PreMOn) - NomBank ontology module",
          "lang": "en",
          "_id": "599d9658daf8c9570d02c2d3"
        }
      ]
    },
    {
      "nsp": "http://premon.fbk.eu/ontology/pb#",
      "prefix": "pmopb",
      "uri": "http://premon.fbk.eu/ontology/pb",
      "titles": [
        {
          "value": "Predicate Model for Ontologies (PreMOn) - PropBank ontology module",
          "lang": "en",
          "_id": "599db279daf8c9570d02fb53"
        }
      ]
    },
    {
      "nsp": "http://premon.fbk.eu/ontology/vn#",
      "prefix": "pmovn",
      "uri": "http://premon.fbk.eu/ontology/vn",
      "titles": [
        {
          "value": "Predicate Model for Ontologies (PreMOn) - VerbNet ontology module",
          "lang": "en",
          "_id": "599d942fdaf8c9570d02bf4a"
        }
      ]
    },
    {
      "nsp": "http://data.press.net/ontology/asset/",
      "prefix": "pna",
      "uri": "http://data.press.net/ontology/asset/",
      "titles": [
        {
          "value": "Press.net Asset Ontology",
          "lang": "en",
          "_id": "55e05a81419d00687563ad87"
        }
      ]
    },
    {
      "nsp": "http://data.press.net/ontology/classification/",
      "prefix": "pnc",
      "uri": "http://data.press.net/ontology/classification/",
      "titles": [
        {
          "value": "Press.net Classification Ontology",
          "lang": "en",
          "_id": "57ad8d0fb00b4b1452a88b4b"
        }
      ]
    },
    {
      "nsp": "http://data.press.net/ontology/event/",
      "prefix": "pne",
      "uri": "http://data.press.net/ontology/event/",
      "titles": [
        {
          "value": "Press.net Event Ontology",
          "lang": "en",
          "_id": "560652478f7ad2ce3438d3fd"
        }
      ]
    },
    {
      "nsp": "http://data.press.net/ontology/identifier/",
      "prefix": "pni",
      "uri": "http://data.press.net/ontology/identifier/",
      "titles": [
        {
          "value": "SNaP Identifier Ontology",
          "lang": "en",
          "_id": "56a3c37037d8a8044b2540cc"
        }
      ]
    },
    {
      "nsp": "http://data.press.net/ontology/stuff/",
      "prefix": "pns",
      "uri": "http://data.press.net/ontology/stuff/",
      "titles": [
        {
          "value": "Press.net Stuff Ontology",
          "lang": "en",
          "_id": "5accd0783aba5caf50dbed6b"
        }
      ]
    },
    {
      "nsp": "http://data.press.net/ontology/tag/",
      "prefix": "pnt",
      "uri": "http://data.press.net/ontology/tag/",
      "titles": [
        {
          "value": "Press.net Tag Ontology",
          "lang": "en",
          "_id": "55d72fbae4ac2b1c4c5a5183"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/po/",
      "prefix": "po",
      "uri": "http://purl.org/ontology/po/",
      "titles": [
        {
          "value": "Programmes ontology",
          "lang": "en",
          "_id": "583a0f5ccd0ed0472763e186"
        }
      ]
    },
    {
      "nsp": "http://dev.poderopedia.com/vocab/",
      "prefix": "poder",
      "uri": "http://dev.poderopedia.com/vocab/schema",
      "titles": [
        {
          "value": "Poder Vocabulary",
          "lang": "en",
          "_id": "5accd0503aba5caf50dbed15"
        }
      ]
    },
    {
      "uri": "http://purl.org/poso/",
      "nsp": "http://purl.org/poso/",
      "prefix": "poso",
      "titles": [
        {
          "value": "Positioning System Ontology",
          "lang": "en",
          "_id": "6326e65c121504032603c39e"
        }
      ]
    },
    {
      "uri": "http://purl.org/poso/common/",
      "nsp": "http://purl.org/poso/common/",
      "prefix": "posocm",
      "titles": [
        {
          "value": "Positioning System Ontology Common Technologies, Algorithms and Systems",
          "lang": "en",
          "_id": "6326e788121504032603c3c7"
        }
      ]
    },
    {
      "nsp": "http://data.ordnancesurvey.co.uk/ontology/postcode/",
      "prefix": "postcode",
      "uri": "http://data.ordnancesurvey.co.uk/ontology/postcode/",
      "titles": [
        {
          "value": "Postcode Ontology",
          "lang": "en",
          "_id": "5a418d96b201efd03d3b77d0"
        }
      ]
    },
    {
      "nsp": "http://data.lirmm.fr/ontologies/poste#",
      "prefix": "poste",
      "uri": "http://data.lirmm.fr/ontologies/poste",
      "titles": [
        {
          "value": "Ontologie de la Poste",
          "lang": "fr",
          "_id": "5783c0c20183b1e80fc87fb7"
        },
        {
          "value": "\"La Poste\" Ontology",
          "lang": "en",
          "_id": "5783c0c20183b1e80fc87fb6"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/ppo#",
      "prefix": "ppo",
      "uri": "http://vocab.deri.ie/ppo",
      "titles": [
        {
          "value": "Privacy Preference Ontology",
          "lang": "en",
          "_id": "55c208da47ebcd4d234436d9"
        }
      ]
    },
    {
      "nsp": "http://contsem.unizar.es/def/sector-publico/pproc#",
      "prefix": "pproc",
      "uri": "http://contsem.unizar.es/def/sector-publico/pproc",
      "titles": [
        {
          "value": "PPROC ontology",
          "lang": "en",
          "_id": "55f847826185ddbd5f7a029a"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/prv/core#",
      "prefix": "pr",
      "uri": "http://purl.org/ontology/prv/core#",
      "titles": [
        {
          "value": "Property Reification Vocabulary",
          "lang": "en",
          "_id": "55e05a0b419d00687563ad7c"
        }
      ]
    },
    {
      "nsp": "http://www.loc.gov/premis/rdf/v1#",
      "prefix": "premis",
      "uri": "http://www.loc.gov/premis/rdf/v1",
      "titles": [
        {
          "value": "PREMIS Ontology",
          "lang": "en",
          "_id": "5dace1028b936c5b59e22a9b"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/prissma/v2#",
      "prefix": "prissma",
      "uri": "http://ns.inria.fr/prissma/v2#",
      "titles": [
        {
          "value": "Presentation of Resources for Interoperable Semantic and Shareable Mobile Adaptability",
          "lang": "en",
          "_id": "5db033dd581233d82940d264"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/pro/",
      "prefix": "pro",
      "uri": "http://purl.org/spar/pro",
      "titles": [
        {
          "value": "The Publishing Roles Ontology",
          "lang": "en",
          "_id": "583a0f8dcd0ed0472763e18f"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/dx/prof",
      "nsp": "http://www.w3.org/ns/dx/prof/",
      "prefix": "prof",
      "titles": [
        {
          "value": "Profiles Vocabulary",
          "lang": "en",
          "_id": "5f36d8324dda25af52c6e000"
        }
      ]
    },
    {
      "nsp": "http://purl.org/prog/",
      "prefix": "prog",
      "uri": "http://purl.org/prog/",
      "titles": [
        {
          "value": "The Event Programme Vocabulary",
          "lang": "en",
          "_id": "57ad8cabb00b4b1452a88b2e"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/prov#",
      "prefix": "prov",
      "uri": "http://www.w3.org/ns/prov#",
      "titles": [
        {
          "value": "W3C PROVenance Interchange",
          "lang": "en",
          "_id": "58f9d4fe6961d74e135adc2d"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/provoc#",
      "prefix": "provoc",
      "uri": "http://ns.inria.fr/provoc",
      "titles": [
        {
          "value": "Product Vocabulary",
          "lang": "en",
          "_id": "56c6e6c1087c0703190899aa"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/provenance/ns#",
      "prefix": "prv",
      "uri": "http://purl.org/net/provenance/ns#",
      "titles": [
        {
          "value": "Provenance Vocabulary Core Ontology",
          "lang": "en",
          "_id": "5ad0afe43aba5caf50df13f4"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/provenance/types#",
      "prefix": "prvt",
      "uri": "http://purl.org/net/provenance/types#",
      "titles": [
        {
          "value": "Provenance Vocabulary types",
          "lang": "en",
          "_id": "560653378f7ad2ce3438d435"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/pso/",
      "prefix": "pso",
      "uri": "http://purl.org/spar/pso",
      "titles": [
        {
          "value": "The Publishing Status Ontology",
          "lang": "en",
          "_id": "583a0cd2cd0ed0472763e167"
        }
      ]
    },
    {
      "nsp": "http://www.ontotext.com/proton/protontop#",
      "prefix": "ptop",
      "uri": "http://www.ontotext.com/proton/protontop",
      "titles": [
        {
          "value": "PROTON (Proto Ontology), Top Module",
          "lang": "en",
          "_id": "5697bb59ff8848f96bd12b97"
        }
      ]
    },
    {
      "nsp": "https://vocab.eccenca.com/pubsub/",
      "prefix": "pubsub",
      "uri": "https://vocab.eccenca.com/pubsub/",
      "titles": [
        {
          "value": "Eccenca Publish-Subscribe Vocabulary",
          "lang": "en",
          "_id": "606c0c2e599773345e0c5789"
        }
      ]
    },
    {
      "uri": "https://w3id.org/env/puv",
      "nsp": "https://w3id.org/env/puv#",
      "prefix": "puv",
      "titles": [
        {
          "value": "Parameter Usage Vocabulary ontology",
          "lang": "en",
          "_id": "635a895bfd5cc3ee1cd108f5"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/pwo/",
      "prefix": "pwo",
      "uri": "http://purl.org/spar/pwo",
      "titles": [
        {
          "value": "The Publishing Workflow Ontology",
          "lang": "en",
          "_id": "55de189754ef107a63464b14"
        }
      ]
    },
    {
      "nsp": "http://purl.org/linked-data/cube#",
      "prefix": "qb",
      "uri": "http://purl.org/linked-data/cube",
      "titles": [
        {
          "value": "The data cube vocabulary",
          "lang": "en",
          "_id": "576a58fa4a73263716316bb2"
        }
      ]
    },
    {
      "nsp": "http://purl.org/qb4olap/cubes#",
      "prefix": "qb4o",
      "uri": "http://purl.org/qb4olap/cubes",
      "titles": [
        {
          "value": "Vocabulary for publishing OLAP data cubes",
          "lang": "en",
          "_id": "57d2cde5a3a9d3a63d7e8add"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/ssnx/qu/qu#",
      "prefix": "qu",
      "uri": "http://purl.oclc.org/NET/ssnx/qu/qu",
      "titles": [
        {
          "value": "Quantity Kinds and Units",
          "lang": "en",
          "_id": "578d05ee8c6f955d29c02c53"
        }
      ]
    },
    {
      "nsp": "http://qudt.org/schema/qudt/",
      "prefix": "qudt",
      "uri": "http://qudt.org/schema/qudt",
      "titles": [
        {
          "value": "Quantities, Units, Dimensions and Types",
          "lang": "en",
          "_id": "5f1b1746b658e6e346838e22"
        }
      ]
    },
    {
      "uri": "https://w3id.org/arco/ontology/arco",
      "nsp": "https://w3id.org/arco/ontology/arco/",
      "prefix": "r-arco",
      "titles": [
        {
          "value": "ArCo Ontology (ArCo network)",
          "lang": "en",
          "_id": "5db15c6f5433bbf424c65658"
        }
      ]
    },
    {
      "nsp": "http://guava.iis.sinica.edu.tw/r4r/",
      "prefix": "r4r",
      "uri": "http://guava.iis.sinica.edu.tw/r4r",
      "titles": [
        {
          "value": "Relations for Reusing (R4R) Ontology",
          "lang": "en",
          "_id": "57ad8c03b00b4b1452a88aee"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/radion#",
      "prefix": "radion",
      "uri": "http://www.w3.org/ns/radion#",
      "titles": [
        {
          "value": "Repository Asset Distribution",
          "lang": "en",
          "_id": "59dcdf302febc4a21c3166e6"
        }
      ]
    },
    {
      "uri": "https://w3id.org/rains",
      "nsp": "https://w3id.org/rains#",
      "prefix": "rains",
      "titles": [
        {
          "value": "The RAInS Ontology",
          "lang": "en",
          "_id": "62791672476a20423a95d4c9"
        }
      ]
    },
    {
      "nsp": "http://iais.fraunhofer.de/vocabs/rami#",
      "prefix": "rami",
      "uri": "https://w3id.org/i40/rami/",
      "titles": [
        {
          "value": "rami - Reference Architecture Model",
          "lang": "en",
          "_id": "619a27ed964a94327aaf7b57"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/raul#",
      "prefix": "raul",
      "uri": "http://vocab.deri.ie/raul",
      "titles": [
        {
          "value": "RAUL Vocabulary",
          "lang": "en",
          "_id": "56950b27ff8848f96bd1046d"
        }
      ]
    },
    {
      "nsp": "http://rdaregistry.info/Elements/a/",
      "prefix": "rdaa",
      "uri": "http://rdaregistry.info/Elements/a",
      "titles": [
        {
          "value": "RDA Agent properties",
          "lang": "en",
          "_id": "56a523a037d8a8044b25e0b7"
        }
      ]
    },
    {
      "nsp": "http://rdaregistry.info/Elements/c/",
      "prefix": "rdac",
      "uri": "http://rdaregistry.info/Elements/c",
      "titles": [
        {
          "value": "RDA Classes",
          "lang": "en",
          "_id": "56a654a737d8a8044b264668"
        }
      ]
    },
    {
      "nsp": "http://rdaregistry.info/Elements/e/",
      "prefix": "rdae",
      "uri": "http://rdaregistry.info/Elements/e",
      "titles": [
        {
          "value": "RDA Expression properties",
          "lang": "en",
          "_id": "5acccf783aba5caf50dbec0d"
        }
      ]
    },
    {
      "nsp": "http://rdvocab.info/uri/schema/FRBRentitiesRDA/",
      "prefix": "rdafrbr",
      "uri": "http://rdvocab.info/uri/schema/FRBRentitiesRDA",
      "titles": [
        {
          "value": "FRBR Entities for RDA",
          "lang": "en",
          "_id": "56a64d6837d8a8044b2642d0"
        }
      ]
    },
    {
      "nsp": "http://rdvocab.info/Elements/",
      "prefix": "rdag1",
      "uri": "http://rdvocab.info/Elements",
      "titles": [
        {
          "value": "RDA Group 1 Elements",
          "lang": "en",
          "_id": "56a6536637d8a8044b264550"
        }
      ]
    },
    {
      "nsp": "http://rdvocab.info/ElementsGr2/",
      "prefix": "rdag2",
      "uri": "http://rdvocab.info/ElementsGr2",
      "titles": [
        {
          "value": "RDA Group 2 Elements",
          "lang": "en",
          "_id": "56a5231537d8a8044b25e063"
        }
      ]
    },
    {
      "nsp": "http://rdvocab.info/ElementsGr3/",
      "prefix": "rdag3",
      "uri": "http://rdvocab.info/ElementsGr3",
      "titles": [
        {
          "value": "RDA Group 3 Elements",
          "lang": "en",
          "_id": "56a64ddc37d8a8044b264306"
        }
      ]
    },
    {
      "nsp": "http://rdaregistry.info/Elements/i/",
      "prefix": "rdai",
      "uri": "http://rdaregistry.info/Elements/i",
      "titles": [
        {
          "value": "RDA Item properties",
          "lang": "en",
          "_id": "56ae4ec798f0192c57ea027c"
        }
      ]
    },
    {
      "nsp": "http://rdaregistry.info/Elements/m/",
      "prefix": "rdam",
      "uri": "http://rdaregistry.info/Elements/m",
      "titles": [
        {
          "value": "RDA Manifestation properties",
          "lang": "en",
          "_id": "56a521c437d8a8044b25dfb8"
        }
      ]
    },
    {
      "nsp": "http://rdvocab.info/RDARelationshipsWEMI/",
      "prefix": "rdarel",
      "uri": "http://rdvocab.info/RDARelationshipsWEMI",
      "titles": [
        {
          "value": "RDA Relationships for Works, Expressions, Manifestations, Items",
          "lang": "en",
          "_id": "56a6992137d8a8044b26676d"
        }
      ]
    },
    {
      "nsp": "http://metadataregistry.org/uri/schema/RDARelationshipsGR2/",
      "prefix": "rdarel2",
      "uri": "http://metadataregistry.org/uri/schema/RDARelationshipsGR2",
      "titles": [
        {
          "value": "RDA Relationships GR2",
          "lang": "en",
          "_id": "57ad8c2bb00b4b1452a88afb"
        }
      ]
    },
    {
      "nsp": "http://rdvocab.info/roles/",
      "prefix": "rdarole",
      "uri": "http://rdvocab.info/roles",
      "titles": [
        {
          "value": "RDA Roles",
          "lang": "en",
          "_id": "56ae4db198f0192c57ea0270"
        }
      ]
    },
    {
      "nsp": "http://rdaregistry.info/Elements/u/",
      "prefix": "rdau",
      "uri": "http://rdaregistry.info/Elements/u",
      "titles": [
        {
          "value": "RDA Unconstrained properties",
          "lang": "en",
          "_id": "568e6d694ee7f7176ff24672"
        }
      ]
    },
    {
      "nsp": "http://rdaregistry.info/Elements/w/",
      "prefix": "rdaw",
      "uri": "http://rdaregistry.info/Elements/w",
      "titles": [
        {
          "value": "RDA Work properties",
          "lang": "en",
          "_id": "56a51c5437d8a8044b25dc2d"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      "prefix": "rdf",
      "uri": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      "titles": [
        {
          "value": "The RDF Concepts Vocabulary",
          "lang": "en",
          "_id": "60449e78f05734d01727282d"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/rdfa#",
      "prefix": "rdfa",
      "uri": "http://www.w3.org/ns/rdfa#",
      "titles": [
        {
          "value": "RDFa Vocabulary for Term and Prefix Assignment, and for Processor Graph Reporting",
          "lang": "en",
          "_id": "5783c5580183b1e80fc88265"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2004/03/trix/rdfg-1/",
      "prefix": "rdfg",
      "uri": "http://www.w3.org/2004/03/trix/rdfg-1/",
      "titles": [
        {
          "value": "Graph",
          "lang": "en",
          "_id": "561e530942fc695f7e67719d"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/rdfp/",
      "prefix": "rdfp",
      "uri": "https://w3id.org/rdfp/",
      "titles": [
        {
          "value": "The RDF Presentation ontology",
          "lang": "en",
          "_id": "580e19837ada88436788895f"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2000/01/rdf-schema#",
      "prefix": "rdfs",
      "uri": "http://www.w3.org/2000/01/rdf-schema#",
      "titles": [
        {
          "value": "The RDF Schema vocabulary",
          "lang": "en",
          "_id": "58ec88bbabe2639e2c3bd8d4"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/rdftest",
      "nsp": "http://www.w3.org/ns/rdftest#",
      "prefix": "rdft",
      "titles": [
        {
          "value": "The RDF 1.1 Test Vocabulary",
          "lang": "en",
          "_id": "60f444cb974824e9140ad42f"
        }
      ]
    },
    {
      "uri": "https://w3id.org/react",
      "nsp": "https://w3id.org/react#",
      "prefix": "react",
      "titles": [
        {
          "value": "The REACT Ontology",
          "lang": "en",
          "_id": "63247215f0004aba7af3f788"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/rec/core#",
      "prefix": "rec",
      "uri": "http://purl.org/ontology/rec/core#",
      "titles": [
        {
          "value": "Recommendation Ontology",
          "lang": "en",
          "_id": "55e057ca419d00687563ad55"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2001/02pd/rec54#",
      "prefix": "rec54",
      "uri": "http://www.w3.org/2001/02pd/rec54#",
      "titles": [
        {
          "value": "Model of the W3C Process",
          "lang": "en",
          "_id": "55e05b85419d00687563ad9c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/reco#",
      "prefix": "reco",
      "uri": "http://purl.org/reco#",
      "titles": [
        {
          "value": "RECommendations Ontology",
          "lang": "en",
          "_id": "57d2ce7aa3a9d3a63d7e8b24"
        }
      ]
    },
    {
      "nsp": "http://reegle.info/schema#",
      "prefix": "reegle",
      "uri": "http://reegle.info/schema",
      "titles": [
        {
          "value": "Renewable Energy and Energy Efficiency",
          "lang": "en",
          "_id": "5accd09b3aba5caf50dbeda7"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/relationship/",
      "prefix": "rel",
      "uri": "http://purl.org/vocab/relationship/",
      "titles": [
        {
          "value": "Relationship",
          "lang": "en",
          "_id": "583a0a49cd0ed0472763e14f"
        }
      ]
    },
    {
      "nsp": "http://www.purl.org/net/remetca#",
      "prefix": "remetca",
      "uri": "http://www.purl.org/net/remetca#",
      "titles": [
        {
          "value": "ReMetCa Ontology",
          "lang": "en",
          "_id": "56ae4f1698f0192c57ea0281"
        }
      ]
    },
    {
      "nsp": "http://purl.org/stuff/rev#",
      "prefix": "rev",
      "uri": "http://purl.org/stuff/rev#",
      "titles": [
        {
          "value": "Review Vocabulary",
          "lang": "en",
          "_id": "555d0af330f688c94e82364a"
        }
      ]
    },
    {
      "uri": "https://www.ica.org/standards/RiC/ontology",
      "nsp": "https://www.ica.org/standards/RiC/ontology#",
      "prefix": "rico",
      "titles": [
        {
          "value": "International Council on Archives Records in Contexts Ontology (ICA RiC-O)",
          "lang": "en",
          "_id": "6054dfddc98d09ac1b967480"
        }
      ]
    },
    {
      "nsp": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#",
      "prefix": "rlog",
      "uri": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#",
      "titles": [
        {
          "value": "RDF Logging Ontology",
          "lang": "en",
          "_id": "569f7971ff8848f96bd205ce"
        }
      ]
    },
    {
      "nsp": "http://purl.org/wf4ever/ro#",
      "prefix": "ro",
      "uri": "http://purl.org/wf4ever/ro",
      "titles": [
        {
          "value": "The Research Object Ontology",
          "lang": "en",
          "_id": "57ad8bb4b00b4b1452a88ada"
        }
      ]
    },
    {
      "uri": "http://w3id.org/roh",
      "nsp": "http://w3id.org/roh#",
      "prefix": "roh",
      "titles": [
        {
          "value": "The ASIO ontology",
          "lang": "en",
          "_id": "632483f0f0004aba7af3f821"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/rooms#",
      "prefix": "rooms",
      "uri": "http://vocab.deri.ie/rooms",
      "titles": [
        {
          "value": "Buildings and Rooms Vocabulary",
          "lang": "en",
          "_id": "5dad880a98c7a8076a14d6bb"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/regorg#",
      "prefix": "rov",
      "uri": "http://www.w3.org/ns/regorg",
      "titles": [
        {
          "value": "Registered Organization Vocabulary",
          "lang": "en",
          "_id": "569ccfb0ff8848f96bd16d03"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/r2rml#",
      "prefix": "rr",
      "uri": "http://www.w3.org/ns/r2rml#",
      "titles": [
        {
          "value": "RDB to RDF Mapping Language Schema",
          "lang": "en",
          "_id": "556dc6f9a866afd621a1ca60"
        }
      ]
    },
    {
      "nsp": "http://softeng.polito.it/rsctx#",
      "prefix": "rsctx",
      "uri": "http://softeng.polito.it/rsctx",
      "titles": [
        {
          "value": "Recommender System Context",
          "lang": "en",
          "_id": "58eca6fcabe2639e2c3bf62f"
        }
      ]
    },
    {
      "nsp": "http://purl.org/rss/1.0/",
      "prefix": "rss",
      "uri": "http://purl.org/rss/1.0",
      "titles": [
        {
          "value": "Vocabulary for Rich Site Summary (RSS) 1.0",
          "lang": "en",
          "_id": "57ad8b79b00b4b1452a88ac5"
        }
      ]
    },
    {
      "uri": "https://w3id.org/rail/topo#",
      "nsp": "https://w3id.org/rail/topo#",
      "prefix": "rto",
      "titles": [
        {
          "value": "Rail Topology Ontology",
          "lang": "en",
          "_id": "60ae317ed50a5fc01d00f4ef"
        }
      ]
    },
    {
      "nsp": "http://purl.org/imbi/ru-meta.owl#",
      "prefix": "ru",
      "uri": "http://purl.org/imbi/ru-meta.owl",
      "titles": [
        {
          "value": "Representational Units Metadata Ontology",
          "lang": "en",
          "_id": "59dce1ee2febc4a21c3169a7"
        }
      ]
    },
    {
      "nsp": "http://rdfunit.aksw.org/ns/core#",
      "prefix": "ruto",
      "uri": "http://rdfunit.aksw.org/ns/core#",
      "titles": [
        {
          "value": "Test-Driven Data Debugging Ontology",
          "lang": "en",
          "_id": "56a5176937d8a8044b25d9d9"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/s4ac/v2#",
      "prefix": "s4ac",
      "uri": "http://ns.inria.fr/s4ac/v2",
      "titles": [
        {
          "value": "Social Semantic SPARQL Security For Access Control Ontology",
          "lang": "en",
          "_id": "5cb3149e470a172015caa396"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4agri/",
      "nsp": "https://saref.etsi.org/saref4agri/",
      "prefix": "s4agri",
      "titles": [
        {
          "value": "SAREF extension for Agriculture",
          "lang": "en",
          "_id": "6037b2b6354efffb2a8d4f21"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4bldg/",
      "nsp": "https://saref.etsi.org/saref4bldg/",
      "prefix": "s4bldg",
      "titles": [
        {
          "value": "SAREF extension for building devices",
          "lang": "en",
          "_id": "6037bc87354efffb2a8d4fb8"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4city/",
      "nsp": "https://saref.etsi.org/saref4city/",
      "prefix": "s4city",
      "titles": [
        {
          "value": "SAREF extension for Smart City",
          "lang": "en",
          "_id": "6037c8a9354efffb2a8d5071"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4ehaw/",
      "nsp": "https://saref.etsi.org/saref4ehaw/",
      "prefix": "s4ehaw",
      "titles": [
        {
          "value": "SAREF4EHAW: an extension of SAREF for eHealth Ageing Well domain",
          "lang": "en",
          "_id": "6037c30f354efffb2a8d5017"
        }
      ]
    },
    {
      "nsp": "https://saref.etsi.org/saref4ener/",
      "prefix": "s4ener",
      "uri": "https://saref.etsi.org/saref4ener/",
      "titles": [
        {
          "value": "SAREF4EE: the EEbus/Energy@home extension of SAREF",
          "lang": "en",
          "_id": "6037c3fc354efffb2a8d5022"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4envi/",
      "nsp": "https://saref.etsi.org/saref4envi/",
      "prefix": "s4envi",
      "titles": [
        {
          "value": "SAREF extension for environment",
          "lang": "en",
          "_id": "6037c8f5354efffb2a8d5077"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4inma/",
      "nsp": "https://saref.etsi.org/saref4inma/",
      "prefix": "s4inma",
      "titles": [
        {
          "value": "SAREF4INMA: an extension of SAREF for the industry and manufacturing domain",
          "lang": "en",
          "_id": "6037c01f354efffb2a8d4ff3"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4syst/",
      "nsp": "https://saref.etsi.org/saref4syst/",
      "prefix": "s4syst",
      "titles": [
        {
          "value": "SAREF4SYST: an extension of SAREF for typology of systems and their inter-connections",
          "lang": "en",
          "_id": "6037c540354efffb2a8d5030"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4watr/",
      "nsp": "https://saref.etsi.org/saref4watr/",
      "prefix": "s4watr",
      "titles": [
        {
          "value": "SAREF extension for water",
          "lang": "en",
          "_id": "6037c87d354efffb2a8d506e"
        }
      ]
    },
    {
      "uri": "https://saref.etsi.org/saref4wear/",
      "nsp": "https://saref.etsi.org/saref4wear/",
      "prefix": "s4wear",
      "titles": [
        {
          "value": "SAREF4WEAR: an extension of SAREF for Wearables",
          "lang": "en",
          "_id": "6037c833354efffb2a8d5066"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#",
      "prefix": "sam",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling",
      "titles": [
        {
          "value": "The Sampling Features Schema Vocabulary",
          "lang": "en",
          "_id": "55d737b0e4ac2b1c4c5a52f6"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/ontology/om/sam-lite#",
      "prefix": "samfl",
      "uri": "http://def.seegrid.csiro.au/ontology/om/sam-lite",
      "titles": [
        {
          "value": "OWL for Sampling Features",
          "lang": "en",
          "_id": "56af7fdd98f0192c57ea9a30"
        }
      ]
    },
    {
      "nsp": "http://dati.san.beniculturali.it/SAN/",
      "prefix": "san-lod",
      "uri": "http://dati.san.beniculturali.it/SAN/",
      "titles": [
        {
          "value": "SAN Ontologia",
          "lang": "en",
          "_id": "589998c0d9b1a8a8618f704c"
        }
      ]
    },
    {
      "nsp": "http://salt.semanticauthoring.org/ontologies/sao#",
      "prefix": "sao",
      "uri": "http://salt.semanticauthoring.org/ontologies/sao",
      "titles": [
        {
          "value": "SALT Annotation Ontology",
          "lang": "en",
          "_id": "583a0a1acd0ed0472763e146"
        }
      ]
    },
    {
      "uri": "https://w3id.org/sao",
      "nsp": "https://w3id.org/sao#",
      "prefix": "saont",
      "titles": [
        {
          "value": "The System Accountability Ontology",
          "lang": "en",
          "_id": "627915a4476a20423a95d4c0"
        }
      ]
    },
    {
      "nsp": "https://saref.etsi.org/core/",
      "prefix": "saref",
      "uri": "https://saref.etsi.org/core/",
      "titles": [
        {
          "value": "SAREF: the Smart Appliances REFerence ontology",
          "lang": "en",
          "_id": "6037b211354efffb2a8d4f0d"
        }
      ]
    },
    {
      "nsp": "http://purl.org/saws/ontology#",
      "prefix": "saws",
      "uri": "http://purl.org/saws/ontology",
      "titles": [
        {
          "value": "Sharing Ancient Wisdoms Ontology",
          "lang": "en",
          "_id": "556dc75ca866afd621a1ca65"
        }
      ]
    },
    {
      "uri": "https://w3id.org/sbeo",
      "nsp": "https://w3id.org/sbeo#",
      "prefix": "sbeo",
      "titles": [
        {
          "value": "SBEO: Smart Building Evacuation Ontology",
          "lang": "en",
          "_id": "60361a57ecd40f1919dc8689"
        }
      ]
    },
    {
      "nsp": "http://schema.org/",
      "prefix": "schema",
      "uri": "http://schema.org/",
      "titles": [
        {
          "value": "Schema.org vocabulary",
          "lang": "en",
          "_id": "5e7c8e57b27249284e3513c5"
        }
      ]
    },
    {
      "nsp": "http://lod.taxonconcept.org/ontology/sci_people.owl#",
      "prefix": "scip",
      "uri": "http://lod.taxonconcept.org/ontology/sci_people.owl",
      "titles": [
        {
          "value": "Scientific People Ontology",
          "lang": "en",
          "_id": "56a3c47b37d8a8044b254156"
        }
      ]
    },
    {
      "nsp": "http://purl.org/spar/scoro/",
      "prefix": "scoro",
      "uri": "http://purl.org/spar/scoro/",
      "titles": [
        {
          "value": "Scholarly Contributions and Roles Ontology",
          "lang": "en",
          "_id": "586bab2f7e341093492c489f"
        }
      ]
    },
    {
      "nsp": "http://rdfs.org/scot/ns#",
      "prefix": "scot",
      "uri": "http://rdfs.org/scot/ns#",
      "titles": [
        {
          "value": "Social Semantic Cloud of Tags",
          "lang": "en",
          "_id": "586bd6e07e341093492c5100"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/scovo#",
      "prefix": "scovo",
      "uri": "http://vocab.deri.ie/scovo",
      "titles": [
        {
          "value": "The Statistical Core Vocabulary",
          "lang": "en",
          "_id": "5783c2460183b1e80fc8807f"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/schema-org-csv#",
      "prefix": "scsv",
      "uri": "http://vocab.deri.ie/scsv",
      "titles": [
        {
          "value": "Schema.org CSV",
          "lang": "en",
          "_id": "56a3c4ee37d8a8044b25419c"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/sparql-service-description#",
      "prefix": "sd",
      "uri": "http://www.w3.org/ns/sparql-service-description",
      "titles": [
        {
          "value": "SPARQL 1.1 Service Description",
          "lang": "en",
          "_id": "5adda46c67b67f5811d01cc6"
        }
      ]
    },
    {
      "uri": "https://w3id.org/vocab/sdm",
      "nsp": "https://w3id.org/vocab/sdm#",
      "prefix": "sdm",
      "titles": [
        {
          "value": "SPARQL endpoint metadata",
          "lang": "en",
          "_id": "5f1ac0f8388540d23b85cee3"
        }
      ]
    },
    {
      "nsp": "http://purl.org/linked-data/sdmx#",
      "prefix": "sdmx",
      "uri": "http://purl.org/linked-data/sdmx",
      "titles": [
        {
          "value": "SDMX-RDF vocabulary",
          "lang": "en",
          "_id": "5c0544ba72ce82f646afa0e5"
        }
      ]
    },
    {
      "nsp": "http://purl.org/linked-data/sdmx/2009/code#",
      "prefix": "sdmx-code",
      "uri": "http://purl.org/linked-data/sdmx/2009/code",
      "titles": [
        {
          "value": "SDMX Code",
          "lang": "en",
          "_id": "57696c4f4a73263716312e6e"
        }
      ]
    },
    {
      "nsp": "http://purl.org/linked-data/sdmx/2009/dimension#",
      "prefix": "sdmx-dimension",
      "uri": "http://purl.org/linked-data/sdmx/2009/dimension",
      "titles": [
        {
          "value": "SDMX Dimension",
          "lang": "en",
          "_id": "5783c1ed0183b1e80fc8804c"
        }
      ]
    },
    {
      "nsp": "http://salt.semanticauthoring.org/ontologies/sdo#",
      "prefix": "sdo",
      "uri": "http://salt.semanticauthoring.org/ontologies/sdo",
      "titles": [
        {
          "value": "SALT Document Ontology",
          "lang": "en",
          "_id": "583a0781cd0ed0472763e12b"
        }
      ]
    },
    {
      "uri": "http://www.sealitproject.eu/ontology/",
      "nsp": "http://www.sealitproject.eu/ontology/",
      "prefix": "sealit",
      "titles": [
        {
          "value": "SeaLiT Ontology",
          "lang": "en",
          "_id": "632b431cc4f7e5f619d44488"
        }
      ]
    },
    {
      "nsp": "http://sindice.com/vocab/search#",
      "prefix": "search",
      "uri": "http://vocab.deri.ie/search",
      "titles": [
        {
          "value": "Sindice Search Vocabulary",
          "lang": "en",
          "_id": "55bb5e507459b3975b63c054"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seas",
      "uri": "https://w3id.org/seas/",
      "titles": [
        {
          "value": "SEAS ontology",
          "lang": "en",
          "_id": "584ad2bb8a0d14e34d5efc18"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seas-eval",
      "uri": "https://w3id.org/seas/EvaluationOntology",
      "titles": [
        {
          "value": "The SEAS Evaluation ontology",
          "lang": "en",
          "_id": "585f95207e34109349246cc0"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seas-op",
      "uri": "https://w3id.org/seas/OperatingOntology",
      "titles": [
        {
          "value": "The SEAS Failable System ontology",
          "lang": "en",
          "_id": "584ad3db8a0d14e34d5efc3b"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seas-qudt",
      "uri": "https://w3id.org/seas/QUDTAlignment",
      "titles": [
        {
          "value": "QUDT Alignment.",
          "lang": "en",
          "_id": "584ad4f58a0d14e34d5efc77"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seas-stats",
      "uri": "https://w3id.org/seas/StatisticsOntology",
      "titles": [
        {
          "value": "The SEAS Statistics ontology.",
          "lang": "en",
          "_id": "5873a4437e34109349366a9f"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seas-sys",
      "uri": "https://w3id.org/seas/SystemOntology",
      "titles": [
        {
          "value": "The SEAS System ontology",
          "lang": "en",
          "_id": "584ad1518a0d14e34d5efbec"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seasb",
      "uri": "https://w3id.org/seas/BatteryOntology",
      "titles": [
        {
          "value": "The SEAS Battery ontology.",
          "lang": "en",
          "_id": "59a67dff7845e44d19bf8a67"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seasbo",
      "uri": "https://w3id.org/seas/BuildingOntology",
      "titles": [
        {
          "value": "The SEAS Building Ontology",
          "lang": "en",
          "_id": "59a696887845e44d19bf9b3d"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seasd",
      "uri": "https://w3id.org/seas/DeviceOntology",
      "titles": [
        {
          "value": "The SEAS Device ontology",
          "lang": "en",
          "_id": "59a5a9377845e44d19beda04"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seasfo",
      "uri": "https://w3id.org/seas/ForecastingOntology",
      "titles": [
        {
          "value": "The SEAS Forecasting ontology",
          "lang": "en",
          "_id": "59a6814a7845e44d19bf8bb0"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seast",
      "uri": "https://w3id.org/seas/TimeOntology",
      "titles": [
        {
          "value": "The SEAS Time Ontology.",
          "lang": "en",
          "_id": "59a59ee17845e44d19becf88"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seas/",
      "prefix": "seasto",
      "uri": "https://w3id.org/seas/TradingOntology",
      "titles": [
        {
          "value": "The SEAS Trading ontology",
          "lang": "en",
          "_id": "59a687c27845e44d19bf910f"
        }
      ]
    },
    {
      "nsp": "http://securitytoolbox.appspot.com/securityMain#",
      "prefix": "security",
      "uri": "http://securitytoolbox.appspot.com/securityMain",
      "titles": [
        {
          "value": "Security Ontology",
          "lang": "en",
          "_id": "57ad8aefb00b4b1452a88a9a"
        }
      ]
    },
    {
      "nsp": "http://semanticweb.cs.vu.nl/2009/11/sem/",
      "prefix": "sem",
      "uri": "http://semanticweb.cs.vu.nl/2009/11/sem/",
      "titles": [
        {
          "value": "The SEM Ontology",
          "lang": "en",
          "_id": "583a0b1ccd0ed0472763e15a"
        }
      ]
    },
    {
      "nsp": "http://www.lingvoj.org/semio#",
      "prefix": "semio",
      "uri": "http://www.lingvoj.org/semio.rdf",
      "titles": [
        {
          "value": "Semio, an ontology of signs",
          "lang": "en",
          "_id": "58f9d5536961d74e135adc87"
        }
      ]
    },
    {
      "uri": "http://www.ontologydesignpatterns.org/cp/owl/semiotics.owl",
      "nsp": "http://www.ontologydesignpatterns.org/cp/owl/semiotics.owl#",
      "prefix": "semiotics",
      "titles": [
        {
          "value": "A content ontology pattern that encodes a basic semiotic theory, by reusing the situation pattern.",
          "lang": "en",
          "_id": "60b7ab1c87423a16187e448d"
        }
      ]
    },
    {
      "nsp": "http://purl.org/SemSur/",
      "prefix": "semsur",
      "uri": "http://purl.org/SemSur/",
      "titles": [
        {
          "value": "The Semantic Survey Ontology (semsur)",
          "lang": "en",
          "_id": "5ad9f3ae2e909b214fc361a1"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/seo#",
      "prefix": "seo",
      "uri": "https://w3id.org/seo#",
      "titles": [
        {
          "value": "The Scientific Events Ontology",
          "lang": "en",
          "_id": "61d5a9d8b7d3952f632002de"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#",
      "prefix": "seq",
      "uri": "http://www.ontologydesignpatterns.org/cp/owl/sequence.owl",
      "titles": [
        {
          "value": "Sequence Pattern",
          "lang": "en",
          "_id": "5697b7f9ff8848f96bd12b39"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/service#",
      "prefix": "service",
      "uri": "http://purl.org/ontology/service",
      "titles": [
        {
          "value": "The Service Ontology",
          "lang": "en",
          "_id": "560659578f7ad2ce3438d586"
        }
      ]
    },
    {
      "nsp": "http://www.opengis.net/ont/sf#",
      "prefix": "sf",
      "uri": "http://www.opengis.net/ont/sf",
      "titles": [
        {
          "value": "Simplified Features Geometry",
          "lang": "en",
          "_id": "5697b7c3ff8848f96bd12b1a"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/shacl#",
      "prefix": "sh",
      "uri": "http://www.w3.org/ns/shacl#",
      "titles": [
        {
          "value": "W3C Shapes Constraint Language (SHACL) Vocabulary",
          "lang": "en",
          "_id": "5accce153aba5caf50dbea61"
        }
      ]
    },
    {
      "nsp": "http://dati.cdec.it/lod/shoah/",
      "prefix": "shoah",
      "uri": "http://dati.cdec.it/lod/shoah/",
      "titles": [
        {
          "value": "Shoah Vocabulary Specification",
          "lang": "en",
          "_id": "578d05bb8c6f955d29c02c4e"
        }
      ]
    },
    {
      "nsp": "http://paul.staroch.name/thesis/SmartHomeWeather.owl#",
      "prefix": "shw",
      "uri": "http://paul.staroch.name/thesis/SmartHomeWeather.owl#",
      "titles": [
        {
          "value": "Smart Home Weather",
          "lang": "en",
          "_id": "5809c78f3e5586c53d897083"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/similarity/",
      "prefix": "sim",
      "uri": "http://purl.org/ontology/similarity/",
      "titles": [
        {
          "value": "The Similarity Ontology",
          "lang": "en",
          "_id": "55abbd6857613119099d71aa"
        }
      ]
    },
    {
      "uri": "https://www.w3id.org/simulation/ontology/",
      "nsp": "https://www.w3id.org/simulation/ontology/",
      "prefix": "simu",
      "titles": [
        {
          "value": "Simulation Ontology",
          "lang": "en",
          "_id": "63bd314a231281b8299f9b67"
        }
      ]
    },
    {
      "nsp": "http://semanticscience.org/resource/",
      "prefix": "sio",
      "uri": "http://semanticscience.org/ontology/sio.owl",
      "titles": [
        {
          "value": "Semanticscience Integrated Ontology",
          "lang": "en",
          "_id": "583a0821cd0ed0472763e136"
        }
      ]
    },
    {
      "nsp": "http://rdfs.org/sioc/ns#",
      "prefix": "sioc",
      "uri": "http://rdfs.org/sioc/ns#",
      "titles": [
        {
          "value": "Semantically-Interlinked Online Communities",
          "lang": "en",
          "_id": "5697b70cff8848f96bd12b03"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
      "prefix": "situ",
      "uri": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl",
      "titles": [
        {
          "value": "Situation Pattern",
          "lang": "en",
          "_id": "569ccfdaff8848f96bd16d0e"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2004/02/skos/core#",
      "prefix": "skos",
      "uri": "http://www.w3.org/2004/02/skos/core",
      "titles": [
        {
          "value": "Simple Knowledge Organization System",
          "lang": "en",
          "_id": "58ec8906abe2639e2c3bd91a"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2008/05/skos-xl#",
      "prefix": "skosxl",
      "uri": "http://www.w3.org/2008/05/skos-xl",
      "titles": [
        {
          "value": "SKOS eXtension for Labels",
          "lang": "en",
          "_id": "58ec89a7abe2639e2c3bd9b2"
        }
      ]
    },
    {
      "nsp": "http://ns.cerise-project.nl/energy/def/cim-smartgrid#",
      "prefix": "smg",
      "uri": "http://ns.cerise-project.nl/energy/def/cim-smartgrid",
      "titles": [
        {
          "value": "CERISE CIM Profile for Smart Grids",
          "lang": "en",
          "_id": "569cd063ff8848f96bd16d2a"
        }
      ]
    },
    {
      "nsp": "http://rdf.myexperiment.org/ontologies/snarm/",
      "prefix": "snarm",
      "uri": "http://rdf.myexperiment.org/ontologies/snarm/",
      "titles": [
        {
          "value": "Simple Network Access Rights Management Ontology",
          "lang": "en",
          "_id": "56719d544ee7f7176fe64be0"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/solid/terms",
      "nsp": "http://www.w3.org/ns/solid/terms#",
      "prefix": "solid",
      "titles": [
        {
          "value": "Solid terms",
          "lang": "en",
          "_id": "5cd0359bd18d844f5ff6f650"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/soron/",
      "prefix": "sor",
      "uri": "http://purl.org/net/soron",
      "titles": [
        {
          "value": "SORON: Social Relationships ONtology",
          "lang": "en",
          "_id": "586ba8e47e341093492c47a8"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/sosa/",
      "prefix": "sosa",
      "uri": "http://www.w3.org/ns/sosa/",
      "titles": [
        {
          "value": "Sensor, Observation, Sample, and Actuator (SOSA) Ontology",
          "lang": "en",
          "_id": "58f9bf1e6961d74e135ab569"
        }
      ]
    },
    {
      "nsp": "http://spinrdf.org/sp#",
      "prefix": "sp",
      "uri": "http://spinrdf.org/sp",
      "titles": [
        {
          "value": "SPIN SPARQL Syntax",
          "lang": "en",
          "_id": "57696bf54a73263716312e61"
        }
      ]
    },
    {
      "nsp": "http://geovocab.org/spatial#",
      "prefix": "spatial",
      "uri": "http://geovocab.org/spatial",
      "titles": [
        {
          "value": "NeoGeo Spatial Ontology",
          "lang": "en",
          "_id": "57696c824a73263716312e7b"
        }
      ]
    },
    {
      "nsp": "http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#",
      "prefix": "spcm",
      "uri": "http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0",
      "titles": [
        {
          "value": "Software Process Control Model",
          "lang": "en",
          "_id": "5c4990f39e5c7dfa7bfd1ea7"
        }
      ]
    },
    {
      "nsp": "http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#",
      "prefix": "spfood",
      "uri": "http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl",
      "titles": [
        {
          "value": "SmartProducts Food Domain Model",
          "lang": "en",
          "_id": "59dcdaa72febc4a21c3161e8"
        }
      ]
    },
    {
      "nsp": "http://spinrdf.org/spin#",
      "prefix": "spin",
      "uri": "http://spinrdf.org/spin",
      "titles": [
        {
          "value": "SPIN Inferencing Vocabulary",
          "lang": "en",
          "_id": "568a56af4ee7f7176ff10ec4"
        }
      ]
    },
    {
      "nsp": "http://www.bbc.co.uk/ontologies/sport/",
      "prefix": "sport",
      "uri": "http://www.bbc.co.uk/ontologies/sport",
      "titles": [
        {
          "value": "BBC Sport Ontology",
          "lang": "en",
          "_id": "57e3dbe6812207ab035478ad"
        }
      ]
    },
    {
      "nsp": "http://spitfire-project.eu/ontology/ns/",
      "prefix": "spt",
      "uri": "http://spitfire-project.eu/ontology/ns",
      "titles": [
        {
          "value": "SPITFIRE Ontology",
          "lang": "en",
          "_id": "5809c57c3e5586c53d896e64"
        }
      ]
    },
    {
      "nsp": "https://bmake.th-brandenburg.de/spv#",
      "prefix": "spvqa",
      "uri": "https://bmake.th-brandenburg.de/spv",
      "titles": [
        {
          "value": "Scholarly Papers Vocabulary with Focus on Qualtitative Analysis",
          "lang": "en",
          "_id": "59b80ffb2ab721804e2fcb71"
        }
      ]
    },
    {
      "nsp": "http://ns.inria.fr/ast/sql#",
      "prefix": "sql",
      "uri": "http://ns.inria.fr/ast/sql#",
      "titles": [
        {
          "value": "SQL Abstract Syntax Trees Vocabulary",
          "lang": "en",
          "_id": "58f9d5a66961d74e135adce0"
        }
      ]
    },
    {
      "nsp": "http://salt.semanticauthoring.org/ontologies/sro#",
      "prefix": "sro",
      "uri": "http://salt.semanticauthoring.org/ontologies/sro",
      "titles": [
        {
          "value": "SALT Rhetorical Ontology",
          "lang": "en",
          "_id": "583a04fecd0ed0472763e112"
        }
      ]
    },
    {
      "uri": "https://purl.org/esric/sronto",
      "nsp": "https://purl.org/esric/sronto/",
      "prefix": "sronto",
      "titles": [
        {
          "value": "Space Resources Ontology",
          "lang": "en",
          "_id": "63209843f837e1272cb6ed66"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/ssn/",
      "prefix": "ssn",
      "uri": "http://www.w3.org/ns/ssn/",
      "titles": [
        {
          "value": "Semantic Sensor Network Ontology",
          "lang": "en",
          "_id": "5fd1d248a1a8e88b452ba6da"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/ssn/",
      "prefix": "ssno",
      "uri": "http://www.w3.org/ns/ssn/",
      "titles": [
        {
          "value": "Semantic Sensor Network Ontology",
          "lang": "en",
          "_id": "599d826edaf8c9570d02a6a6"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/ssso#",
      "prefix": "ssso",
      "uri": "http://purl.org/ontology/ssso",
      "titles": [
        {
          "value": "Simple Service Status Ontology",
          "lang": "en",
          "_id": "56a5158637d8a8044b25d8dc"
        }
      ]
    },
    {
      "nsp": "http://semweb.mmlab.be/ns/stoptimes#",
      "prefix": "st",
      "uri": "http://semweb.mmlab.be/ns/stoptimes#Ontology",
      "titles": [
        {
          "value": "The Stop Times ontology",
          "lang": "en",
          "_id": "55f5c184a71142386b7a398d"
        }
      ]
    },
    {
      "nsp": "http://securitytoolbox.appspot.com/stac#",
      "prefix": "stac",
      "uri": "http://securitytoolbox.appspot.com/stac",
      "titles": [
        {
          "value": "Security Toolbox : Attacks and Countermeasures",
          "lang": "en",
          "_id": "5cb30433470a172015caa313"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/step#",
      "prefix": "step",
      "uri": "http://purl.org/net/step",
      "titles": [
        {
          "value": "Semantic Trajectory Episodes",
          "lang": "en",
          "_id": "56938c0261dfb9a05dd2948b"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/i40/sto#",
      "prefix": "sto",
      "uri": "https://w3id.org/i40/sto#",
      "titles": [
        {
          "value": "i40 Standards Lanscape Vocabulary",
          "lang": "en",
          "_id": "59b911622ab721804e310534"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/stories/",
      "prefix": "stories",
      "uri": "http://purl.org/ontology/stories/",
      "titles": [
        {
          "value": "Stories Ontology",
          "lang": "en",
          "_id": "586ba2d17e341093492c474e"
        }
      ]
    },
    {
      "nsp": "http://purl.org/voc/summa/",
      "prefix": "summa",
      "uri": "http://purl.org/voc/summa/",
      "titles": [
        {
          "value": "SUMMA Vocabulary",
          "lang": "en",
          "_id": "57ad84d9b00b4b1452a886be"
        }
      ]
    },
    {
      "uri": "https://www.w3id.org/survey-ontology",
      "nsp": "https://w3id.org/survey-ontology#",
      "prefix": "sur",
      "titles": [
        {
          "value": "The Survey Ontology",
          "lang": "en",
          "_id": "5f1acda1388540d23b85cf30"
        }
      ]
    },
    {
      "uri": "https://w3id.org/squap/",
      "nsp": "https://w3id.org/squap/SoftwareQuality/",
      "prefix": "sw-quality",
      "titles": [
        {
          "value": "SQuAP Ontology",
          "lang": "en",
          "_id": "5d2dcb84cc309974619c5271"
        }
      ]
    },
    {
      "nsp": "http://data.semanticweb.org/ns/swc/ontology#",
      "prefix": "swc",
      "uri": "http://data.semanticweb.org/ns/swc/ontology",
      "titles": [
        {
          "value": "Semantic Web Conference Ontology",
          "lang": "en",
          "_id": "55a0da1b57613119099c1049"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2004/03/trix/swp-1/",
      "prefix": "swp",
      "uri": "http://www.w3.org/2004/03/trix/swp-1",
      "titles": [
        {
          "value": "Graph Authority",
          "lang": "en",
          "_id": "569cc838ff8848f96bd16c58"
        }
      ]
    },
    {
      "nsp": "http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#",
      "prefix": "swpm",
      "uri": "http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0",
      "titles": [
        {
          "value": "Software Work Product Model",
          "lang": "en",
          "_id": "55d733c5e4ac2b1c4c5a5244"
        }
      ]
    },
    {
      "nsp": "http://sw-portal.deri.org/ontologies/swportal#",
      "prefix": "swpo",
      "uri": "http://sw-portal.deri.org/ontologies/swportal",
      "titles": [
        {
          "value": "Semantic Web Portal Ontology",
          "lang": "en",
          "_id": "586ba1657e341093492c4739"
        }
      ]
    },
    {
      "nsp": "http://swrc.ontoware.org/ontology#",
      "prefix": "swrc",
      "uri": "http://swrc.ontoware.org/ontology-07",
      "titles": [
        {
          "value": "Semantic Web for Research Communities",
          "lang": "en",
          "_id": "5ad9dd862e909b214fc3567b"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2003/11/swrl#",
      "prefix": "swrl",
      "uri": "http://www.w3.org/2003/11/swrl",
      "titles": [
        {
          "value": "Semantic Web Rule Language",
          "lang": "en",
          "_id": "576a582b4a73263716316b66"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/lemon/synsem",
      "nsp": "http://www.w3.org/ns/lemon/synsem#",
      "prefix": "synsem",
      "titles": [
        {
          "value": "Lexicon Model for Ontologies - Synsem",
          "lang": "en",
          "_id": "60d071196eec354e1dfe3de2"
        }
      ]
    },
    {
      "nsp": "http://ns.bergnet.org/tac/0.1/triple-access-control#",
      "prefix": "tac",
      "uri": "http://ns.bergnet.org/tac/0.1/triple-access-control",
      "titles": [
        {
          "value": "TripleAccessControl Ontology",
          "lang": "en",
          "_id": "59dce0cd2febc4a21c3168dd"
        }
      ]
    },
    {
      "nsp": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
      "prefix": "tag",
      "uri": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
      "titles": [
        {
          "value": "Tag ontology",
          "lang": "en",
          "_id": "583a0743cd0ed0472763e125"
        }
      ]
    },
    {
      "nsp": "http://vocab.deri.ie/tao#",
      "prefix": "tao",
      "uri": "http://vocab.deri.ie/tao",
      "titles": [
        {
          "value": "Trust Assertion Ontology",
          "lang": "en",
          "_id": "57ad868bb00b4b1452a88830"
        }
      ]
    },
    {
      "uri": "https://w3id.org/EUTaxO",
      "nsp": "https://w3id.org/EUTaxO#",
      "prefix": "tax",
      "titles": [
        {
          "value": "EUTaxO - EUdaphobase Taxonomy Ontology",
          "lang": "en",
          "_id": "638bc8a5e8d209386de14943"
        }
      ]
    },
    {
      "nsp": "http://purl.org/biodiversity/taxon/",
      "prefix": "taxon",
      "uri": "http://purl.org/biodiversity/taxon/",
      "titles": [
        {
          "value": "TaxonMap Ontology",
          "lang": "en",
          "_id": "569172ffb7cea413588f96ef"
        }
      ]
    },
    {
      "uri": "http://taxref.mnhn.fr/lod/taxref-ld",
      "nsp": "http://taxref.mnhn.fr/lod/",
      "prefix": "taxre-ld",
      "titles": [
        {
          "value": "TAXREF-LD Ontology",
          "lang": "en",
          "_id": "63171127b813c51c1e077157"
        }
      ]
    },
    {
      "uri": "https://w3id.org/timebank",
      "nsp": "https://w3id.org/timebank#",
      "prefix": "tb",
      "titles": [
        {
          "value": "Timebank Ontology",
          "lang": "en",
          "_id": "5e988ba37172d55b4fddfe1c"
        }
      ]
    },
    {
      "uri": "https://www.w3.org/2019/wot/td",
      "nsp": "https://www.w3.org/2019/wot/td#",
      "prefix": "td",
      "titles": [
        {
          "value": "Thing Description Ontology",
          "lang": "en",
          "_id": "5ed4d2bec7d84a2a049e4236"
        }
      ]
    },
    {
      "uri": "https://w3id.org/todo/tododfa",
      "nsp": "https://w3id.org/todo/tododfa#",
      "prefix": "tddfa",
      "titles": [
        {
          "value": "TODODFA: Frame-Action Module for Task-Oriented Dialogue management Ontology (TODO)",
          "lang": "en",
          "_id": "61a4d530bf34bcf5590f03d7"
        }
      ]
    },
    {
      "uri": "https://w3id.org/todo/tododial",
      "nsp": "https://w3id.org/todo/tododial#",
      "prefix": "tddial",
      "titles": [
        {
          "value": "TODODial: Dialogue Module for Task-Oriented Dialogue management Ontology (TODO)",
          "lang": "en",
          "_id": "61a3d620bf34bcf5590f011c"
        }
      ]
    },
    {
      "uri": "https://w3id.org/todo/tododm",
      "nsp": "https://w3id.org/todo/tododm#",
      "prefix": "tddm",
      "titles": [
        {
          "value": "TODODM: Dialogue Management Module for Task-Oriented Dialogue management Ontology (TODO)",
          "lang": "en",
          "_id": "61a4d1bebf34bcf5590f039e"
        }
      ]
    },
    {
      "uri": "https://w3id.org/todo/tododom",
      "nsp": "https://w3id.org/todo/tododom#",
      "prefix": "tddom",
      "titles": [
        {
          "value": "TODODom: Domain Module for Task-Oriented Dialogue management Ontology (TODO)",
          "lang": "en",
          "_id": "61a2b4a6dd8a986a3bc45a62"
        }
      ]
    },
    {
      "uri": "https://w3id.org/todo/tododt",
      "nsp": "https://w3id.org/todo/tododt#",
      "prefix": "tddt",
      "titles": [
        {
          "value": "TODODT: Dialogue Tracing Module for Task-Oriented Dialogue management Ontology (TODO)",
          "lang": "en",
          "_id": "61a4d4abbf34bcf5590f03d0"
        }
      ]
    },
    {
      "uri": "https://w3id.org/todo/tododw",
      "nsp": "https://w3id.org/todo/tododw#",
      "prefix": "tddw",
      "titles": [
        {
          "value": "TODODW: World Module for Task-Oriented Dialogue management Ontology (TODO)",
          "lang": "en",
          "_id": "61a4d3c9bf34bcf5590f03c8"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2006/time-entry#",
      "prefix": "te",
      "uri": "http://www.w3.org/2006/time-entry",
      "titles": [
        {
          "value": "Time Entry",
          "lang": "en",
          "_id": "5697b642ff8848f96bd12af5"
        }
      ]
    },
    {
      "nsp": "http://linkedscience.org/teach/ns#",
      "prefix": "teach",
      "uri": "http://linkedscience.org/teach/ns#",
      "titles": [
        {
          "value": "Teaching Core Vocabulary Specification",
          "lang": "en",
          "_id": "58f9d4ae6961d74e135adbe2"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2006/03/test-description#",
      "prefix": "test",
      "uri": "http://www.w3.org/2006/03/test-description",
      "titles": [
        {
          "value": "Test Metadata",
          "lang": "en",
          "_id": "586ba1cc7e341093492c4741"
        }
      ]
    },
    {
      "uri": "https://privatealpha.com/ontology/transformation/1#",
      "nsp": "https://privatealpha.com/ontology/transformation/1#",
      "prefix": "tfo",
      "titles": [
        {
          "value": "Transformation Functions Ontology",
          "lang": "en",
          "_id": "5eb43ca654a440f80a33027c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/theatre#",
      "prefix": "theatre",
      "uri": "http://purl.org/theatre#",
      "titles": [
        {
          "value": "Theatre Ontology",
          "lang": "en",
          "_id": "57f681fb812207ab03623440"
        }
      ]
    },
    {
      "nsp": "http://resource.geosciml.org/ontology/timescale/thors#",
      "prefix": "thors",
      "uri": "http://resource.geosciml.org/ontology/timescale/thors",
      "titles": [
        {
          "value": "The Temporal Ordinal Reference Systems",
          "lang": "en",
          "_id": "598add7888adb933350f5bc4"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#",
      "prefix": "ti",
      "uri": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl",
      "titles": [
        {
          "value": "The Time Interval Pattern",
          "lang": "en",
          "_id": "569ccffeff8848f96bd16d17"
        }
      ]
    },
    {
      "uri": "https://w3id.org/tree",
      "nsp": "https://w3id.org/tree#",
      "prefix": "tiles",
      "titles": [
        {
          "value": "TREE Ontology",
          "lang": "en",
          "_id": "63174cadb813c51c1e07741f"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2006/time#",
      "prefix": "time",
      "uri": "http://www.w3.org/2006/time",
      "titles": [
        {
          "value": "Time Ontology",
          "lang": "en",
          "_id": "598c0ea188adb93335127354"
        }
      ]
    },
    {
      "nsp": "http://purl.org/tio/ns#",
      "prefix": "tio",
      "uri": "http://purl.org/tio/ns#",
      "titles": [
        {
          "value": "The Tickets Ontology",
          "lang": "en",
          "_id": "59dcda262febc4a21c31617c"
        }
      ]
    },
    {
      "nsp": "http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl",
      "prefix": "tis",
      "uri": "http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl",
      "titles": [
        {
          "value": "Time Indexed Situation",
          "lang": "en",
          "_id": "569cd01dff8848f96bd16d21"
        }
      ]
    },
    {
      "nsp": "http://observedchange.com/tisc/ns#",
      "prefix": "tisc",
      "uri": "http://www.observedchange.com/tisc/ns#",
      "titles": [
        {
          "value": "Open Time and Space Core Vocabulary",
          "lang": "en",
          "_id": "55bca8777459b3975b63caa8"
        }
      ]
    },
    {
      "nsp": "http://purl.org/NET/c4dm/timeline.owl#",
      "prefix": "tl",
      "uri": "http://purl.org/NET/c4dm/timeline.owl",
      "titles": [
        {
          "value": "The Timeline Ontology",
          "lang": "en",
          "_id": "586b9f487e341093492c4720"
        }
      ]
    },
    {
      "nsp": "http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#",
      "prefix": "tm",
      "uri": "http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal",
      "titles": [
        {
          "value": "A vocabulary for temporal objects in Geographic Information",
          "lang": "en",
          "_id": "59dcdf6f2febc4a21c316714"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2001/sw/hcls/ns/transmed/",
      "prefix": "tmo",
      "uri": "http://www.w3.org/2001/sw/hcls/ns/transmed/",
      "titles": [
        {
          "value": "Translational Medicine Ontology",
          "lang": "en",
          "_id": "57f74b8b812207ab0362dd0c"
        }
      ]
    },
    {
      "uri": "http://purl.org/toco/",
      "nsp": "http://purl.org/toco/",
      "prefix": "toco",
      "titles": [
        {
          "value": "Toucan Ontology",
          "lang": "en",
          "_id": "5d11bcf4d3a37d851dfc47f7"
        }
      ]
    },
    {
      "uri": "https://w3id.org/todo",
      "nsp": "https://w3id.org/todo#",
      "prefix": "todo",
      "titles": [
        {
          "value": "TODO: Task-Oriented Dialogue management Ontology",
          "lang": "en",
          "_id": "61a4d015bf34bcf5590f038c"
        }
      ]
    },
    {
      "nsp": "http://data.ign.fr/def/topo#",
      "prefix": "topo",
      "uri": "http://data.ign.fr/def/topo",
      "titles": [
        {
          "value": "Ontologie des éléments du territoire et de ses infrastructures de l'IGN",
          "lang": "fr",
          "_id": "58ec8846abe2639e2c3bd870"
        },
        {
          "value": "An ontology for describing territory elements an infrastructure at French Mapping Agency.",
          "lang": "en",
          "_id": "58ec8846abe2639e2c3bd86f"
        }
      ]
    },
    {
      "nsp": "http://tour-pedia.org/download/tp.owl#",
      "prefix": "tp",
      "uri": "http://tour-pedia.org/download/tp.owl",
      "titles": [
        {
          "value": "Tourpedia Ontology",
          "lang": "en",
          "_id": "5992066e605c58c744d4fea0"
        }
      ]
    },
    {
      "nsp": "http://www.sensormeasurement.appspot.com/ont/transport/traffic#",
      "prefix": "traffic",
      "uri": "http://www.sensormeasurement.appspot.com/ont/transport/traffic",
      "titles": [
        {
          "value": "Road Traffic Management",
          "lang": "en",
          "_id": "5783c5a60183b1e80fc88296"
        }
      ]
    },
    {
      "nsp": "http://contextus.net/ontology/ontomedia/ext/common/trait#",
      "prefix": "trait",
      "uri": "http://contextus.net/ontology/ontomedia/ext/common/trait#",
      "titles": [
        {
          "value": "OntoMedia Trait Representation",
          "lang": "en",
          "_id": "57f609ac812207ab0361ce3a"
        }
      ]
    },
    {
      "nsp": "http://vocab.org/transit/terms/",
      "prefix": "transit",
      "uri": "http://vocab.org/transit/terms/",
      "titles": [
        {
          "value": "TRANSIT",
          "lang": "en",
          "_id": "5b3a04d96c71ef466168a4f8"
        }
      ]
    },
    {
      "nsp": "http://linkeddata.finki.ukim.mk/lod/ontology/tao#",
      "prefix": "trao",
      "uri": "http://linkeddata.finki.ukim.mk/lod/ontology/tao#",
      "titles": [
        {
          "value": "Transport Administration Ontology",
          "lang": "en",
          "_id": "57d27a5da3a9d3a63d7e647f"
        }
      ]
    },
    {
      "nsp": "http://rdfs.org/sioc/types#",
      "prefix": "tsioc",
      "uri": "http://rdfs.org/sioc/types#",
      "titles": [
        {
          "value": "SIOC Types Ontology Module",
          "lang": "en",
          "_id": "578d00ed8c6f955d29c02b7e"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/tsn#",
      "prefix": "tsn",
      "uri": "http://purl.org/net/tsn#",
      "titles": [
        {
          "value": "Territorial Statistical Nomenclature Ontology",
          "lang": "en",
          "_id": "5a328179ece6c50213e94130"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/tsnchange#",
      "prefix": "tsnc",
      "uri": "http://purl.org/net/tsnchange#",
      "titles": [
        {
          "value": "Territorial Statistical Nomenclature Change Ontology",
          "lang": "en",
          "_id": "5a3284e9ece6c50213e94506"
        }
      ]
    },
    {
      "nsp": "http://idi.fundacionctic.org/cruzar/turismo#",
      "prefix": "turismo",
      "uri": "http://idi.fundacionctic.org/cruzar/turismo",
      "titles": [
        {
          "value": "Ontología de Turismo para el Ayuntamiento de Zaragoza",
          "lang": "es",
          "_id": "568a5da14ee7f7176ff10f1a"
        },
        {
          "value": "Ontology of Tourist for Saragossa town hall.",
          "lang": "en",
          "_id": "568a5da14ee7f7176ff10f19"
        }
      ]
    },
    {
      "nsp": "http://www.essepuntato.it/2012/04/tvc/",
      "prefix": "tvc",
      "uri": "http://www.essepuntato.it/2012/04/tvc",
      "titles": [
        {
          "value": "The Time-indexed Value in Context",
          "lang": "en",
          "_id": "569cc885ff8848f96bd16c61"
        }
      ]
    },
    {
      "nsp": "http://lod.taxonconcept.org/ontology/txn.owl#",
      "prefix": "txn",
      "uri": "http://lod.taxonconcept.org/ontology/txn.owl",
      "titles": [
        {
          "value": "TaxonConcept Ontology",
          "lang": "en",
          "_id": "6317121cb813c51c1e07715d"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2006/timezone#",
      "prefix": "tzont",
      "uri": "http://www.w3.org/2006/timezone",
      "titles": [
        {
          "value": "Time Zone Ontology",
          "lang": "en",
          "_id": "578369fc0183b1e80fc875d7"
        }
      ]
    },
    {
      "nsp": "http://purl.org/olia/ubyCat.owl#",
      "prefix": "uby",
      "uri": "http://purl.org/olia/ubyCat.owl",
      "titles": [
        {
          "value": "ubyCat.owl",
          "lang": "en",
          "_id": "5610edb3bbf00b4b0783ceb9"
        }
      ]
    },
    {
      "nsp": "http://purl.org/uco/ns#",
      "prefix": "uco",
      "uri": "http://purl.org/uco/ns#",
      "titles": [
        {
          "value": "Used Cars Ontology",
          "lang": "en",
          "_id": "56ae4d8398f0192c57ea0268"
        }
      ]
    },
    {
      "nsp": "http://purl.oclc.org/NET/muo/ucum/",
      "prefix": "ucum",
      "uri": "http://purl.oclc.org/NET/muo/ucum/",
      "titles": [
        {
          "value": "Units of measurement ontology",
          "lang": "en",
          "_id": "57b7130ea3a9d3a63d7709f2"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/ns/ui#",
      "prefix": "ui",
      "uri": "http://www.w3.org/ns/ui",
      "titles": [
        {
          "value": "A user interface ontology",
          "lang": "en",
          "_id": "5ff6f98961a499a258e9ac45"
        }
      ]
    },
    {
      "uri": "http://www.w3id.org/urban-iot/core",
      "nsp": "http://www.w3id.org/urban-iot/core#",
      "prefix": "uiot",
      "titles": [
        {
          "value": "Urban IoT Ontologies - Core Module",
          "lang": "en",
          "_id": "5fc762711e22675e2a3b3231"
        },
        {
          "value": "Ontologie per gli Apparati IoT Urbani - Modulo Core",
          "lang": "it",
          "_id": "5fc762711e22675e2a3b3230"
        }
      ]
    },
    {
      "uri": "http://www.w3id.org/urban-iot/electric",
      "nsp": "http://www.w3id.org/urban-iot/electric#",
      "prefix": "uiote",
      "titles": [
        {
          "value": "Ontologie per gli Apparati IoT Urbani - Modulo Electric Mobility",
          "lang": "it",
          "_id": "5fae610e9ba0235c2e0f2192"
        },
        {
          "value": "Urban IoT Ontologies - Electric Mobility Module",
          "lang": "en",
          "_id": "5fae610e9ba0235c2e0f2191"
        }
      ]
    },
    {
      "uri": "http://www.w3id.org/urban-iot/sharing",
      "nsp": "http://www.w3id.org/urban-iot/sharing#",
      "prefix": "uiots",
      "titles": [
        {
          "value": "Ontologie per gli Apparati IoT Urbani - Modulo Sharing Mobility",
          "lang": "it",
          "_id": "5fb39488b79f57e927b87705"
        },
        {
          "value": "Urban IoT Ontologies - Sharing Mobility Module",
          "lang": "en",
          "_id": "5fb39488b79f57e927b87704"
        }
      ]
    },
    {
      "nsp": "http://umbel.org/umbel#",
      "prefix": "umbel",
      "uri": "http://umbel.org/umbel",
      "titles": [
        {
          "value": "Upper Mapping and Binding Exchange Layer",
          "lang": "en",
          "_id": "5f2bcd63f1a48001181ad3e5"
        }
      ]
    },
    {
      "nsp": "http://purl.org/umu/uneskos#",
      "prefix": "uneskos",
      "uri": "http://purl.org/umu/uneskos",
      "titles": [
        {
          "value": "UNESKOS Vocabulary",
          "lang": "en",
          "_id": "5610f0b4bbf00b4b0783cece"
        }
      ]
    },
    {
      "nsp": "http://purl.uniprot.org/core/",
      "prefix": "uniprot",
      "uri": "http://purl.uniprot.org/core/",
      "titles": [
        {
          "value": "Uniprot Core Ontology",
          "lang": "en",
          "_id": "578367430183b1e80fc874bf"
        }
      ]
    },
    {
      "nsp": "http://uri4uri.net/vocab#",
      "prefix": "uri4uri",
      "uri": "http://uri4uri.net/vocab",
      "titles": [
        {
          "value": "URI Vocabulary",
          "lang": "en",
          "_id": "578364fa0183b1e80fc873ec"
        }
      ]
    },
    {
      "uri": "https://w3id.org/usability",
      "nsp": "https://w3id.org/usability#",
      "prefix": "usability",
      "titles": [
        {
          "value": "Usability",
          "lang": "en",
          "_id": "5cee546f29b3ea805fb470fc"
        },
        {
          "value": "Удобство использования",
          "lang": "ru",
          "_id": "5cee546f29b3ea805fb470fb"
        }
      ]
    },
    {
      "nsp": "http://code-research.eu/ontology/visual-analytics#",
      "prefix": "va",
      "uri": "http://code-research.eu/ontology/visual-analytics",
      "titles": [
        {
          "value": "The Visual Analytics Vocabulary",
          "lang": "en",
          "_id": "578d04a68c6f955d29c02c36"
        }
      ]
    },
    {
      "nsp": "http://www.linkedmodel.org/schema/vaem#",
      "prefix": "vaem",
      "uri": "http://www.linkedmodel.org/schema/vaem",
      "titles": [
        {
          "value": "Vocabulary for Attaching Essential Metadata",
          "lang": "en",
          "_id": "591c84cc6eb19eef1936dbb8"
        }
      ]
    },
    {
      "nsp": "http://www.essepuntato.it/2013/10/vagueness/",
      "prefix": "vag",
      "uri": "http://www.essepuntato.it/2013/10/vagueness",
      "titles": [
        {
          "value": "The Vagueness Ontology",
          "lang": "en",
          "_id": "57f608c4812207ab0361cd6f"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocab/vann/",
      "prefix": "vann",
      "uri": "http://purl.org/vocab/vann/",
      "titles": [
        {
          "value": "VANN: A vocabulary for annotating vocabulary descriptions",
          "lang": "en",
          "_id": "584fb3598a0d14e34d5f69fb"
        }
      ]
    },
    {
      "uri": "http://www.w3.org/ns/lemon/vartrans",
      "nsp": "http://www.w3.org/ns/lemon/vartrans#",
      "prefix": "vartrans",
      "titles": [
        {
          "value": "Lexicon Model for Ontologies - Vartrans",
          "lang": "en",
          "_id": "60d06e73bbbd68b91c5f024f"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2006/vcard/ns#",
      "prefix": "vcard",
      "uri": "http://www.w3.org/2006/vcard/ns",
      "titles": [
        {
          "value": "An Ontology for vCards",
          "lang": "en",
          "_id": "577f5d8e0183b1e80fc720b2"
        }
      ]
    },
    {
      "nsp": "http://data.lirmm.fr/ontologies/vdpp#",
      "prefix": "vdpp",
      "uri": "http://data.lirmm.fr/ontologies/vdpp",
      "titles": [
        {
          "value": "Vocabulary for Dataset Publication Projects",
          "lang": "en",
          "_id": "557f47ef1d5237e823d24ef6"
        }
      ]
    },
    {
      "nsp": "http://linkeddata.finki.ukim.mk/lod/ontology/veo#",
      "prefix": "veo",
      "uri": "http://linkeddata.finki.ukim.mk/lod/ontology/veo#",
      "titles": [
        {
          "value": "Vehicle Emissions Ontology",
          "lang": "en",
          "_id": "57d28866a3a9d3a63d7e6aed"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/VideoGameOntology#",
      "prefix": "vgo",
      "uri": "http://purl.org/net/VideoGameOntology",
      "titles": [
        {
          "value": "The Video Game Ontology",
          "lang": "en",
          "_id": "586a4b537e341093492b8c01"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#",
      "prefix": "vin",
      "uri": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine",
      "titles": [
        {
          "value": "Wine Ontology",
          "lang": "en",
          "_id": "568be88c4ee7f7176ff1250f"
        }
      ]
    },
    {
      "uri": "http://w3id.org/vir#",
      "nsp": "http://w3id.org/vir#",
      "prefix": "vir",
      "titles": [
        {
          "value": "VIR - Visual Representation ontology",
          "lang": "en",
          "_id": "5cee5930086e18b660657b58"
        }
      ]
    },
    {
      "nsp": "http://vivoweb.org/ontology/core#",
      "prefix": "vivo",
      "uri": "http://vivoweb.org/ontology/core",
      "titles": [
        {
          "value": "VIVO Core Ontology",
          "lang": "en",
          "_id": "58e63a03f6baaa6b1ab42a4b"
        }
      ]
    },
    {
      "nsp": "http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#",
      "prefix": "vmm",
      "uri": "http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0",
      "titles": [
        {
          "value": "Visual Modeling tool Model",
          "lang": "en",
          "_id": "55d73529e4ac2b1c4c5a5281"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vocommons/voaf#",
      "prefix": "voaf",
      "uri": "http://purl.org/vocommons/voaf",
      "titles": [
        {
          "value": "Vocabulary of a Friend",
          "lang": "en",
          "_id": "577f5d160183b1e80fc72088"
        }
      ]
    },
    {
      "nsp": "http://voag.linkedmodel.org/voag#",
      "prefix": "voag",
      "uri": "http://voag.linkedmodel.org/schema/voag",
      "titles": [
        {
          "value": "Vocabulary Of Attribution and Governance",
          "lang": "en",
          "_id": "5feb4051ba82ec865987975e"
        }
      ]
    },
    {
      "nsp": "http://w3id.org/rsp/vocals#",
      "prefix": "vocals",
      "uri": "http://w3id.org/rsp/vocals#",
      "titles": [
        {
          "value": "VoCaLS: A Vocabulary and Catalog for Linked Streams",
          "lang": "en",
          "_id": "5ae77bd03b60c4c82ec0ef08"
        },
        {
          "value": "VoCaLS: ontologie de representation de données et metadonnées de streams",
          "lang": "fr",
          "_id": "5ae77bd03b60c4c82ec0ef07"
        }
      ]
    },
    {
      "nsp": "http://rdfs.org/ns/void#",
      "prefix": "void",
      "uri": "http://vocab.deri.ie/void",
      "titles": [
        {
          "value": "Vocabulary of Interlinked Datasets",
          "lang": "en",
          "_id": "58e63961f6baaa6b1ab42998"
        }
      ]
    },
    {
      "uri": "http://purl.org/query/voidext",
      "nsp": "http://purl.org/query/voidext#",
      "prefix": "voidext",
      "titles": [
        {
          "value": "Extended Vocabulary of Interlinked Datasets (VoIDext)",
          "lang": "en",
          "_id": "5ddcda497ec5516d2b0ae026"
        }
      ]
    },
    {
      "nsp": "http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl",
      "prefix": "voidwh",
      "uri": "http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl",
      "titles": [
        {
          "value": "Void Warehouse Ontology",
          "lang": "en",
          "_id": "5696a42dff8848f96bd11d54"
        }
      ]
    },
    {
      "nsp": "http://simile.mit.edu/2003/10/ontologies/vraCore3#",
      "prefix": "vra",
      "uri": "http://simile.mit.edu/2003/10/ontologies/vraCore3#",
      "titles": [
        {
          "value": "RDFS Ontology for VRA",
          "lang": "en",
          "_id": "568a52b14ee7f7176ff10e94"
        }
      ]
    },
    {
      "nsp": "http://purl.org/voc/vrank#",
      "prefix": "vrank",
      "uri": "http://vocab.sti2.at/vrank",
      "titles": [
        {
          "value": "Vocabulary for Ranking",
          "lang": "en",
          "_id": "586a47fc7e341093492b8804"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
      "prefix": "vs",
      "uri": "http://www.w3.org/2003/06/sw-vocab-status/ns",
      "titles": [
        {
          "value": "SemWeb Vocab Status ontology",
          "lang": "en",
          "_id": "55d72d4ce4ac2b1c4c5a513c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vsearch/",
      "prefix": "vsearch",
      "uri": "http://purl.org/vsearch/",
      "titles": [
        {
          "value": "vSearch Vocabulary",
          "lang": "en",
          "_id": "5a2515123d405e60384eb2bc"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vso/ns#",
      "prefix": "vso",
      "uri": "http://purl.org/vso/ns",
      "titles": [
        {
          "value": "Vehicle Sales Ontology",
          "lang": "en",
          "_id": "59dcdf972febc4a21c316731"
        }
      ]
    },
    {
      "nsp": "http://purl.org/vvo/ns#",
      "prefix": "vvo",
      "uri": "http://purl.org/vvo/ns#",
      "titles": [
        {
          "value": "Volkswagen Vehicles Ontology",
          "lang": "en",
          "_id": "59a697e77845e44d19bf9b45"
        }
      ]
    },
    {
      "nsp": "https://www.w3.org/ns/ssn/",
      "prefix": "w3c-ssn",
      "uri": "https://www.w3.org/ns/ssn",
      "titles": [
        {
          "value": "Semantic Sensor Network Ontology",
          "lang": "en",
          "_id": "58481b778a0d14e34d5eb3bd"
        }
      ]
    },
    {
      "nsp": "http://purl.org/wai#",
      "prefix": "wai",
      "uri": "http://purl.org/wai#",
      "titles": [
        {
          "value": "Roles and Profiles Ontology",
          "lang": "en",
          "_id": "568bea2b4ee7f7176ff1253e"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2007/05/powder-s#",
      "prefix": "wdrs",
      "uri": "http://www.w3.org/2007/05/powder-s",
      "titles": [
        {
          "value": "Protocol for Web Description Resources",
          "lang": "en",
          "_id": "59dce0912febc4a21c3168b0"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/wf-invocation#",
      "prefix": "wf-invoc",
      "uri": "http://purl.org/net/wf-invocation",
      "titles": [
        {
          "value": "Workflow Invocation Ontology",
          "lang": "en",
          "_id": "586a48517e341093492b887c"
        }
      ]
    },
    {
      "nsp": "http://purl.org/wf4ever/wfdesc#",
      "prefix": "wfdesc",
      "uri": "http://purl.org/wf4ever/wfdesc",
      "titles": [
        {
          "value": "The Wfdesc ontology",
          "lang": "en",
          "_id": "56c599af2ba77c902f475671"
        }
      ]
    },
    {
      "nsp": "http://purl.org/net/wf-motifs#",
      "prefix": "wfm",
      "uri": "http://purl.org/net/wf-motifs",
      "titles": [
        {
          "value": "The Workflow Motif Ontology",
          "lang": "en",
          "_id": "5696a478ff8848f96bd11d58"
        }
      ]
    },
    {
      "nsp": "http://purl.org/wf4ever/wfprov#",
      "prefix": "wfprov",
      "uri": "http://purl.org/wf4ever/wfprov",
      "titles": [
        {
          "value": "The Wfprov Ontology",
          "lang": "en",
          "_id": "57ad898db00b4b1452a8896f"
        }
      ]
    },
    {
      "nsp": "http://vocab.org/whisky/terms/",
      "prefix": "whisky",
      "uri": "http://vocab.org/whisky/terms",
      "titles": [
        {
          "value": "Whisky Ontology",
          "lang": "en",
          "_id": "576a432e4a732637163164cc"
        }
      ]
    },
    {
      "nsp": "http://www.kanzaki.com/ns/whois#",
      "prefix": "whois",
      "uri": "http://www.kanzaki.com/ns/whois",
      "titles": [
        {
          "value": "Who's who description vocabulary",
          "lang": "en",
          "_id": "57ad888bb00b4b1452a888db"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/wi/core#",
      "prefix": "wi",
      "uri": "http://purl.org/ontology/wi/core#",
      "titles": [
        {
          "value": "The Weighted Interests Vocabulary",
          "lang": "en",
          "_id": "599d8f6ddaf8c9570d02ba2f"
        }
      ]
    },
    {
      "uri": "http://wikiba.se/ontology",
      "nsp": "http://wikiba.se/ontology#",
      "prefix": "wikibase",
      "titles": [
        {
          "value": "Wikibase system ontology",
          "lang": "en",
          "_id": "61acb6907fca4e68358b44c6"
        }
      ]
    },
    {
      "nsp": "http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#",
      "prefix": "wikim",
      "uri": "http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0",
      "titles": [
        {
          "value": "WIKI tool Model",
          "lang": "en",
          "_id": "586a45de7e341093492b84fc"
        }
      ]
    },
    {
      "nsp": "http://www.wsmo.org/ns/wsmo-lite#",
      "prefix": "wl",
      "uri": "http://www.wsmo.org/ns/wsmo-lite#",
      "titles": [
        {
          "value": "WSMO-Lite Ontology",
          "lang": "en",
          "_id": "586a4be87e341093492b8c8a"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/wo/",
      "prefix": "wlo",
      "uri": "http://purl.org/ontology/wo/",
      "titles": [
        {
          "value": "BBC Wildlife Ontology",
          "lang": "en",
          "_id": "586a489d7e341093492b88e4"
        }
      ]
    },
    {
      "nsp": "http://purl.org/ontology/wo/core#",
      "prefix": "wo",
      "uri": "http://purl.org/ontology/wo/core#",
      "titles": [
        {
          "value": "Weighting Ontology",
          "lang": "en",
          "_id": "59dcdfcc2febc4a21c31675e"
        }
      ]
    },
    {
      "nsp": "http://xmlns.com/wot/0.1/",
      "prefix": "wot",
      "uri": "http://xmlns.com/wot/0.1/",
      "titles": [
        {
          "value": "Web Of Trust",
          "lang": "en",
          "_id": "63248491f0004aba7af3f839"
        }
      ]
    },
    {
      "uri": "https://www.w3.org/2019/wot/security#",
      "nsp": "https://www.w3.org/2019/wot/security#",
      "prefix": "wotsec",
      "titles": [
        {
          "value": "Security mechanisms for the Web of Things",
          "lang": "en",
          "_id": "5ed4d5efc7d84a2a049e4244"
        }
      ]
    },
    {
      "nsp": "http://purl.org/xapi/ontology#",
      "prefix": "xapi",
      "uri": "http://purl.org/xapi/ontology#",
      "titles": [
        {
          "value": "xAPI Controlled Vocabulary Ontology",
          "lang": "en",
          "_id": "6324846bf0004aba7af3f834"
        }
      ]
    },
    {
      "nsp": "https://w3id.org/vocab/xbrll#",
      "prefix": "xbrll",
      "uri": "https://w3id.org/vocab/xbrll",
      "titles": [
        {
          "value": "A lightweight XBRL vocabulary",
          "lang": "en",
          "_id": "63171240b813c51c1e077165"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/1999/xhtml/vocab#",
      "prefix": "xhv",
      "uri": "http://www.w3.org/1999/xhtml/vocab",
      "titles": [
        {
          "value": "XHTML Vocabulary",
          "lang": "en",
          "_id": "632483b7f0004aba7af3f817"
        }
      ]
    },
    {
      "nsp": "http://rdf-vocabulary.ddialliance.org/xkos#",
      "prefix": "xkos",
      "uri": "http://rdf-vocabulary.ddialliance.org/xkos",
      "titles": [
        {
          "value": "XKOS",
          "lang": "en",
          "_id": "61a3d84ebf34bcf5590f0137"
        }
      ]
    },
    {
      "nsp": "http://www.w3.org/2001/XMLSchema#",
      "prefix": "xsd",
      "uri": "http://www.w3.org/2001/XMLSchema",
      "titles": [
        {
          "value": "XML Schema",
          "lang": "en",
          "_id": "632cac1bc4f7e5f619d44eed"
        }
      ]
    },
    {
      "uri": "https://yogaontology.org/ontology/",
      "nsp": "https://yogaontology.org/ontology/",
      "prefix": "yoga",
      "titles": [
        {
          "value": "Yoga Ontology",
          "lang": "en",
          "_id": "5f1557107d492f6c11bd06a2"
        }
      ]
    },
    {
      "nsp": "http://zbw.eu/namespaces/zbw-extensions/",
      "prefix": "zbwext",
      "uri": "http://zbw.eu/namespaces/zbw-extensions",
      "titles": [
        {
          "value": "ZBW Extensions",
          "lang": "en",
          "_id": "63248698f0004aba7af3f85b"
        }
      ]
    }
  ]
}